import React, { useRef, useState,useEffect, useLayoutEffect } from "react";
import MiniSideBar from "../../components/mini-sidebar";
import {
  Box,
  Card,
  CardFooter,
  Center,
  Circle,
  Divider,
  Flex,
  Image,
  InputGroup,
  Menu,
  MenuButton,
  Spacer,
  Stack,
  Text,
  Textarea,
  VStack,
  MenuList,
  MenuItem,
  InputRightElement,
  Input,
  Td,
  Tr,
  Step,
  StepIndicator,
  StepTitle,
  StepDescription,
  Stepper,
  StepSeparator,
  UnorderedList,
  ListItem,
  CardBody,
  ToastProvider,
  CheckboxGroup,
  Checkbox,
  RadioGroup,
  Radio,
  Switch,
} from "@chakra-ui/react";
import SecondaryNav from "../../components/seconday-nav";
import PrimaryButton from "../../components/primary-button";
import MiniDropdownInput from "../../components/mini-dropdown";
import GrayCard from "../../components/card";
import SearchBar from "../../components/search-bar";
import TypingLoader from "../../components/typing-loader";
import {COLORS} from "../../components/styles/colors";
import ToggleTab from "../../components/accordion";
import DynamicModal from "../../components/dynamic-modal";
import ModalRight from "../../components/modal-right";
import { Link, NavLink, useLocation } from "react-router-dom";
import useLoader from "../../components/loader/loaderstates";
import Loader from "../../components/loader/loader";
import SimpleTable from "../../components/simple-table";
import moment from "moment";
import { DropdownInput, PrimaryInput, Toaster } from "../../components";
import ReportViewCard from "../../components/report-card";
import FilterButton from "../../components/filter-button";
import { Button } from '@chakra-ui/react';
import { actionAccessMain, downloadDocument, getDob, getgender, getIsDoctor, getLoginID, getusername, handleAlphaDotAndSpace, handleAlphaNumericDotAndSpace, validationOfNumberWithOnly1Decimal } from "../../auth";
import { AddMedicine, DeleteMedicine, EditMedicine, FetchMedicationsData, FetchMyHealthAIData, GetAIMedicineComposition, GetMedicineName } from "../../middleware/services/medications.js";
import { FetchMedicineAIPrompts } from "../../middleware/services/medicines/index.js";
import { FetchTransferMedicineList, uploadImageInProfile } from "../../middleware/services/profile/index.js";
import AiModal from "../../components/ai-modal/index.js";
import MonthYearPicker from "../../components/date-monthyear";
import DropdownInputForVitals from "../../components/dropdown-input-forVitals/index.js";
import { useGPUTranscriber } from "../../components/patient-health/doctor-notes/cheif-complaint-audio/useGPUTranscriber.js";
import { GPUChatAudioManager } from "../../components/patient-health/doctor-notes/cheif-complaint-audio/gpuChatVoiceManager.js";
import { useForm } from "react-hook-form";
import { CorrectChiefComplaintUsingAI, CorrectInstructionsUsingAI, CorrectMedicalTermsUsingAI, FetchMedicineAIAnswer } from "../../middleware/services/visits/aicalls.js";
import { FetchPatientDetails } from "../../middleware/services/messages/index.js";
import DatePicker from "../../components/date-picker/index.js";
import { FetchDoctorsByUser, FetchUsersByClinic } from "../../middleware/services/home/index.js";
import { useHybridTranscriber } from "../../components/patient-health/doctor-notes/cheif-complaint-audio/useHybridTranscriber.js";
import { GPUChatAudioManagerSpeechMode } from "../../components/patient-health/doctor-notes/cheif-complaint-audio/gpuChatVoiceManagerSpeechMode.js";


const MedicationIndex = () => {

    const detailsmodel = React.useRef();
    const showmedicinename = React.useRef();
    const addMedication = React.useRef();
    const editmedications = React.useRef();
    const dynamicModal = React.useRef();
    const learnMoreModal = React.useRef();
    const chatContainerRef = useRef(null);
    const AIChatModel = useRef();

    const { isLoading, showLoader, dismissLoader } = useLoader();
    var [data, setData] = useState(null);
  const { showSuccessToast, showErrorToast } = Toaster();
  const location = useLocation();
  const [patientid, setPatientid] = useState("");
  const [apmtIdUrl, setApmtIdUrl] = useState("");
  const [  boolCheck , setBoolCheck ] = useState(false)
  const [  initialPageLoad , setInitialPageLoad ] = useState(false)
  const [isChecked , setIsChecked] = useState(0)
  const [medicineexpirydate, setMedicineExpiryDate] = useState('');
  var [title, setTitle] = useState();
  const [showhidesearch, ShowHideSearch] = useState(false);

  const [minDateStateEdit , setMinDateStateEdit] = useState('')
  const [maxDateStateEdit , setMaxDateStateEdit] = useState('')
  var [id, setID] = useState();
  const [showAIModal , setShowAIModal] = useState(true)
  const [daysDiffrence, setDaysDiffrence] = useState("")
  const [documentURLForEdit, setDocumentURLForEdit] = useState([]);
  const [showDocNamesDropdown , setShowDocNamesDropdown] = useState(true)
  const [searchValue, setSearchValue] = useState("");
  const [boolValForSuggestions , setBoolValForSuggestions] = useState(true)
  const [suggestions, setSuggestions] = useState({});
  const [treatmentteamdata, setTreatmentTeamData] = useState("");
  const [benifit, setBenifit] = useState('')
  const [sideEffects, setSideEffects] = useState('')


  const [filenameforUpload, setFilenameforUpload] = useState([])
    const [selectedImage, setSelectedImage] = useState(null);
  const today = moment().format("YYYY-MM-DD HH:mm:ss.SSS");
  const [prescribedby, setPrescribedBy] = useState(null);
  const [hospitalname, setHospitalname] = useState(null);
  const [manufacturer, setManufacturer] = useState(null);
  const [instructions, setInstructions] = useState(null);
    const { register, handleSubmit, watch, setValue } = useForm();

  const [isAICorrected, setIsAICorrected] = useState(false);
  const [drugClass, setDrugClass] = useState(null);
  const [therapeutic, setTherapeutic] = useState(null);
  const [medicinename, setMedicineName] = useState("");
  const [Composition, setComposition] = useState("");
  const [medicinedata, setMedicinedata] = useState(null);
  //const [medicineenddata, setMedicineEndDate] = useState('');
  const [dosage, setMedicineDosage] = useState(null);
  const [dosageunit, setMedicineDosageUnit] = useState("mg");
  const [frequency, setMedicineDosageFrequency] = useState("");
  const [morning, setMorning] = useState("0");
  const [afternoon, setAfternoon] = useState("0");
  const [setevening, setEvening] = useState("0");
  const [setnight, setNight] = useState("0");
  const [beforefood, setBeforefood] = useState("0");
  const [afterfood, setAfterfood] = useState("0");
  const [filenameArray, setFilenameArray] = useState([]);


  const [activeTab, setActiveTab] = useState(0);
  const [medicineData, setMedicineData] = useState([])
  const [medicineTypeRadio, setMedicineTypeRadio] = useState("Tablet")
  const [medicinetypeFilter, setMedicineTypeFilter] = useState("All")
  const [medicinetype, setMedicineType] = useState("Tablet");

  const [filteredData, setFilteredData] = useState([]);


  const [aianswers, setAIAnswers] = useState([]);
  const [remainingquestions, setRemainingQuestions] = useState([]);
  const [aiquestion, setAIAnalysis] = useState(null);
  const [AiInput, setAiInput] = useState(null);
  const [initialRender, setInitialRender] = useState(true);
  const [animate, setAnimate] = useState(false);

  const [actionAccessPatients , setActionAccessPatients] = useState(null);
  

   // states of new inputs of medication ---
    const [routeOfAdministration, setRouteOfAdministration] = useState(null);
    const [timing, setTiming] = useState(null);
    const [quantity, setQuantity] = useState(null);
    const [areaOfApplication, setAreaOfApplication] = useState(null);
    const [diluent, setDiluent] = useState(null);
    const [infusionDuration, setInfusionDuration] = useState(null);
    const [infusionFrequency, setInfusionFrequency] = useState(null);
    const [additives, setAdditives] = useState(null);
    const [duration, setDuration] = useState(null);
  
    const [medicineFreqValue, setMedicineFreqValue] = useState("")
    const [medicineFreqUnit, setMedicineFreqUnit] = useState("")
    //   const [ durationValue , setDurationValue] = useState("")
    //   const [ durationUnit , setDurationUnit] = useState("")
  
    const [rateOfInfusionValue, setRateOfInfusionValue] = useState(null);
    const [rateOfInfusionUnit , setRateOfInfusionUnit] = useState("ml/hr")
    const [durationValue, setDurationValue] = useState(null);
    const [durationUnit, setDurationUnit] = useState(null);
    const [frequencyUnit, setFrequencyUnit] = useState(null);
  
    // ---


  useEffect(() => {
    setActionAccessPatients(actionAccessMain(4))
    const currentUrl = window.location.href;
    const searchParams = new URLSearchParams(currentUrl.split('?') [1]);
    const id = searchParams.get('id');
    const apmtid = searchParams.get('appointmentid');
    setPatientid(id);

    if (apmtid) {
    setApmtIdUrl(apmtid);
    }

  if(apmtid) {
      fetchmediationdata(id, apmtid)
    fetchData("All", 1, id, apmtid);
    } else {
      fetchmediationdata(id, "")
    fetchData("All", 1);
    }
    // fetchmediationdata(id)   
  }, []);
  
  let patientidFromLocal = localStorage.getItem("patientid")
  const fetchmediationdata = async (id, apmtid="") => {
    showLoader()
        try {
          const result = await FetchMedicationsData({
            patientid: id || patientidFromLocal,
            // "patientid":patientidFromLocal,
            ...(apmtid && { appointmentid: apmtid }), 
            ...(apmtid && { type: 'ipd' })
          });

          console.log('result: ', result)
          if (result != null) {
            setData(result);
            setFilteredData(result)
          } else {
            setFilteredData('')
          }
          dismissLoader()
      } catch (error) {
          console.error("Error in home:", error);
        }
        dismissLoader()
      };

  // useEffect(() => {
  //   fetchData("All", 1);
  //   // fetchTreatmentTeam();
  // }, []);

  // useEffect(() => {
  //   if (data) {
  //     const filteredData = data.filter((step) =>
  //       step.medicinename && step.medicinename.toLowerCase().includes(searchValue.toLowerCase())
  //     );
      
  //     setFilteredData(filteredData)
  //   }
  // }, [searchValue, data])
  useEffect(()=>{
    setBoolValForSuggestions(!boolValForSuggestions)
  },[suggestions])
  const fetchData = async (type, tab, patientId="", appointmentId="") => {
    showLoader();
    setData("");
    try {
      const result = await FetchMedicationsData({
        // patientid,
        "patientid":patientidFromLocal,
        ...(appointmentId && { appointmentid: appointmentId }), 
        ...(appointmentId && { type: 'ipd' }),
        medicinetype: type,
        // iscurrent: tab,
      });
      console.log(result, "modified medications res");
      if (result != null) {
        setData(result);
        setFilteredData(result)
      } else {
        //alert("No data");
      }
      dismissLoader();
    } catch (error) {
      console.error("Error in DashboardIndex:", error);
    }
  };
  // const fetchTreatmentTeam = async () => {
  //   try {
  //     const result = await FetchTreatmentTeam({
  //       patientid,
  //     });
  //     if (result != null) {
  //       setTreatmentTeamData(result);
        
  //     } else {
  //       //alert("No data");
  //     }
  //     dismissLoader();
  //   } catch (error) {
  //     console.error("Error in home:", error);
  //   }
  // };
let patientgender = getgender();
let gender = patientgender;
if (gender === 1) {
  gender = "Female";
} else if (gender === 2) {
  gender = "Male";
} else if (gender === 3) {
  gender = "Others";
}else{
  gender = "Male";
}
  const dob = getDob();
  const patientname = getusername();

  const age = calculateAge(dob);
  function calculateAge(dateOfBirth) {
    const today = new Date();
    const dob = new Date(dateOfBirth);
    let age = today.getFullYear() - dob.getFullYear();
    const monthDiff = today.getMonth() - dob.getMonth();

    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < dob.getDate())) {
      age--;
    }
    return age;
  }
              const handlemedicinetime = (values) => {
                
                // If any time checkbox is selected, clear frequency inputs
                if (values.length > timeValues.length) {
                  // if (values.length > 0) {
                    setMedicineFreqUnit("");
                    setMedicineFreqValue(null);
                  }
                  setTimeValues(values);
                
                // Update individual time states if needed
                setMorning(values.includes("morning") ? 1 : 0);
                setAfternoon(values.includes("afternoon") ? 1 : 0);
                setNight(values.includes("night") ? 1 : 0);
              };
  
  // const handlemedicinetime = (values) => {
  //   if (values.includes("morning")) {
  //     setMorning(1);
  //   } else {
  //     setMorning(0);
  //   }
  //   if (values.includes("afternoon")) {
  //     setAfternoon(1);
  //   } else {
  //     setAfternoon(0);
  //   }
  //   if (values.includes("evening")) {
  //     setEvening(1);
  //   } else {
  //     setEvening(0);
  //   }
  
  //   if (values.includes("night")) {
  //     setNight(1);
  //   } else {
  //     setNight(0);
  //   }
  // };
  // const handlemedicinetimebeforeafter = (values) => {
  //   if (values.includes("beforefood")) {
  //     setBeforefood(1);
  //   } else {
  //     setBeforefood(0);
  //   }
  
  //   if (values.includes("afterfood")) {
  //     setAfterfood(1);
  //   } else {
  //     setAfterfood(0);
  //   }
  // };

  const handlemedicinetimebeforeafter = (value) => {
              setFoodTiming(value);
              if (value === "beforefood") {
                setBeforefood(1);
                setAfterfood(0);
              } else {
                setBeforefood(0);
                setAfterfood(1);
              }
            };

  const filterSurgeonNames = (surgeonName) => {
    const filtered = treatmentteamdata && treatmentteamdata.filter((surgeon) =>
      surgeon.doctorname?.toLowerCase().includes(surgeonName.toLowerCase())
    );
    setSuggestions(filtered);
  };

  const handleSurgeonNameChange = (surgeonName) => {
    let formattedValue = surgeonName.replace(/[^0-9a-zA-Z\s.]/g, "")
    setPrescribedBy(formattedValue);

    // Filter surgeon names based on input
    if (formattedValue) {
      filterSurgeonNames(formattedValue);
    } else {
      setSuggestions([]);
    }
    setPrescribedBy(formattedValue)
  };

  const handleSelect = (suggestion) => {
    setPrescribedBy(suggestion.doctorname);
    setSuggestions([]);
  };
  let input = {
    // patientid: "",
    "patientid":patientidFromLocal,
    documenttype_cd: "",
    documentcategory_cd: "",
    documentname: "",
    documenturl: "",
    prescribedby: prescribedby,
    hospitalname: hospitalname,
    patientname: patientname,
    age: age,
    documentdate: today,
    medicinedetail: [
      {
        medicinename: medicinename,
        chemical_composition: Composition,
        manufacturer: manufacturer,
        drugclass: drugClass,
        therapeutic: therapeutic, 
        medicinetype: medicinetype,
        dosage: dosage,
        dosageunit:dosageunit,
        // startdate: fromdate,
        // enddate: todate,
        // frequency:   frequency && medicineFreqUnit ? (frequency + " " + medicineFreqUnit) : frequency,
        frequency: frequency || "1",
                  frequencytime: medicineFreqUnit,
                  frequencyvalue: medicineFreqValue || null,
        morning: morning,
        afternoon: afternoon,
        evening: setevening,
        night: setnight,
        beforefood: beforefood,
        afterfood: afterfood,
        medicineexpirydate: medicineexpirydate,
        iscurrentmedicine: isChecked,
        custommessage: isAICorrected ? instructions : watch("textField") || instructions,
        longtext: "",
        documents: filenameArray.map(filename => ({ filename })),

         // new inputs
         "routeofadministration": routeOfAdministration,
         "timingofinjection": timing,
         "quantitytobeapplied": quantity,
         "areaofapplication": areaOfApplication,
         "diluent": diluent,
         "additives": additives,
 
         "rateofinfusionvalue": rateOfInfusionValue,
         "rateofinfusionunit": rateOfInfusionUnit,
        //  "duration": durationValue && durationUnit ? (durationValue + " " + durationUnit) : durationValue,
         "duration": durationValue && durationUnit ? (durationValue + " " + durationUnit) : durationValue || "5 Days"
      },
    ],
  };

  const handleimageselection = async (e) => {
    e.preventDefault();
    setMedicineName("")
    const file = e.target.files[0];
    const reader = new FileReader();
    reader.onloadend = () => {
      setSelectedImage(reader.result);
    };
    reader.readAsDataURL(file);
    const allowedTypes = ["image/png", "image/jpeg", "image/jpg", "image/webp"];
    if (!allowedTypes.includes(file.type)) {
      showErrorToast("Invalid file type. Please select a PNG, JPG or JPEG file.");
    dismissLoader();
      return false;
    }
    showLoader();
    const result = await GetMedicineName(file, file.name, file.type);
    if(result?.output?.message  == "No credits are available"){
      showErrorToast("No sufficient tokens available")
    }else{
    setMedicineName(result.medicine_name);
    setComposition(result.chemical_composition)

     if(result.expiry_date !== "00-0000"){
      //const formatteddate = moment(result.expiry_date).format("DD-MM-yyyy")
      setMedicineExpiryDate(result.expiry_date);
     }
    setBenifit(result.benefit);
    setSideEffects(result.side_effects);
  //  showmedicinename.current.openRight();
    }
    
    
  e.target.value = '';
    dismissLoader();
  };


  const handlemedicinenamecontinue = () => {
    showmedicinename.current.closeRight();
    
  };

  // Add Medicine
  // const addmedicine = async () => {
  //   // const parsedDate = moment(medicineexpirydate, "MM-yyyy");
  //   // const mfgMonth = parsedDate.month() +1;
  //   // const mfgYear = parsedDate.year();
  //   const currentMonth = moment().month() + 1;
  //   const currentYear = moment().year();

  //   const parsedDateExp = moment(medicineexpirydate, "MM-yyyy");
  //   const expMonth = parsedDateExp.month() +1;
  //   const expYear = parsedDateExp.year();
    
  //   showLoader();
  //   if (moment(input.medicinedetail[0].startdate, 'DD-MM-YYYY', true).isValid()) {
  //   input.medicinedetail[0].startdate = moment(input.medicinedetail[0].startdate, 'DD-MM-YYYY').format('YYYY-MM-DD');
  //   }
  //   if (moment(input.medicinedetail[0].enddate, 'DD-MM-YYYY', true).isValid()) {
  //   input.medicinedetail[0].enddate = moment(input.medicinedetail[0].enddate, 'DD-MM-YYYY').format('YYYY-MM-DD');
  //   }
  //   //console.log(input , " input to add medictiaon")
  //   //Freq and duration validations in Add Func ---
  //    if (medicineFreqUnit && !frequency) {
  //       showErrorToast("Please select Frequency!");
  //       dismissLoader();
  //       return false;
  //     } else if (!medicineFreqUnit && frequency) {
  //       showErrorToast("Please select Frequency Interval!");
  //       dismissLoader();
  //       return false;
  //     } else if (!durationUnit && durationValue && (medicinetype != "Syrup" && medicinetype != "Drops")) {
  //       showErrorToast("Please select Duration!");
  //       dismissLoader();
  //       return false;
  //     } else if (durationUnit && !durationValue  && (medicinetype != "Syrup" && medicinetype != "Drops")) {
  //       showErrorToast("Please select Interval Value!");
  //       dismissLoader();
  //       return false;
  //     }
  //   //---

  //   if (medicinename == "") {
  //     showErrorToast("Please specify or upload any medicine");
  //     setTimeout(() => {
  //     dismissLoader();
  //     }, 1000);
  //     return false;
  //   }else if(medicineexpirydate && expYear == currentYear && expMonth < currentMonth){
  //     showErrorToast("Exp month cannot be less than current Month!");
  //     dismissLoader();
  //       return false;
  //   } else {
  //     const result = await AddMedicine(input);
      
  //     if (result && result.output.result === 'success') {
  //       // if(showAIModal){
  //       //   await fetchAiDoctorPrompts(medicinename);
  //       // }
  //       showSuccessToast("Medicine created Successfully");
  //       fetchData(medicinetypeFilter, activeTab === 1? "0": "1");
  //       addMedication.current.closeModal();
        
  //     } else if (result.output.result === "failure" && result.output.message ==="medicine already Exists") {
  //       showErrorToast("Medicine already Exists")
  //     }
  //   }
  //   dismissLoader();
  // };

  const addmedicine = async () => {
    try {
        // Validate required fields
        if (newMedicine.medicinename === "") {
            showErrorToast("Please specify medicine name");
            return;
        }

        // Get current timestamp for documentdate
        const currentTimestamp = moment().format("YYYY-MM-DD HH:mm:ss.SSS");

        // Prepare the input object
        const input = {
            ...(apmtIdUrl && { appointmentid: apmtIdUrl }), 
            ...(apmtIdUrl && { type: 'ipd' }),
            patientid: patientidFromLocal,
            documenttype_cd: "",
            documentcategory_cd: "",
            documentname: "",
            documenturl: "",
            prescribedby: newMedicine.prescribedby || "",
            hospitalname: newMedicine.hospitalname || "",
            patientname: patientname,
            age: age,
            documentdate: currentTimestamp,
            medicinedetail: [
                {
                    medicinename: newMedicine.medicinename,
                    chemical_composition: newMedicine.composition,
                    manufacturer: newMedicine.manufacturer,
                    drugclass: newMedicine.drugclass,
                    therapeutic: newMedicine.therapeutic,
                    medicinetype: newMedicine.medicinetype,
                    dosage: newMedicine.dosage,
                    dosageunit: newMedicine.dosageunit,
                    // startdate: newMedicine.medicationstartdate,
                    // enddate: newMedicine.medicationenddate,
                    startdate: moment(newMedicine.medicationstartdate, "DD-MM-YYYY").format("YYYY-MM-DD"), // Convert to YYYY-MM-DD
                    enddate: moment(newMedicine.medicationenddate, "DD-MM-YYYY").format("YYYY-MM-DD"), // Convert to YYYY-MM-DD
                    frequency: newMedicine.frequency.toString(),
                    frequencytime: newMedicine.frequencytime,
                    frequencyvalue: newMedicine.frequencyvalue,
                    morning: newMedicine.morning,
                    afternoon: newMedicine.afternoon,
                    evening: newMedicine.evening,
                    night: newMedicine.night,
                    beforefood: newMedicine.beforefood,
                    afterfood: newMedicine.afterfood,
                    medicineexpirydate: "", // Add if available
                    iscurrentmedicine: '', // Default value
                    custommessage: newMedicine.custommessage,
                    longtext: "",
                    documents: [], // Add documents if available
                    
                    // New inputs
                    routeofadministration: newMedicine.routeofadministration,
                    timingofinjection: newMedicine.timingofinjection,
                    quantitytobeapplied: newMedicine.quantitytobeapplied,
                    areaofapplication: newMedicine.areaofapplication,
                    diluent: newMedicine.diluent,
                    additives: newMedicine.additives,
                    rateofinfusionvalue: newMedicine.rateofinfusionvalue,
                    rateofinfusionunit: newMedicine.rateofinfusionunit,
                    duration: `${newMedicine.durationvalue} ${newMedicine.durationunit}`,
                    frequencyduration: newMedicine.frequencyduration,
                    sos: newMedicine.sos,
                    updatedby: Doctorid,
                    updateddate: getLocalISOString(date, time)
                }
            ]
        };

        showLoader();

        // Make API call
        const result = await AddMedicine(input);
        
        if (result && result.output.result === 'success') {
            showSuccessToast("Medicine added successfully");
            
            // Reset form
            setNewMedicine({
                id: null,
                inventoryid: null,
                medicinename: "",
                manufacturer: "",
                drugclass: "",
                therapeutic: "",
                composition: "",
                medicinetype: "Tablet",
                dosage: "",
                dosageunit: "mg",
                medicationstartdate: moment().format("DD-MM-YYYY"),
                medicationenddate: moment().add(5, "days").format("DD-MM-YYYY"),
                frequency: 1,
                frequencytime: "",
                frequencyvalue: "",
                morning: 1,
                afternoon: 0,
                evening: 0,
                night: 0,
                prescribedby: "",
                hospitalname: "",
                beforefood: 0,
                afterfood: 1,
                issaved: false,
                frequencyduration: null,
                routeofadministration: null,
                timingofinjection: null,
                quantitytobeapplied: null,
                areaofapplication: null,
                diluent: null,
                additives: null,
                rateofinfusionvalue: null,
                rateofinfusionunit: "ml/hr",
                duration: "5 Days",
                durationunit: "Days",
                durationvalue: 5,
                custommessage: null,
                sos: null
            });

            // Close the modal
            addMedication.current.closeModal();
            
            // Refresh data if needed
            if(apmtIdUrl) {
              fetchData(medicinetypeFilter, activeTab === 1 ? "0" : "1", patientidFromLocal, apmtIdUrl);
            } else {
              fetchData(medicinetypeFilter, activeTab === 1 ? "0" : "1");
            }
            
        } else if (result.output.result === "failure" && result.output.message === "medicine already Exists") {
            showErrorToast("Medicine already Exists");
        } else {
            showErrorToast("Failed to add medicine");
        }
    } catch (error) {
        console.error("Error adding medicine:", error);
        showErrorToast("An error occurred while adding medicine");
    } finally {
        dismissLoader();
    }
};
  
  // const [documentURLForEdit, setDocumentURLForEdit] = useState([]);
  const handleDeleteDocInEdit = (index) => {
    const updatedUrls = [...documentURLForEdit];
    updatedUrls.splice(index, 1);
   // setUploadedDocuments(updatedUrls);
    
    setDocumentURLForEdit(updatedUrls);

    if (updatedUrls != null) {

      setFilenameforUpload(updatedUrls?.map(doc => doc.documentname));
    }
  };
  // Update data
  // const editmedicine = async () => {
  //   let input = {
  //     // patientid: "",
  //     "patientid":patientidFromLocal,
  //     "id": id,
  //     documenttype_cd: "",
  //     documentcategory_cd: "",
  //     documentname: "",
  //     documenturl: "",
  //     prescribedby: prescribedby,
  //     hospitalname: hospitalname,
  //     patientname: patientname,
  //     age: age,
  //     documentdate: today,
  //     medicinename: medicinename,
  //     chemical_composition: Composition,
  //     medicinetype: medicinetype,
  //     dosage: dosage,
  //     dosageunit:dosageunit,
  //     // startdate: fromdate,
  //     // enddate: todate,
  //     frequency:   frequency && medicineFreqUnit ? (frequency + " " + medicineFreqUnit) : frequency,
  //     morning: morning,
  //     afternoon: afternoon,
  //     evening: setevening,
  //     night: setnight,
  //     beforefood: beforefood,
  //     afterfood: afterfood,
  //     medicineexpirydate: medicineexpirydate,
  //     iscurrentmedicine: isChecked,
  //     longtext: "",

  //     documents: filenameforUpload.map(filename => ({ filename })),

  //      // new inputs
  //      "routeofadministration": routeOfAdministration,
  //      "timingofinjection": timing,
  //      "quantitytobeapplied": quantity,
  //      "areaofapplication": areaOfApplication,
  //      "diluent": diluent,
  //      "additives": additives,

  //      "rateofinfusionvalue": rateOfInfusionValue,
  //      "rateofinfusionunit": rateOfInfusionUnit,
  //      "duration": durationValue && durationUnit ? (durationValue + " " + durationUnit) : durationValue,

  //   };
  //   const currentMonth = moment().month() + 1;
  //   const currentYear = moment().year();

  //   const parsedDateExp = moment(medicineexpirydate, "MM-yyyy");
  //   const expMonth = parsedDateExp.month() +1;
  //   const expYear = parsedDateExp.year();
    
  //   if (moment(input.startdate, 'DD-MM-YYYY', true).isValid()) {
  //     input.startdate = moment(input.startdate, 'DD-MM-YYYY').format('YYYY-MM-DD');
  //   }
  //   if (moment(input.enddate, 'DD-MM-YYYY', true).isValid()) {
  //     input.enddate = moment(input.enddate, 'DD-MM-YYYY').format('YYYY-MM-DD');
  //   }
   
  //   //Freq and duration validations in Edit Func ---
  //     if (medicineFreqUnit && !frequency) {
  //       showErrorToast("Please select Frequency!");
  //       dismissLoader();
  //       return false;
  //     } 
  //     // else if (!medicineFreqUnit && frequency) {
  //     //   showErrorToast("Please select Frequency Interval!");
  //     //   dismissLoader();
  //     //   return false;
  //     // } 
  //     else if (!durationUnit && durationValue  && (medicinetype != "Syrup" && medicinetype != "Drops")) {
  //       showErrorToast("Please select Duration!");
  //       dismissLoader();
  //       return false;
  //     } else if (durationUnit && !durationValue  && (medicinetype != "Syrup" && medicinetype != "Drops")) {
  //       showErrorToast("Please select Interval Value!");
  //       dismissLoader();
  //       return false;
  //     }
  //   //---

  //   // if (medicinename == "") {
  //   //   showErrorToast("Please specify or upload any medicine");
  //   //   return false;
  //   // }
  //   else if(medicineexpirydate && expYear == currentYear && expMonth < currentMonth){
  //     showErrorToast("Exp month cannot be less than current Month!");
  //     // dismissLoader();
  //       return false;
  //   }  else {
     
  //     showLoader();
  //     const result = await EditMedicine(input);
      
  //     if (result) {
  //       // if(showAIModal){
  //       // await fetchAiDoctorPrompts(input.medicinename);
  //       // }
  //       showSuccessToast("Medicine updated Successfully");
  //       fetchData(medicinetypeFilter, activeTab === 1? "0": "1");
  //       editmedications.current.closeRight();
  //       detailsmodel.current.closeRight();
        
  //     }
  //     setTimeout(() => {
        
  //     dismissLoader();
  //     }, 2000);
  //   }
  // };

  
  const editmedicine = async () => {
    try {
        // Validate required fields
        if (editMedicine.medicinename === "") {
            showErrorToast("Please specify medicine name");
            return false;
        }

        // Date validation
        const currentMonth = moment().month() + 1;
        const currentYear = moment().year();
        const parsedDateExp = moment(editMedicine.medicineexpirydate, "MM-yyyy");
        const expMonth = parsedDateExp.month() + 1;
        const expYear = parsedDateExp.year();

        // Frequency and duration validations
        if (editMedicine.frequencytime && !editMedicine.frequencyvalue) {
            showErrorToast("Please select Frequency Value!");
            return false;
        } else if (!editMedicine.durationunit && editMedicine.durationvalue && 
                  (editMedicine.medicinetype != "Syrup" && editMedicine.medicinetype != "Drops")) {
            showErrorToast("Please select Duration!");
            return false;
        } else if (editMedicine.durationunit && !editMedicine.durationvalue && 
                  (editMedicine.medicinetype != "Syrup" && editMedicine.medicinetype != "Drops")) {
            showErrorToast("Please select Interval Value!");
            return false;
        } else if (editMedicine.medicineexpirydate && expYear == currentYear && expMonth < currentMonth) {
            showErrorToast("Exp month cannot be less than current Month!");
            return false;
        }

        // // Get current date in required format
        // const currentDate = new Date();
        // const updatedDate = moment(currentDate).format("YYYY-MM-DDTHH:mm:ss");
        // // You should replace 'currentUser' with your actual user identifier
        // const updatedBy = "currentUser"; // Replace with actual user ID or name

        // Combine date and time for updateddate
    const updatedDateTime = getLocalISOString(editMedicine.updateddate, editMedicine.updatedtime);

        // Prepare the input object
        const editinput = {
          ...(apmtIdUrl && { appointmentid: apmtIdUrl }), 
            ...(apmtIdUrl && { type: 'ipd' }),
            patientid: patientidFromLocal,
            // id: editMedicine.id, // Include the medicine ID for editing
            // documenttype_cd: "",
            // documentcategory_cd: "",
            // documentname: "",
            // documenturl: "",
            // hospitalname: editMedicine.hospitalname || "",
            // patientname: patientname,
            // age: age,
            // documentdate: moment().format("YYYY-MM-DD HH:mm:ss.SSS"),
            medicinedetail: [
                {
                  id: editMedicine.id,
                    medicinename: editMedicine.medicinename,
                    chemical_composition: editMedicine.chemicalcomposition,
                    manufacturer: editMedicine.manufacturer,
                    drugclass: editMedicine.drugclass,
                    therapeutic: editMedicine.therapeutic,
                    medicinetype: editMedicine.medicinetype,
                    dosage: editMedicine.dosage,
                    dosageunit: editMedicine.dosageunit,
                    startdate: moment(editMedicine.medicationstartdate, "DD-MM-YYYY").format("YYYY-MM-DD"),
                    enddate: moment(editMedicine.medicationenddate, "DD-MM-YYYY").format("YYYY-MM-DD"),
                    frequency: editMedicine.frequency.toString(),
                    frequencytime: editMedicine.frequencytime,
                    frequencyvalue: editMedicine.frequencyvalue,
                    morning: editMedicine.morning ? 1 : 0,
                    afternoon: editMedicine.afternoon ? 1 : 0,
                    evening: editMedicine.evening ? 1 : 0,
                    night: editMedicine.night ? 1 : 0,
                    beforefood: editMedicine.beforefood ? 1 : 0,
                    afterfood: editMedicine.afterfood ? 1 : 0,
                    medicineexpirydate: editMedicine.medicineexpirydate || "",
                    // iscurrentmedicine: editMedicine.iscurrentmedicine ? 1 : 0,
                    custommessage: editMedicine.custommessage,
                    isactive: 1,
                    // longtext: "",
                    // documents: editMedicine.documents || [],
                    
                    // // New inputs
                    // routeofadministration: editMedicine.routeofadministration,
                    // timingofinjection: editMedicine.timingofinjection,
                    // quantitytobeapplied: editMedicine.quantitytobeapplied,
                    // areaofapplication: editMedicine.areaofapplication,
                    // diluent: editMedicine.diluent,
                    // additives: editMedicine.additives,
                    // rateofinfusionvalue: editMedicine.rateofinfusionvalue,
                    // rateofinfusionunit: editMedicine.rateofinfusionunit,
                    duration: `${editMedicine.durationvalue} ${editMedicine.durationunit}`,
                    frequencyduration: editMedicine.frequencyduration,
                    sos: editMedicine.sos || null,

                    //  updateddate: updatedDate,
                    // updatedby: updatedBy
                    updateddate: updatedDateTime,
                    updatedby: Doctorid 
                }
            ],
        };

        showLoader();
        // const result = await EditMedicine({ editinput });
        const result = await EditMedicine(editinput);

        if (result && result.output && result.output.result === 'success') {
            showSuccessToast("Medicine updated successfully");
            // fetchData(medicinetypeFilter, activeTab === 1 ? "0" : "1");
            // Refresh data if needed
            if(apmtIdUrl) {
              fetchData(medicinetypeFilter, activeTab === 1 ? "0" : "1", patientidFromLocal, apmtIdUrl);
            } else {
              fetchData(medicinetypeFilter, activeTab === 1 ? "0" : "1");
            }
            editMedication.current.closeModal();
            // editmedications.current.closeRight();
            // detailsmodel.current.closeRight();
        } else {
            showErrorToast(result.output?.message || "Failed to update medicine");
        }
    } catch (error) {
        console.error("Error updating medicine:", error);
        showErrorToast("An error occurred while updating medicine");
    } finally {
        dismissLoader();
    }
};
  const opendetailsmodel = (medicine) => {
    //console.log(medicine , "medicine ")
    setFilenameforUpload([])
    setMedicinedata("");
    setMedicineData([])
    // const medicationEndDate = moment(medicine.medicationenddate);
    //   const today = moment();
    //   const differenceInDays = medicationEndDate.diff(today, 'days');
    setMedicinedata(medicine);
    
    setDocumentURLForEdit(medicine.documents)

    var enddate = moment(medicine.medicationenddate);
    var startdate = moment(medicine.medicationstartdate);
    var daysDiffrence = enddate.diff(startdate  ,"days" )
    var totalDays = daysDiffrence + 1;
    if(totalDays <= 1 ) {
    setDaysDiffrence("1 day")
    }else {
      setDaysDiffrence(totalDays + " days")
    }
    setMedicineData(medicine.documents)
    if (medicine.documents) {

      const documentNames = medicine.documents.map(doc => doc.documentname);
      setFilenameforUpload(documentNames);
    }

    detailsmodel.current.openRight();
  };

  const setDetailsOfEdit = (item, e, showAIModal) => {
    
    setShowAIModal(showAIModal)
    setInitialPageLoad(true)
    setID(item.id);
    setMedicineName(item.medicinename);
    setComposition(item.chemicalcomposition);
    setMedicineType(item.medicinetype);
    setMedicineDosage(item.dosage);
    setMedicineDosageUnit(item.dosageunit);
    // const stratdate =  moment(item.medicationstartdate, 'YYYY-MM-DD').format('DD-MM-yyyy');
    // const enddate =  moment(item.medicationenddate, 'YYYY-MM-DD').format('DD-MM-yyyy');
    // setFromDate(stratdate)
    // setToDate(enddate);
    setMedicineDosageFrequency(item.frequency);
    setMorning(item.morning);
    setAfternoon(item.afternoon);
    setEvening(item.evening);
    setNight(item.night);
    setBeforefood(item.beforefood);
    setAfterfood(item.afterfood);
    setPrescribedBy(item.prescribedby)
    setHospitalname(item.prescribedhospitalname)
    setIsChecked(item.iscurrentmedicine)
    setMaxDateStateEdit("")
    setMinDateStateEdit("")
    setMedicineExpiryDate(item.medicineexpirydate)

      if(e.target.checked){
        setIsChecked(1)
        setBoolCheck(!boolCheck)
        
      }else{
        setIsChecked(0)
        setBoolCheck(!boolCheck)
      }
   // detailsmodel.current.openRight();
  };

  useEffect(()=>{
    if(initialPageLoad)editmedicine()

  },[boolCheck])

  const handleChangeDosageUnit = (selectedOption) => {
    setMedicineDosageUnit(selectedOption.label);
  };
  const handleconsumptionfrequencychange = (selectedOption) => {
    setMedicineDosageFrequency(selectedOption)
    // if(selectedOption == "1"){
    //   setMedicineDosageFrequency("1");
    // }else  if(selectedOption == "2"){
    //   setMedicineDosageFrequency("2");
    // }else  if(selectedOption == "3"){
    //   setMedicineDosageFrequency("3");
    // }else  if(selectedOption == "4"){
    //   setMedicineDosageFrequency("4");
    // }
  };
  const handlemedicinetypechange = (event) => {

    setMedicineType(event);
    if(event == "Tablet" || event == "Capsule"){
      setMedicineDosageUnit("mg");
    }else if (event == "Syrup" || event == "Drops" || event == "Injection" ||  event == "Nebulization" ||  event == "IVFluids"){
      
      setMedicineDosageUnit("ml");
    }else if (event == "Ointment"){
      
      setMedicineDosageUnit("grms");
    } else if (event == "Inhaler") {
      setMedicineDosageUnit("puffs");
    }
  };
  const handlemedicinename = (event) => {
    setMedicineName(event.target.value);
  };
  const handletabswitch = (index) => { 
   
      switch (index) {
        case 0:
          setActiveTab(0);
          fetchData(medicinetypeFilter,1);
          break;
        case 1:
          setActiveTab(1);
          fetchData(medicinetypeFilter,0);
          break;     
        default:
          break;
      }
  };
  const handlefilterswitch = (label) => {
    if (label === "Tablet") {
      fetchData("Tablet", activeTab === 1? "0": "1");
      setMedicineTypeRadio("Tablet")
      setMedicineType("Tablet")
      setMedicineDosageUnit("mg")
      setMedicineTypeFilter("Tablet")
    } else if (label === "Syrup") {
      fetchData("Syrup",activeTab === 1? "0": "1");
      setMedicineTypeRadio("Syrup")
      setMedicineType("Syrup")
      setMedicineTypeFilter("Syrup")
      setMedicineDosageUnit("ml")
    } else if (label === "Drops") {
      fetchData("Drops", activeTab === 1? "0": "1");
      setMedicineTypeRadio("Drops")
      setMedicineType("Drops")
      setMedicineTypeFilter("Drops")
      setMedicineDosageUnit("ml")
    } else {
      fetchData("All",activeTab === 1? "0": "1");
      setMedicineTypeRadio("Tablet")
      setMedicineType("Tablet")
      setMedicineTypeFilter("All")
      setMedicineDosageUnit("mg")
    }
  };
  const SearchIconClicked = () => {
    ShowHideSearch(true);
  };
  const DeleteMedicineModel = (title, id) => {
    setID(id);
    setTitle(title);
    dynamicModal.current.openModal();
  };
  const deletemedicine = async () => {
    const result = await DeleteMedicine({
      // loginid,
      id: id,
      "patientid":patientidFromLocal,
    });
    if (result) {
      showSuccessToast("Medicine deleted successfully");
      fetchData(medicinetypeFilter,activeTab === 1? "0": "1");
      dynamicModal.current.closeModal();
      detailsmodel.current.closeRight();
    }
  };

const handleeditmedication = (item)=>{

  setID(item.id);
  setMedicineName(item.medicinename);
  setComposition(item.chemicalcomposition);
  setMedicineType(item.medicinetype);
  setMedicineDosage(item.dosage);
  setMedicineDosageUnit(item.dosageunit);
  // const stratdate =  moment(item.medicationstartdate, 'YYYY-MM-DD').format('DD-MM-yyyy');
  // const enddate =  moment(item.medicationenddate, 'YYYY-MM-DD').format('DD-MM-yyyy');
  // setFromDate(stratdate)
  // setToDate(enddate);

  // setMedicineDosageFrequency(item.frequency);
  setMorning(item.morning);
  setAfternoon(item.afternoon);
  setEvening(item.evening);
  setNight(item.night);
  setBeforefood(item.beforefood);
  setAfterfood(item.afterfood);
  setPrescribedBy(item.prescribedby)
  setHospitalname(item.prescribedhospitalname)
  setIsChecked(item.iscurrentmedicine)
  setMaxDateStateEdit("")
  setMinDateStateEdit("")
  setMedicineExpiryDate(item.medicineexpirydate)
  setShowDocNamesDropdown(false)
  setShowAIModal(true)

   // new Input states set on Edit modal open - Start ||----
   setRouteOfAdministration(item.routeofadministration);
   setTiming(item.timingofinjection);
   setQuantity(item.quantitytobeapplied);
   setAreaOfApplication(item.areaofapplication);
   setDiluent(item.diluent);
   setInfusionDuration(item.infusionDuration);
   setAdditives(item.additives);
   
   setRateOfInfusionUnit(item.rateofinfusionunit)
   setRateOfInfusionValue(item.rateofinfusionvalue)

   setDuration(item.duration);

  //  setMedicineDosageFrequency(item.frequency);

   if (item.frequency) {
     const parts = item.frequency.split(" "); 
     const value = parts[0]; 
     const unit = parts[1];  
     setMedicineDosageFrequency(value); 
     setMedicineFreqUnit(unit);  
   }

   if (item.duration) {
       const parts = item.duration.split(" "); 
       const value = parts[0]; 
       const unit = parts[1];  
       setDurationValue(value); 
       setDurationUnit(unit);  
     }
   // new Input states set on Edit modal open - End ----||

  editmedications.current.openRight();
}

  const noDataStyle = {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  };

  function clearState (){
    setRouteOfAdministration(null);
    setTiming(null);
    setQuantity(null);
    setAreaOfApplication(null);
    setDiluent(null);
    setInfusionDuration(null);
    setAdditives(null);
    setDuration(null)
    setMedicineFreqValue(null); 
    setMedicineFreqUnit(null); 
    setRateOfInfusionValue(null);
    setRateOfInfusionUnit("ml/hr")
    
    setDurationValue("3"); 
    setDurationUnit("Days"); 

    setMedicineType("Tablet")
    setMedicineDosageUnit("mg")
  }

  const addData = () => {
    setNewMedicine({
      id: null,
    inventoryid: null,
    medicinename: "",
    manufacturer: "",
    drugclass: "",
    therapeutic: "",
    composition: "",
    medicinetype: "Tablet",
    dosage: "",
    dosageunit: "mg",
    medicationstartdate: today, // SETTING DEFAULTS
    medicationenddate: fiveDaysFromToday, // SETTING DEFAULTS
    frequency: 1, // SETTING DEFAULTS
    frequencytime: "",
    frequencyvalue: "",
    morning: 1, // SETTING DEFAULTS
    afternoon: 0,
    evening: 0,
    night: 0,
    prescribedby: "",
    hospitalname: "",
    beforefood: 0, // SETTING DEFAULTS
    afterfood: 1,
    issaved: false,

    // new inputs

    frequencyduration: null,
    routeofadministration: null,
    timingofinjection: null,
    quantitytobeapplied: null,
    areaofapplication: null,
    diluent: null,
    additives: null,

    rateofinfusionvalue: null,
    rateofinfusionunit: "ml/hr",
    // duration: null,
    duration: "5 Days", // Set default duration value
durationunit: "Days", // Add this new field
durationvalue: 5, // Add this new field

custommessage:null,
sos:null
    })
    setFilenameArray([]);
    setMedicineName("") 
    setComposition("") 
    // setFromDate(moment().format("DD-MM-yyyy"))
    // setToDate(moment().format("DD-MM-yyyy"))
    setHospitalname(null)
    setManufacturer(null)
    setDrugClass(null)
    setTherapeutic(null)
    setPrescribedBy(null)
    setDropdownMedType('')
    //setMedicineType("Tablet")
    //setMedicineDosageUnit("mg")
    setMedicineDosage(null)
    setMedicineDosageFrequency("")
    setMorning("0")
    setEvening("0")
    setNight("0")
    setComposition("")
    setMedicineExpiryDate("")
    setShowAIModal(true);

    // Clear the instructions properly
  setInstructions(""); // Use empty string instead of null
  setValue("textField", ""); // Clear the form value

    setDate(moment().format("DD-MM-yyyy"));
    setTime(moment().format("HH:mm"));
    fetchDoctors();
    
    clearState();
    addMedication.current.openModal();

    setShowDocNamesDropdown(false)
   
  }


  const fileInputRef = useRef(null);
  const fileInputRefUpdate = useRef(null);
  const handleMedicationUpload = async (e) => {
    e.preventDefault();
    showLoader();

    const file2 = e.target.files[0];
    const allowedTypes = ["image/png", "image/jpeg", "image/jpg", "image/webp"];
    if (!allowedTypes.includes(file2.type)) {
      showErrorToast("Invalid file type. Please select a PNG, JPG or JPEG file.");
      setTimeout(() => {
        
        dismissLoader();
      }, 1000);
      return false;
    }
    const reader = new FileReader();
    reader.readAsDataURL(file2);
    //console.log(file2 , "File")
    const result = await uploadImageInProfile(file2, file2.name);
    //console.log(result , "result.name ");
    const filename = result.name;
    setFilenameArray(prev => [...prev, filename]);
    
    e.target.value = ''; 
    dismissLoader();

  };
  const addMedicationUploadDocument = () => {
    fileInputRef.current.click();
  }

  const handleDelete = (index) => {
    const newArray = [...filenameArray];
    newArray.splice(index, 1);
    setFilenameArray(newArray);
  };

  const updateMedicationDocuments = () => {

    fileInputRefUpdate.current.click();
  }
  const handleMedicationUploadUpdate = async (e) => {
    e.preventDefault();
    showLoader();

    const file2 = e.target.files[0];
    const allowedTypes = ["image/png", "image/jpeg", "image/jpg", "image/webp"];
    if (!allowedTypes.includes(file2.type)) {
      showErrorToast("Invalid file type. Please select a PNG, JPG or JPEG file.");
      setTimeout(() => {
        
        dismissLoader();
      }, 1000);
      return false;
    }
    const reader = new FileReader();
    reader.readAsDataURL(file2);
    
    const result = await uploadImageInProfile(file2, file2.name);
 
    const filename = result.name;
    // setMedicineData(prevData => [...prevData, filename]);
    setFilenameforUpload(prevFilenames => [...prevFilenames, filename]);
    //console.log(filenameforUpload, "filenameforUpload")

    // below we are setting the documents uploaded in edit, and we are checking if the prevFileNames is an array or not
    //  as when prevFileNames is empty it is giving error that iprevFileNames is not an array.
    setDocumentURLForEdit(prevFileNames => {
      if(!Array.isArray(prevFileNames)){
        return[{
          documentname: filename,
          documenturl: filename,
          imagepath: "https://midocfileserver.blob.core.windows.net/midocdev/"
        }]
      }else {
        return[
          ...prevFileNames, 
          {
            documentname: filename,
            documenturl: filename,
            imagepath: "https://midocfileserver.blob.core.windows.net/midocdev/"
       
          }
        ]
      }
    })
    showSuccessToast("Document Added Successfully.");
    e.target.value = '';
    dismissLoader();

  };


  const formatDate = (dateString) => {
    if (!dateString) return '-';
    return moment(dateString).format('Do MMM, YYYY');
  };

   const handleclose = ()=>{
  showhidesearch(false)
   }
   
  const [minDateState , setMinDateState] = useState('')
  const [maxDateState , setMaxDateState] = useState('')

  // const [minDateStateEdit , setMinDateStateEdit] = useState('')
  // const [maxDateStateEdit , setMaxDateStateEdit] = useState('')
  //  const handleFromDateChange = (selecteddate) => {
  //   const formattedDate = moment(selecteddate).format('YYYY-MM-DD');
  //   setFromDate(formattedDate);

  //   setMinDateState(selecteddate)
    
  //   setMinDateStateEdit(selecteddate)
    
  //   const formattedDateToSetAsMinDate = moment(selecteddate).format('DD-MM-YYYY');
  //   setMinDateValue(formattedDateToSetAsMinDate)
  // };
  
  // const handleToDateChange = (selecteddate) => {
  //   const formattedDate = moment(selecteddate).format('YYYY-MM-DD');
  //   setToDate(formattedDate);
  //   setMaxDateState(selecteddate)
    
  //   setMaxDateStateEdit(selecteddate)
  // };
  const handleExpiryDateChange = (event) => {
    //const formattedDate = moment(selecteddate).format('YYYY-MM-DD');
    setMedicineExpiryDate(event);
  };
  const closeSearchBar =()=>{
    setSearchValue("")
    ShowHideSearch(false)
  }
  // existing function
  // const fetchComposition = async (medicineName) => {
  //   const inputData = {
  //     input: {
  //       name: medicineName,
  //     },
  //   };
  //   if(medicineName){
  //   try {
  //      showLoader();
  //     const result = await GetAIMedicineComposition(inputData.input);
  //     // console.log(result);
  //     if (result) {
  //       showSuccessToast("Medicine composition fetched successfully");
  //       setComposition(result.chemical_composition);
  //       if (Array.isArray(result.Manufacturer)) {
  //         setManufacturer(result.Manufacturer.join(", "));
  //       } else {
  //         setManufacturer(result.Manufacturer || ""); 
  //       }
  //       if (Array.isArray(result.TherapeuticCategory)) {
  //         setTherapeutic(result.TherapeuticCategory.join(", "));
  //       } else {
  //         setTherapeutic(result.TherapeuticCategory || "");
  //       }
  //       if (Array.isArray(result.DrugClass)) {
  //         setDrugClass(result.DrugClass.join(", "));
  //       } else {
  //         setDrugClass(result.DrugClass || ""); 
  //       }
  //       // setMedicineExpiryDate(result.expiry_date);
  //       setBenifit(result.benefit);
  //   setSideEffects(result.side_effects);
  //     }
  //     dismissLoader()
  //   } catch (error) {
  //     console.error("Error Fetching Medicine composition:", error);
  //     showErrorToast("An error occurred while Fetching Medicine composition");
  //   } 
      
  // }else{
  //   showErrorToast("Please provide medicine name or upload medicine photo")
  // }
  // };
  const fetchComposition = async (medicineName) => {
        if (!medicineName) {
          showErrorToast("Please enter medicine name first to fetch composition");
        } else {
          const inputData = {
            input: {
              name: medicineName,
            },
          };
  
          // console.log(inputData.input);
  
          showLoader();
          try {
            // console.log(inputData);
            const result = await GetAIMedicineComposition(inputData.input);
            console.log(result, "resutl for Fetch");
            if (result) {
              showSuccessToast("Fetched Medicine composition successfully");
              handleNewMedicineChange("composition", result.chemical_composition);
              // handleNewMedicineChange("manufacturer", result.Manufacturer);
              // handleNewMedicineChange("therapeutic", result.TherapeuticCategory);
              // handleNewMedicineChange("drugclass", result.DrugClass);
  
              if (Array.isArray(result.Manufacturer)) {
            handleNewMedicineChange("manufacturer", result.Manufacturer.join(", "));
          } else {
            handleNewMedicineChange("manufacturer", result.Manufacturer || ""); 
          }
          if (Array.isArray(result.TherapeuticCategory)) {
            handleNewMedicineChange("therapeutic", result.TherapeuticCategory.join(", "));
          } else {
            handleNewMedicineChange("therapeutic", result.TherapeuticCategory || "");
          }
          if (Array.isArray(result.DrugClass)) {
            handleNewMedicineChange("drugclass", result.DrugClass.join(", "));
          } else {
            handleNewMedicineChange("drugclass", result.DrugClass || ""); 
          }

          // Add instructions population
        if (result.InstructionsOfAdministration) {
          handleNewMedicineChange("custommessage", result.InstructionsOfAdministration);
        }
        
        // Set medicine type if available
        // if (result.type) {
        //   handleNewMedicineChange("medicinetype", result.type);
        // }
              // handleNewMedicineChange("custommessage", result.InstructionsOfAdministration);
              setKey((prevKey) => prevKey + 1);
              // handleNewMedicineChange("medicinetype", result.type);
            }
          } catch (error) {
            console.error("Error Fetching Medicine composition:", error);
            showErrorToast(
              "An error occurred while Fetching Medicine composition"
            );
          } finally {
            dismissLoader();
          }
  
          // fetchDoctorNotes();
  
          // console.log("Clicked");
        }
      };
  const makeAicall = async ()=>{
    const inputData = {
      input: {
        name: medicinename,
      },
    };
    if(medicinename){
    try {
     showLoader();
    const result = await GetAIMedicineComposition(inputData.input);
    if(result){
        // setMedicineName(result.medicine_name);
        setComposition(result.chemical_composition)

        if(result.expiry_date !== "00-0000"){
          //const formatteddate = moment(result.expiry_date).format("DD-MM-yyyy")
          setMedicineExpiryDate(result.expiry_date);
        }
        setBenifit(result.benefit);
        setSideEffects(result.side_effects);
        learnMoreModal.current.openModal()
         dismissLoader();
    }
    }catch(error){

    }
  }
};
useEffect(() => {
  if (animate) {
    const timer = setTimeout(() => {
      setAnimate(false);
    }, 500);
    return () => clearTimeout(timer);
  }
}, [animate]);

useEffect(() => {
  // Scroll to bottom whenever aianswers changes
  if (chatContainerRef.current) {
    chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight;
  }
}, [aianswers]);
const fetchAiDoctorPrompts = async (medicinename)=>{
  showLoader();
  setRemainingQuestions([])
  setAiInput(null);
  setAIAnswers([])
  setInitialRender(true)
  const result = await FetchPatientDetails({
    patientid: patientidFromLocal,
  });
  console.log(result)
  let Aiprompts = { ...result, medicinename };
    setAiInput(Aiprompts);
    const response = await FetchMedicineAIPrompts(Aiprompts);
    if (response.generated_question) {
      setAIAnalysis(response);
      setRemainingQuestions(response.generated_question);
      AIChatModel.current.openRight();
    }
    dismissLoader();
}

const GetAIAnswer = async (prompt) => {
  // Display question immediately
  const newQuestion = { question: prompt, answer: "" };
  setAIAnswers((prevState) => [...prevState, newQuestion]);

  // Remove the question from remaining questions immediately
  setRemainingQuestions((prevState) => prevState.filter((question) => question.value !== prompt));

  // Trigger animation
  setAnimate(true);

  // Set initialRender to false after the first question is clicked
  setInitialRender(false);
  let AichatInput = { ...AiInput, query:prompt };


  const response = await FetchMedicineAIAnswer(AichatInput);

  if (response) {
    // Replace "typing" with actual answer
    setAIAnswers((prevState) =>
      prevState.map((item) =>
        item.question === prompt && item.answer === ""
          ? { question: item.question, answer: response.answer }
          : item
      )
    );
  }
};
const handleIsCurrent = (e)=>{
  if(e.target.checked){
    setIsChecked(1)
  }else{
    setIsChecked(0)
  }
}
const listOfSurgeonNames = ( isImage) => {
 
  const allSuggestions = treatmentteamdata && treatmentteamdata

  setSuggestions(allSuggestions);
  // setBoolValForSuggestions(!boolValForSuggestions) 
  if(isImage){
    setShowDocNamesDropdown(!showDocNamesDropdown)

  }
};

const handleMonthYearChange = (date) => {
  setMedicineExpiryDate(moment(date).format('MM-yyyy'));
};

 // new input fields added functionality || start 

 const handleRateOfInfusionUnit = (selectedOption) => {
  setRateOfInfusionUnit(selectedOption.label);
};

//  function handleFrequencyUnit(selectedOption) {
//     setMedicineFreqUnit(selectedOption)
// }
function handleFrequencyUnit(selectedOption) {
                 
                 if (selectedOption) {
                   setTimeValues([]);
                   setMorning(0);
                   setAfternoon(0);
                   setNight(0);
                  }
                  setMedicineFreqUnit(selectedOption)
              }
               function handleFrequencyValue(selectedOption) {
                 
                 // If frequency value is selected, clear time checkboxes
                 if (selectedOption) {
                   setTimeValues([]);
                   setMorning(0);
                   setAfternoon(0);
                   setNight(0);
                  }
                  setMedicineFreqValue(selectedOption)
              }
function handleDurationValue(selectedOption) {
    setDurationValue(selectedOption)
}
function handleDurationUnit(selectedOption) {
  // if(selectedOption != "Until symptoms resolve"){
    setDurationUnit(selectedOption)
  // }
}

function handleRouteOfAdministration(selectedOption) {
  setRouteOfAdministration(selectedOption)
}

function handleTiming(e) {
  setTiming(e.target.value)
}

function handleQuantity(selectedOption) {
  setQuantity(selectedOption)
}

function handleAreaOfApplication(e) {
  setAreaOfApplication(e.target.value)
}

function handleDiluent(selectedOption) {
  setDiluent(selectedOption)
}

function handleInfusionDuration(selectedOption) {
  setInfusionDuration(selectedOption)
}
function handleInfusionFrequency(selectedOption) {
  setInfusionFrequency(selectedOption)
}

function handleAdditives(e) {
  setAdditives(e.target.value)
}

// new input fields added functionality End ||

const [timeValues, setTimeValues] = useState(["morning"]);
            const [foodTiming, setFoodTiming] = useState("beforefood");

            // const handleFrequencyValue = (selectedOption) => {
            //   setMedicineDosageFrequency(selectedOption)
            //   // if(selectedOption == "1"){
            //   //   setMedicineDosageFrequency("1");
            //   // }else  if(selectedOption == "2"){
            //   //   setMedicineDosageFrequency("2");
            //   // }else  if(selectedOption == "3"){
            //   //   setMedicineDosageFrequency("3");
            //   // }else  if(selectedOption == "4"){
            //   //   setMedicineDosageFrequency("4");
            //   // }
            // };

            const isChatbotAllowed = () => {
  const subscriptionName = localStorage.getItem("subscriptionName");
  const subscriptionEndDate = localStorage.getItem("subscriptionEndDate");
  
  // If either value is missing, assume chatbot is allowed (or you can handle differently)
  if (!subscriptionName || !subscriptionEndDate) return true;
  
  // Check if subscription is Basic and end date has passed
  const currentDate = new Date();
  const endDate = new Date(subscriptionEndDate);
  
  // return !(subscriptionName === "Basic");
  return !(subscriptionName === "Basic" && currentDate > endDate);
};

// const activeTranscriber = useGPUTranscriber();
//Remove speech and keep Null to toggle between GPU and Speech
const { transcriber: activeTranscriber, mode } =
  useHybridTranscriber("speech", (text) => {
    // called when speech recognition finishes
    setPlaceholder(text || "");
    setTyping(false);
});

  const [typing, setTyping] = useState(false); // Typing indicator state
  const [HPITextBox, SetHPITextBox] = useState("");

  const [placeholder, setPlaceholder] = useState(
    // "Click anywhere to start typing...."
    "Instructions"
  );

  useEffect(() => {
      // console.log("triggered");
      if (activeTranscriber?.output?.text) {
        setValue("textField", activeTranscriber.output.text);
  
        handleNewMedicineChange("custommessage", activeTranscriber.output.text);
        // setPlaceholder("Click anywhere to start typing....");
        setPlaceholder("Instructions");
        setTyping(false);
      }
    }, [activeTranscriber?.output]);

//   useEffect(() => {
//   if (activeTranscriber?.output?.text) {
//     // Update both state and form value
//     setEditMedicine(prev => ({
//       ...prev,
//       custommessage: (prev.custommessage || "") + activeTranscriber.output.text
//     }));
//     setValue("textField", (editMedicine.custommessage || "") + activeTranscriber.output.text);
//     setPlaceholder("Instructions");
//     setTyping(false);
//   }
// }, [activeTranscriber?.output]);

useEffect(() => {
  if (activeTranscriber?.output?.text) {
    const newText = activeTranscriber.output.text;

    setEditMedicine(prev => ({
      ...(prev || {}),
      custommessage: newText
    }));

    try {
      setValue("textField", newText);
    } catch (e) {
      console.warn("setValue unavailable while updating transcribed text", e);
    }

    // don't delete this
    // setEditMedicine(prev => {
    //   const prevCustom = (prev && prev.custommessage) ? prev.custommessage : "";
    //   const updatedCustom = prevCustom + newText;

    //   try {
    //     setValue("textField", updatedCustom);
    //   } catch (e) {
    //     console.warn("setValue unavailable while updating transcribed text", e);
    //   }

    //   return {
    //     ...(prev || {}),
    //     custommessage: updatedCustom,
    //   };
    // });

    setPlaceholder("Instructions");
    setTyping(false);
  }
}, [activeTranscriber?.output]);

      const textFieldValue = watch("textField", "");
        const [isButtonDisabled, setIsButtonDisabled] = useState(false);
        const [initialText, setInitialText] = useState("");
    
      const onSubmit = (data) => {
          setIsButtonDisabled(true); // Disable button on submit
          // UpdateHpiTextBox(data);
          SetHPITextBox(data);
          // fetchDoctorNotesEmptyIndication();
        };
      
         // submit on tab switch and submit button is enalbed
          useEffect(()=>{
              if(!isButtonDisabled){
              handleSubmit(onSubmit)();
              }
          },[])
      
        useEffect(() => {
          if (textFieldValue !== initialText) {
            setIsButtonDisabled(false); // Enable button if text field value changes
          } else {
            setIsButtonDisabled(true); // Disable button if text field value is unchanged
          }
        }, [textFieldValue, initialText]);

  const correctOrders = async (formType) => {
      // const currentText = watch("textField");
      const currentText = formType === "edit" 
    ? editMedicine.custommessage 
    : newMedicine.custommessage;
      
      if (!currentText) {
        showErrorToast("No text available to correct");
        return;
      }
  
      const inputToSave = {
        input: {
          text: currentText,
          // type: `medicine_instructions#ayurvedic, Psychiatry#Consultation Note#99#hindi#arabic`,
        },
      };
  
      showLoader();
      try {
        // const result = await CorrectMedicalTermsUsingAI(inputToSave);
        const result = await CorrectInstructionsUsingAI(inputToSave.input);
        if (result) {
          showSuccessToast("Updated Text");
          const updatedText = result?.text;

          if (formType === "edit") {
        // For edit modal
        setEditMedicine(prev => ({
          ...prev,
          custommessage: updatedText
        }));
      } else {
        // For add modal
        handleNewMedicineChange("custommessage", updatedText);
      }
  
      // handleNewMedicineChange("custommessage", updatedText);
          // setValue("textField", updatedText, {
          //   shouldDirty: true,
          //   shouldTouch: true,
          //   shouldValidate: true,
          // });
          
      console.log('updatedText: ', updatedText)
          
      setValue("textField", result.text);
      setInstructions(updatedText);
      setIsAICorrected(true);
          
          // Update the appropriate state based on form type
          // if (formType === "add") {
          //   handleNewMedicineChange("custommessage", updatedText);
          // } else if(formType === "currentedit") {
          //   handleEditCurrentMedicineChange("custommessage", updatedText);
          // } else {
          //   handleEditMedicineChange("custommessage", updatedText);
          // }
          
          setIsButtonDisabled(false);
        }
      } catch (error) {
        console.error("Error in Correct AI call:", error);
        showErrorToast("Error Happened While Correcting.");
      } finally {
        dismissLoader();
      }
  };

      const [editMedicine, setEditMedicine] = useState(null);
    const editMedication = useRef();
    const [medicineList, setMedicineList] = useState([]);
        const [showMedicineNamesDropdown, setShowMedicineNamesDropdown] =
          useState(-1);
        const [focusedItemIndex, setFocusedItemIndex] = useState(-1);
        const suggestionsMenuRef = useRef(null);
        const [key, setKey] = useState(0); // to rerender the composition input box
            const [compositionEditKey, setCompositionEditKey] = useState(0); // to rerender the composition input box

            const handleIntervalChange = (value) => {
      handleEditMedicineChange("durationunit", value);
      // Update the combined duration string
      handleEditMedicineChange("duration", `${editMedicine.durationvalue} ${value}`);
    };
    
    const handleIntervalValueChange = (e) => {
      const value = parseInt(e.target.value, 10);
      const cleanValue = isNaN(value) ? "" : value;
      handleEditMedicineChange("durationvalue", cleanValue);
      // Update the combined duration string
      handleEditMedicineChange("duration", `${cleanValue} ${editMedicine.durationunit}`);
    };

        const handleEditKeyDown = (e, index) => {
      if (e.key === "ArrowDown") {
        setFocusedItemIndex(
          (prevIndex) => (prevIndex + 1) % suggestions.length
        );
        const itemHeight =
          suggestionsMenuRef.current?.children[0]?.clientHeight || 0;
        if (suggestionsMenuRef.current) {
          suggestionsMenuRef.current.scrollTop = focusedItemIndex * itemHeight;
        }
      } else if (e.key === "ArrowUp") {
        setFocusedItemIndex((prevIndex) =>
          prevIndex === 0 ? suggestions.length - 1 : prevIndex - 1
        );
        const itemHeight =
          suggestionsMenuRef.current?.children[0]?.clientHeight || 0;
        if (suggestionsMenuRef.current) {
          suggestionsMenuRef.current.scrollTop = focusedItemIndex * itemHeight;
        }
      } else if (e.key === "Enter" && focusedItemIndex !== -1) {
        const selectedItem = suggestions[focusedItemIndex];
        handleEditSelect(selectedItem, index);
      }
    };

    // existing
     const handleEditSelect = (suggestion, index) => {
      // handleEditMedicineChange(
      //   "medicinename",
      //   suggestion.productname + " (" + suggestion.remainingquantity + " Qty)"
      // );
      handleEditMedicineChange("medicinename", suggestion.productname);
      handleEditMedicineChange("inventoryid", suggestion.inventoryid);
      setSuggestions([]);
      setBoolValForSuggestions(!boolValForSuggestions);
      setShowMedicineNamesDropdown(-1);
    };

    const handleEditSelectIPD = (suggestion) => {
  setEditMedicine(prev => ({
    ...prev,
    medicinename: suggestion.medicinename,
    medicineId: suggestion.id,
    medicinetype: suggestion.medicinetype || "Tablet",
    dosage: suggestion.dosage || "",
    dosageunit: suggestion.dosageunit || "mg",
    frequency: suggestion.frequency || 1,
    frequencytime: suggestion.frequencytime || "",
    frequencyvalue: suggestion.frequencyvalue || "",
    morning: suggestion.morning || 0,
    afternoon: suggestion.afternoon || 0,
    evening: suggestion.evening || 0,
    night: suggestion.night || 0,
    beforefood: suggestion.beforefood || 0,
    afterfood: suggestion.afterfood || 0,
    drugclass: suggestion.drugclass || "",
    therapeutic: suggestion.therapeutic || "",
    manufacturer: suggestion.manufacturer || "",
    composition: suggestion.chemicalcomposition || "",
    custommessage: suggestion.instructions || "",
    duration: suggestion.duration || "5 Days",
    durationvalue: suggestion.duration ? parseInt(suggestion.duration.split(' ')[0]) : 5,
    durationunit: suggestion.duration ? suggestion.duration.split(' ')[1] : "Days",
    medicationstartdate: suggestion.medicationstartdate 
      ? moment(suggestion.medicationstartdate).format("DD-MM-YYYY")
      : moment().format("DD-MM-YYYY"),
    medicationenddate: suggestion.medicationenddate 
      ? moment(suggestion.medicationenddate).format("DD-MM-YYYY")
      : moment().add(5, "days").format("DD-MM-YYYY")
  }));
  
  setSuggestions([]);
  setShowMedicineNamesDropdown(-1);
};

    const filterMedicineNames = (medicine) => {
      const filtered = medicineList.filter((obj) =>
        obj.productname?.toLowerCase().includes(medicine.toLowerCase())
      );
      setSuggestions(filtered);
      setBoolValForSuggestions(!boolValForSuggestions);
    };


  const handleEditMedicine = (medicine) => {
      console.log('medication details: ', medicine)
      // setEditMedicine(medicine);
      // Initialize doctor state from the medicine data
  setDoctorid(medicine.updatedbydoctor || null);

      // Split duration into value and unit
    let durationValue = '';
    let durationUnit = 'Days'; // default unit
    
    if (medicine.duration) {
      console.log('duration', duration)
      const durationParts = medicine.duration.split(' ');
      console.log('durationParts', durationParts)
      if (durationParts.length === 2) {
        durationValue = durationParts[0];
        console.log('durationValue', durationValue)
        durationUnit = durationParts[1];
        console.log('durationUnit', durationUnit)
      } else if (medicine.duration.match(/^\d+$/)) {
            // If only number is provided
            durationValue = medicine.duration;
        }
    }

    // Initialize dropdown state if medicine type is in additional types
  if (additionalMedicineTypes.includes(medicine.medicinetype)) {
    setDropdownMedType(medicine.medicinetype);
  } else {
    setDropdownMedType("");
  }

  const updatedDate = medicine.updateddate ? new Date(medicine.updateddate) : new Date();
  const formattedDate = moment(updatedDate).format("DD-MM-YYYY");
  const formattedTime = moment(updatedDate).format("HH:mm");

      // Convert ISO dates to DD-MM-YYYY format
       const formattedMedicine = {
        ...medicine,
        custommessage: medicine.custommessage || "",
        durationvalue: durationValue,
        durationunit: durationUnit,
        medicationstartdate: medicine.medicationstartdate 
            ? moment(medicine.medicationstartdate).format("DD-MM-YYYY")
            : moment().format("DD-MM-YYYY"),
        medicationenddate: medicine.medicationenddate 
            ? moment(medicine.medicationenddate).format("DD-MM-YYYY")
            : moment().add(5, 'days').format("DD-MM-YYYY"),
        frequencytime: medicine.frequencytime || "",
        frequencyvalue: medicine.frequencyvalue || "",
        custommessage: medicine.custommessage || "",
        doctor: medicine.doctorname || "",
        // updateddate: medicine.updateddate || ""
        updateddate: formattedDate,
    updatedtime: formattedTime
    };

    setEditMedicine(formattedMedicine);
    setValue("textField", formattedMedicine.custommessage);

    // Fetch doctors when opening edit modal
  fetchDoctors().then(() => {
    // Set default doctor after doctors are fetched
    if (medicine.doctorname) {
      const doctorObj = DoctorList.find(d => d.fullname === medicine.doctorname);
      if (doctorObj) {
        setDoctorid(doctorObj.doctorid);
        setDefaultDoctor(doctorObj.fullname);
      }
    }
  });

      editMedication.current.openModal();
      // setEditMedicine({
      //   ...medicine,
      //   frequencytime: medicine.frequencytime || "",
      //   frequencyvalue: medicine.frequencyvalue || "",
      // });
   };

   const handleEditMedicineChange = (field, value) => {
      setEditMedicine((prev) => ({ ...prev, [field]: value }));
    };

    // existing
    //  const fetchCompositionForEdit = async (medicineName) => {
    //       if (!medicineName) {
    //         showErrorToast("Please enter medicine name first to fetch composition");
    //       } else {
    //         const inputData = {
    //           input: {
    //             name: medicineName,
    //           },
    //         };
    
    //         // console.log(inputData.input);
    
    //         try {
    //           // showLoader();
    //           // console.log(inputData);
    //           const result = await GetAIMedicineComposition(inputData.input);
    //           // console.log(result);
    //           if (result) {
    //             showSuccessToast("Fetched Medicine composition successfully");
    //             handleEditMedicineChange(
    //               "composition",
    //               result.chemical_composition
    //             );
    //             // handleEditMedicineChange(
    //             //   "manufacturer",
    //             //   result.Manufacturer
    //             // );
    //             // handleEditMedicineChange(
    //             //   "therapeutic",
    //             //   result.TherapeuticCategory
    //             // );
    //             // handleEditMedicineChange(
    //             //   "drugclass",
    //             //   result.DrugClass
    //             // );
    //             if (Array.isArray(result.Manufacturer)) {
    //           handleEditMedicineChange("manufacturer", result.Manufacturer.join(", "));
    //         } else {
    //           handleEditMedicineChange("manufacturer", result.Manufacturer || ""); 
    //         }
    //         if (Array.isArray(result.TherapeuticCategory)) {
    //           handleEditMedicineChange("therapeutic", result.TherapeuticCategory.join(", "));
    //         } else {
    //           handleEditMedicineChange("therapeutic", result.TherapeuticCategory || "");
    //         }
    //         if (Array.isArray(result.DrugClass)) {
    //           handleEditMedicineChange("drugclass", result.DrugClass.join(", "));
    //         } else {
    //           handleEditMedicineChange("drugclass", result.DrugClass || ""); 
    //         }
    //             setCompositionEditKey((prevKey) => prevKey + 1);
    //             // handleNewMedicineChange("medicinetype", result.type);
                
    //           }
    //         } catch (error) {
    //           console.error("Error Fetching Medicine composition:", error);
    //           showErrorToast(
    //             "An error occurred while Fetching Medicine composition"
    //           );
    //         } finally {
    //           // dismissLoader();
    //         }
    
    //         // fetchDoctorNotes();
    
    //         // console.log("Clicked");
    //       }
    //     };

    const fetchCompositionForEdit = async (medicineName) => {
  if (!medicineName) {
    showErrorToast("Please enter medicine name first to fetch composition");
  } else {
    const inputData = {
      input: {
        name: medicineName,
      },
    };
    showLoader();
    try {
      const result = await GetAIMedicineComposition(inputData.input);
      if (result) {
        showSuccessToast("Fetched Medicine composition successfully");
        setEditMedicine(prev => ({
          ...prev,
          composition: result.chemical_composition,
          manufacturer: Array.isArray(result.Manufacturer) 
            ? result.Manufacturer.join(", ") 
            : result.Manufacturer || "",
          therapeutic: Array.isArray(result.TherapeuticCategory)
            ? result.TherapeuticCategory.join(", ")
            : result.TherapeuticCategory || "",
          drugclass: Array.isArray(result.DrugClass)
            ? result.DrugClass.join(", ")
            : result.DrugClass || "",
          custommessage: result.InstructionsOfAdministration || "",
          medicinetype: result.type || "Tablet"
        }));
        setCompositionEditKey((prevKey) => prevKey + 1);
      }
    } catch (error) {
      console.error("Error Fetching Medicine composition:", error);
      showErrorToast("An error occurred while Fetching Medicine composition");
    } finally {
      dismissLoader();
    }
  }
};


        const currentDay = moment().format("DD-MM-YYYY");
    const fiveDaysFromToday = moment().add(5, "days").format("DD-MM-YYYY");
  const [newMedicine, setNewMedicine] = useState({
        id: null,
        inventoryid: null,
        medicinename: "",
        manufacturer: "",
        drugclass: "",
        therapeutic: "",
        composition: "",
        medicinetype: "Tablet",
        dosage: "",
        dosageunit: "mg",
        medicationstartdate: currentDay, // SETTING DEFAULTS
        medicationenddate: fiveDaysFromToday, // SETTING DEFAULTS
        frequency: 1, // SETTING DEFAULTS
        frequencytime: "",
        frequencyvalue: "",
        morning: 1, // SETTING DEFAULTS
        afternoon: 0,
        evening: 0,
        night: 0,
        prescribedby: "",
        hospitalname: "",
        beforefood: 0, // SETTING DEFAULTS
        afterfood: 1,
        issaved: false,
  
        // new inputs
  
        frequencyduration: null,
        routeofadministration: null,
        timingofinjection: null,
        quantitytobeapplied: null,
        areaofapplication: null,
        diluent: null,
        additives: null,
  
        rateofinfusionvalue: null,
        rateofinfusionunit: "ml/hr",
        // duration: null,
        duration: "5 Days", // Set default duration value
    durationunit: "Days", // Add this new field
    durationvalue: 5, // Add this new field
  
        custommessage:null,
        sos:null
      });
  // const [medicinetype, setMedicineType] = useState(newMedicine.medicinetype || "Tablet");


const [dropdownMedType, setDropdownMedType] = useState("");
const additionalMedicineTypes = [
  "Respules",
  "Suspension",
  "Foam",
  "Suppository",
  "EA",
  "Device",
  // "Sachet",
  "Box",
  "Spray",
  "Lotion",
  "Tube",
  "Gargle",
  "Powder",
  "Soap",
  "Aerosol",
  "Shampoo",
  "Topical Cleanser",
  "Custom"
];
const handleEditTypeChange = (value) => {
  const finalValue = value === (editMedicine.medicinetype || dropdownMedType) ? "" : value;
  
  if (additionalMedicineTypes.includes(finalValue)) {
    setDropdownMedType(finalValue);
    handleEditMedicineChange("medicinetype", finalValue);
  } else {
    setDropdownMedType("");
    handleEditMedicineChange("medicinetype", finalValue);
  }

  // Set default dosage units
  if (["Syrup", "Drops", "Suspension", "Respules", "Gargle", "Shampoo", "Topical Cleanser"].includes(finalValue)) {
    handleEditMedicineChange("dosageunit", "ml");
  } else if (["Tablet", "Capsule", "Suppository", "Powder"].includes(finalValue)) {
    handleEditMedicineChange("dosageunit", "mg");
  } else if (["Injection", "Nebulization", "IVFluids"].includes(finalValue)) {
    handleEditMedicineChange("dosageunit", "ml");
  } else if (["Ointment", "Cream", "Gel", "Foam", "Lotion", "Tube", "Soap"].includes(finalValue)) {
    handleEditMedicineChange("dosageunit", "grms");
  } else if (["Inhaler", "Spray", "Aerosol"].includes(finalValue)) {
    handleEditMedicineChange("dosageunit", "puffs");
  } else if (["EA", "Device", "Box"].includes(finalValue)) {
    handleEditMedicineChange("dosageunit", "each");
  } else if (finalValue === "Sachet") {
    handleEditMedicineChange("dosageunit", "mg");
  } else if (finalValue === "Custom") {
    handleEditMedicineChange("dosageunit", "");
  }
};

const handleTypeChange = (value) => {
  const finalValue = value === dropdownMedType ? "" : value; // Toggle selection
  if (additionalMedicineTypes.includes(finalValue)) {
    setDropdownMedType(finalValue);
    setMedicineType("");
  } else {
    setMedicineType(finalValue);
    setDropdownMedType("");
  }
  
  handleNewMedicineChange("medicinetype", finalValue);

  // Set default dosage units
  if (["Syrup", "Drops", "Suspension", "Respules", "Gargle", "Shampoo", "Topical Cleanser"].includes(finalValue)) {
    handleNewMedicineChange("dosageunit", "ml");
  } else if (["Tablet", "Capsule", "Suppository", "Powder"].includes(finalValue)) {
    handleNewMedicineChange("dosageunit", "mg");
  } else if (["Injection", "Nebulization", "IVFluids"].includes(finalValue)) {
    handleNewMedicineChange("dosageunit", "ml");
  } else if (["Ointment", "Cream", "Gel", "Foam", "Lotion", "Tube", "Soap"].includes(finalValue)) {
    handleNewMedicineChange("dosageunit", "grms");
  } else if (["Inhaler", "Spray", "Aerosol"].includes(finalValue)) {
    handleNewMedicineChange("dosageunit", "puffs");
  } else if (["EA", "Device", "Box"].includes(finalValue)) {
    handleNewMedicineChange("dosageunit", "each");
  } else if (finalValue === "Sachet") {
    handleNewMedicineChange("dosageunit", "mg");
  } else if (finalValue === "Custom") {
    handleNewMedicineChange("dosageunit", "");
  }
};

      const handleNewMedicineChange = (field, value) => {
      setNewMedicine((prev) => ({ ...prev, [field]: value }));
    };

    const handleIntervalNewChange = (value) => {
      handleNewMedicineChange("durationunit", value);
      // Update the combined duration string
      handleNewMedicineChange("duration", `${newMedicine.durationvalue} ${value}`);
    };
    
    const handleIntervalNewValueChange = (e) => {
      const value = parseInt(e.target.value, 10);
      const cleanValue = isNaN(value) ? "" : value;
      handleNewMedicineChange("durationvalue", cleanValue);
      // Update the combined duration string
      handleNewMedicineChange("duration", `${cleanValue} ${newMedicine.durationunit}`);
    };

  //   const handleAddMedicine = () => {
  //     if (newMedicine.medicinename === "") {
  //       showErrorToast("Please enter medicine name to continue");
  //       return;
  //     }
  //     if (newMedicine.frequencytime && !newMedicine.frequencyvalue) {
  //       showErrorToast("Please select the Value when Frequency is selected");
  //       return;
  //     }
  //     // setSelectedMedicines((prev) => [...prev, newMedicine]);
  //     // DetectInteractionsUsingAI(newMedicine.medicinename);
  //     // setShowAddCard(false);
  //     // Reset the new medicine form
  //     setNewMedicine({
  //       id: null,
  //       inventoryid: null,
  //       medicinename: "",
  //       manufacturer: "",
  //       drugclass: "",
  //       therapeutic: "",
  //       composition: "",
  //       medicinetype: "Tablet",
  //       dosage: "",
  //       dosageunit: "mg",
  //       medicationstartdate: today, // SETTING DEFAULTS
  //       medicationenddate: fiveDaysFromToday, // SETTING DEFAULTS
  //       frequency: 1, // SETTING DEFAULTS
  //       frequencytime: "",
  //       frequencyvalue: '',
  //       morning: 1, // SETTING DEFAULTS
  //       afternoon: 0,
  //       evening: 0,
  //       night: 0,
  //       prescribedby: "",
  //       hospitalname: "",
  //       beforefood: 1, // SETTING DEFAULTS
  //       afterfood: 0,
  //       issaved: false,

  //       // new inputs

  //       frequencyduration: null,
  //       routeofadministration: null,
  //       timingofinjection: null,
  //       quantitytobeapplied: null,
  //       areaofapplication: null,
  //       diluent: null,
  //       additives: null,

  //       rateofinfusionvalue: null,
  //       rateofinfusionunit: "ml/hr",
  //       // duration: null,
  //       duration: "",
  //       // duration: durationvalue + durationunit, // Set default duration value
  // durationunit: "Days", // Add this new field
  // durationvalue: 5,

  //       custommessage:null,
  //     sos:null
  //     });

  //     addMedication.current.closeModal();

  //     // console.log(selectedMedicines);
  //   };

  //   const handleCancelAddMedicine = () => {
  //     // setShowAddCard(false);
  //     // Reset the new medicine form
  //     setNewMedicine({
  //       id: null,
  //       medicinename: "",
  //       manufacturer: "",
  //       drugclass: "",
  //       therapeutic: "",
  //       composition: "",
  //       medicinetype: "Tablet",
  //       dosage: "",
  //       dosageunit: "mg",
  //       medicationstartdate: today, // SETTING DEFAULTS
  //       medicationenddate: fiveDaysFromToday, // SETTING DEFAULTS
  //       frequency: 1, // SETTING DEFAULTS
  //       frequencytime: "",
  //       frequencyvalue: "",
  //       morning: 1, // SETTING DEFAULTS
  //       afternoon: 0,
  //       evening: 0,
  //       night: 0,
  //       prescribedby: "",
  //       hospitalname: "",
  //       beforefood: 1, // SETTING DEFAULTS
  //       afterfood: 0,
  //       issaved: false,

  //       // new inputs

  //       frequencyduration: null,
  //       routeofadministration: null,
  //       timingofinjection: null,
  //       quantitytobeapplied: null,
  //       areaofapplication: null,
  //       diluent: null,
  //       additives: null,

  //       rateofinfusionvalue: null,
  //       rateofinfusionunit: "ml/hr",
  //       // duration: null,
  //       duration: "5 Days", // Set default duration value
  // durationunit: "Days", // Add this new field
  // durationvalue: 5,

  //       custommessage:null,
  //     sos:null
  //     });

  //     addPrescriptionMedication.current.closeModal();

  //     // console.log(selectedMedicines);
  //   };


  function formatDateTime(isoString) {
  const date = new Date(isoString);

  // Check if the date is valid
  if (isNaN(date.getTime())) {
    return "Invalid Date";
  }

  // Format the day with ordinal suffix (e.g., 1st, 2nd, 3rd, 4th)
  const day = date.getDate();
  const dayWithSuffix = day + (
    (day % 10 === 1 && day !== 11) ? 'st' :
    (day % 10 === 2 && day !== 12) ? 'nd' :
    (day % 10 === 3 && day !== 13) ? 'rd' : 'th'
  );

  // Format the month name (e.g., June)
  const monthNames = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
  ];
  const monthName = monthNames[date.getMonth()];

  // Format the year
  const year = date.getFullYear();

  // Format the time in 12-hour with AM/PM
  let hours = date.getHours();
  const minutes = date.getMinutes().toString().padStart(2, '0');
  const ampm = hours >= 12 ? 'PM' : 'AM';
  hours = hours % 12 || 12; // Convert to 12-hour format

  // Combine everything
  return `${dayWithSuffix} ${monthName} ${year} at ${hours}:${minutes} ${ampm}`;
}

// --------------------- Date TIme & Doctor ------------------------------------
var [DoctorListForDropdown, setDoctorListForDropdown] = useState([]);
var [DoctorList, setDoctorList] = useState([]);
var [Doctorid, setDoctorid] = useState(null);
var [DefaultDoctor, setDefaultDoctor] = useState(null);

const [date, setDate] = useState(moment().format("DD-MM-yyyy"));
const [time, setTime] = useState(moment().format("HH:mm"));

const getLocalISOString = (dateStr, timeStr) => {
  // Parse the date in DD-MM-yyyy format
  const [day, month, year] = dateStr.split("-").map(Number);
  // Parse the time in HH:mm format
  const [hours, minutes] = timeStr.split(":").map(Number);
  
  // Create a Date object in local timezone
  const dateObj = new Date(year, month - 1, day, hours, minutes, 0);
  
  // Format to ISO string with local timezone offset
  const timezoneOffset = dateObj.getTimezoneOffset() * 60000; // offset in milliseconds
  const localISOTime = new Date(dateObj - timezoneOffset).toISOString().slice(0, 19).replace('Z', '');
  
  return localISOTime;
};

const handledatechange = (selectedDate) => {
  const formattedDate = moment(selectedDate).format("DD-MM-yyyy");
  setDate(formattedDate);
};

const handleTimeChange = (event) => {
    const inputTime = event.target.value;
    const currentDate = moment().format("DD-MM-yyyy");
    const currentTime = moment().format("HH:mm");
    
    // Only validate if the selected date is today
    if (date === currentDate) {
      const [inputHours, inputMinutes] = inputTime.split(":").map(Number);
      const [currentHours, currentMinutes] = currentTime.split(":").map(Number);
  
      // Create moment objects for comparison
      const inputMoment = moment().set({
        hour: inputHours,
        minute: inputMinutes,
        second: 0,
        millisecond: 0
      });
      
      const currentMoment = moment();
  
      if (inputMoment.isAfter(currentMoment)) {
        setTime(currentTime);
        showErrorToast("Future time cannot be selected.");
        return;
      }
    }
    
    // If date is not today or time is not in future, update the time
    setTime(inputTime);
  };

  // existing function
// const handleTimeChange = (event) => {
//   const inputTime = event.target.value;
//   const currentTime = new Date();
//   const [inputHours, inputMinutes] = inputTime.split(":").map(Number);

//   const inputDate = new Date();
//   inputDate.setHours(inputHours);
//   inputDate.setMinutes(inputMinutes);

//   if (inputDate > currentTime) {
//     const currentFormattedTime = moment().format("HH:mm");
//     setTime(currentFormattedTime);
//     showErrorToast("Future time cannot be selected.");
//   } else {
//     setTime(inputTime);
//   }
// };

const fetchDoctors = async () => {
    showLoader();
    try {
      // const result = await FetchDoctorsByUser({
      const result = await FetchUsersByClinic({
        // doctorid,
        appointmentid: apmtIdUrl,
      });

      // console.log('resultofDoctors: ', result)
      if (result.output.result == "success") {
        console.log('result.outptu.data: ', result.output.data)
        setDoctorList(result.output.data);
        const Doctors = result.output.data && result.output.data.map((step) => [
          step.fullname
        ]);
        console.log('Doctors: ', Doctors)
        setDoctorListForDropdown(Doctors);
        const currentdoctor = getIsDoctor();
        console.log('currentdoctor: ', currentdoctor)
        const loginid = getLoginID();
        console.log('getLogin: ', loginid)
        
        let obj = {}
        if (currentdoctor == 1 && currentdoctor != null) {
          obj = result.output.data && result.output.data.filter(doctor => doctor.doctorid == loginid);
          if (obj[0]) {
            console.log('obj[0]: ', obj[0].fullname)
            setDefaultDoctor(obj[0].fullname)
            setDoctorid(loginid)
          }

        } else {
          setDefaultDoctor("");
        }
      } else {
        setDoctorList([]);
        dismissLoader();
      }
      dismissLoader();
    } catch (error) {
      console.error("Error", error);
    }
  };

const HandleEditDoctor = (selectedOption) => {
    let obj = DoctorList.filter(doctor => doctor.fullname == selectedOption);
    // setDoctorid(obj[0].doctorid)
    if (obj.length > 0) {
    setDoctorid(obj[0].doctorid);
    // setSelectedDoctorId(obj[0].doctorid); // Store the selected doctor ID
    setDefaultDoctor(obj[0].fullname);
  }
  }

// ---------------- Serach by filter medicine ---------------------
// Add this state
const [medicineSearchTerm, setMedicineSearchTerm] = useState("");
const [isSearching, setIsSearching] = useState(false);
const [focusedInput, setFocusedInput] = useState(null);
const medicineNameRef = useRef(null);

const handleInputFocus = (inputName) => {
  setFocusedInput(inputName);
};

// Add this function for API search
const searchMedicines = async (searchTerm) => {
  try {
    setIsSearching(true);
    const result = await FetchTransferMedicineList({
      // doctorid,
      type: "catalog",
      "medicinename": searchTerm 
    });
    
    if (result.output.data?.length > 0) {
      setSuggestions(result.output.data);
    } else {
      setSuggestions([]);
    }
  } catch (error) {
    console.error("Error searching medicines:", error);
    setSuggestions([]);
  } finally {
    setIsSearching(false);
  }
};

// Modify the handleNewMedicineChange function
const handleNewMedicineChangeIPD = (field, value) => {
  setNewMedicine((prev) => ({ ...prev, [field]: value }));
  // setMedicineSearchTerm(value);
  
  // Only search if 3+ characters
  // if (value.length >= 3) {
  //   searchMedicines(value);
  //   setShowMedicineNamesDropdown(1);
  // } else {
  //   setSuggestions([]);
  //   setShowMedicineNamesDropdown(-1);
  // }

  if (field === "medicinename") {
    setMedicineSearchTerm(value);
    if (value.length >= 3) {
      searchMedicines(value);
      setShowMedicineNamesDropdown(1);
    } else {
      setSuggestions([]);
      setShowMedicineNamesDropdown(-1);
    }
  }
};

// Modify the handleSelect function
const handleSelectIPD = (suggestion) => {
  // setNewMedicine(prev => ({
  //   ...prev,
  //   medicinename: suggestion.medicinename,
  //   medicineId: suggestion.id, // or whatever ID field you need
  //   // dosage: suggestion.dosage,
  //   // dosageunit: suggestion.dosageunit,
  //   // medicinetype: suggestion.medicinetype
  // }));
  setNewMedicine(prev => ({
    ...prev,
    medicinename: suggestion.medicinename,
    medicineId: suggestion.id,
    medicinetype: suggestion.medicinetype || "Tablet", // Default to Tablet if not specified
    dosage: suggestion.dosage || "",
    dosageunit: suggestion.dosageunit || "mg",
    frequency: suggestion.frequency || 1,
    frequencytime: suggestion.frequencytime || "",
    frequencyvalue: suggestion.frequencyvalue || "",
    morning: suggestion.morning || 0,
    afternoon: suggestion.afternoon || 0,
    evening: suggestion.evening || 0,
    night: suggestion.night || 0,
    beforefood: suggestion.beforefood || 0,
    afterfood: suggestion.afterfood || 0,
    drugclass: suggestion.drugclass || "",
    therapeutic: suggestion.therapeutic || "",
    manufacturer: suggestion.manufacturer || "",
    composition: suggestion.chemicalcomposition || "",
    custommessage: suggestion.instructions || "",
    duration: suggestion.duration || "5 Days",
    // Parse duration into value and unit if available
    durationvalue: suggestion.duration ? parseInt(suggestion.duration.split(' ')[0]) : 5,
    durationunit: suggestion.duration ? suggestion.duration.split(' ')[1] : "Days",
    // Parse dates if available
    medicationstartdate: suggestion.medicationstartdate 
      ? moment(suggestion.medicationstartdate).format("DD-MM-YYYY") 
      : moment().format("DD-MM-YYYY"),
    medicationenddate: suggestion.medicationenddate 
      ? moment(suggestion.medicationenddate).format("DD-MM-YYYY") 
      : moment().add(5, "days").format("DD-MM-YYYY")
  }));
  setSuggestions([]);
  setShowMedicineNamesDropdown(-1);
};
  return (
    <>
    {isLoading && <Loader />}
      <Box w="100%">
        <Box>
        {/* <Flex> */}
        <Box pos='sticky' p='1rem 1.5rem' alignItems='center' top='0' zIndex='999' bg='white' borderBottom='1px solid #E6E7E9' display="flex" justifyContent="space-between" mb="10px">
            <Text fontWeight='600'>Medications</Text>
            <PrimaryButton
              fontSize="14px"
              variant="mdBtn"
              btnIcon="/assets/imgs/add.png"
              buttonText="Add Medication"
              onClick={addData}
              isDisabled={actionAccessPatients?.create ? false : true}
            />
          </Box>

            <Box p="2px" pb="0" display="flex" justifyContent="start">
              {/* <FilterButton
                tabs={["All", "Tablet", "Syrup"]}
                onClick={(label) => handlefilterswitch(label)}
              /> */}
            </Box>

            <Stepper
                        orientation="vertical"
                        // height="400px"
                        height='calc(100vh - 160px)'
                        overflow='hidden auto'
                        padding='1rem'
                        size="xs"
                        colorScheme="#CDCFD4"
                        // gap="0"
                        gap="1rem"
                        w="100%"
                         justifyContent='flex-start'
                      >
            {data && data != null ? (
              // <Flex
              //   wrap="wrap"
              //   w="100%"
              //   justifyContent="left"
              //   alignContent="flex-start"
              //   gap="20px"
              //   h='calc(100vh - 160px)' 
              //   overflow='hidden auto'  
              //   padding='1rem 1.5rem'
              // >
                filteredData.length > 0  ? (
                    filteredData.map((medicine, index) => (
                      <Step w="100%" flex='unset' key={index}>
                                      <StepIndicator color="#E6E7E9" />
                        
                                      <Box flexShrink="0" w="95%">
                                        <StepTitle as="div">
                                          {/* 10th Jan, 2024 */}
                                          <Text fontWeight='600' fontSize="0.875rem" color="#384052" mb="0.5rem">
                                            {/* {formatDate(medicine.medicationstartdate)} */}
                                            {formatDateTime(medicine?.updateddate ? medicine.updateddate : medicine.createddate)}
                                            </Text>
                                          
                                        </StepTitle>
                                        <StepDescription
                                          bg="white"
                                          w="100%"
                                          border="1px solid #E6E7E9"
                                          borderRadius="0.65rem"
                                          p="0.75rem"
                                        >
                                          {/* <Text fontWeight='600' fontSize="0.875rem" color="#384052" mb="0.5rem">{`${medicine.doctorname} , ${medicine.bookingid}`}</Text>
                                          <Text fontSize="0.875rem" color="#384052" mb="0.5rem">{medicine.specialization}</Text> */}

                                  <Box key={index} width='100%' >
                                    <Box
                                      display="flex"
                                      alignItems="center"
                                      justifyContent="space-between"
                                      p="10px"
                                      border="1px solid gray"
                                      borderRadius="10px"
                                      width="100%"
                                    >
                                      {/* {screenType !== "mobile" && ( */}
                                        <>
                                          <Box width="52%">
                                            <Box fontWeight={"semibold"}>
                                              {medicine.medicinename} (
                                              {medicine.dosage ? (
                                                <>
                                                  {medicine.dosage} {medicine.dosageunit}
                                                </>
                                              ) : (
                                                <>-/- {medicine.dosageunit}</>
                                              )}
                                              )
                                              <Box
                                                display="inline-block"
                                                verticalAlign="bottom"
                                                fontSize="10px"
                                                fontWeight="600"
                                                bg="#E6E7E966"
                                                border="1px solid #E6E7E9"
                                                p="5px 10px"
                                                borderRadius="full"
                                                w="fit-content"
                                                whiteSpace="nowrap"
                                                overflow="hidden"
                                                textOverflow="ellipsis"
                                              >
                                                {medicine.medicinetype
                                                  ? medicine.medicinetype
                                                  : "-"}
                                              </Box>
                                              <Box
                                                display="inline-block"
                                                verticalAlign="bottom"
                                                fontSize="10px"
                                                fontWeight="600"
                                                // bg="#E6E7E966"
                                                bg="#73FF99"
                                                border="1px solid #E6E7E9"
                                                p="5px 10px"
                                                borderRadius="full"
                                                w="fit-content"
                                                whiteSpace="nowrap"
                                                overflow="hidden"
                                                textOverflow="ellipsis"
                                              >
                                                Prescribed
                                              </Box>
                                            </Box>
                                            <Box width="80%" title={medicine.chemicalcomposition} isTruncated fontSize={"xs"}>
                                              Composition: {medicine.chemicalcomposition}
                                            </Box>
                                          </Box>
                                          {medicine.frequencytime && medicine.frequencyvalue ? (
                                             <Box width="10%">
                                             {medicine.frequencytime} {medicine.frequencyvalue}
                                           </Box>
                                          ):(
                                            <Box width="8%">
                                            {medicine.morning}-{medicine.afternoon}-
                                            {medicine.night}
                                          </Box>
                                          )}
                                         
                                          <Box width="30%">
                                            {medicine.beforefood === 1 &&
                                              medicine.afterfood === 1 && (
                                                <>Before & After Food</>
                                              )}
                                            {medicine.beforefood === 1 &&
                                              (medicine.afterfood === 0 ||
                                                medicine.afterfood === null) && (
                                                <>Before Food</>
                                              )}
                                            {(medicine.beforefood === 0 ||
                                              medicine.beforefood === null) &&
                                              medicine.afterfood === 1 && <>After Food</>}{" "}
                                            {(medicine.beforefood === 1 ||
                                              medicine.afterfood === 1) &&
                                              medicine.frequency &&
                                              "- "}
                                            {medicine.frequency &&
                                              `${medicine.frequency} Qty`}

                                              {medicine.duration && (
                                        <> • {medicine.duration}</>
                                            )}
                                          </Box>
                                          <Box display="flex" alignItems="center" width="20%">
                                          <Box
                                          as="button"
                                          border="1px solid #E6E7E9"
                                          borderRadius="full"
                                          w="36px"
                                          h="auto"
                                          p="10px"
                                          display="flex"
                                          justifyContent="center"
                                          alignItems="center"
                                          onClick={isChatbotAllowed() ? () => fetchAiDoctorPrompts(medicine.medicinename) : null}
                                          cursor={isChatbotAllowed() ? "pointer" : "not-allowed"}
                                          opacity={isChatbotAllowed() ? 1 : 0.5}
                                          bg={isChatbotAllowed() ? "transparent" : "gray.100"}
                                          _hover={
                                            isChatbotAllowed() 
                                              ? { bg: "gray.50", borderColor: "gray.300" } 
                                              : {}
                                          }
                                          title={
                                            !isChatbotAllowed() 
                                              ? "Please upgrade your subscription to use AI features" 
                                              : "Get AI suggestions"
                                          }
                                        >
                                          <Image 
                                            w="26px" 
                                            src="/assets/svgs/ai-star-outline.svg" 
                                            opacity={isChatbotAllowed() ? 1 : 0.5}
                                            filter={!isChatbotAllowed() ? "grayscale(100%)" : "none"}
                                          />
                                        </Box>
                                            <Box
                                              as="button"
                                              border="1px solid #E6E7E9"
                                              borderRadius="full"
                                              w="36px"
                                              h="auto"
                                              p="10px"
                                              ml="10px"
                                              onClick={() => handleEditMedicine(medicine)}
                                            >
                                              <Image
                                                w="13px"
                                                src="/assets/svgs/edit-gray.svg"
                                              />
                                            </Box>
                                            <Box
                                              as="button"
                                              border="1px solid #E6E7E9"
                                              borderRadius="full"
                                              w="36px"
                                              h="auto"
                                              p="10px"
                                              ml="10px"
                                              // onClick={() => handleDeleteMedicine(medicine)}
                                              onClick={() =>
                                                DeleteMedicineModel(
                                                  medicine && medicine.medicinename,
                                                  medicine && medicine.id
                                                )
                                              }
                                            >
                                              <Image w="13px" src="/assets/imgs/delete.png" />
                                            </Box>
                                          </Box>
                                        </>
                                      {/* )} */}
                
                                      {/* {screenType == "mobile" && (
                                        <>
                                          <Box width="100%">
                                            <Box fontWeight={"semibold"}>
                                              {medicine.medicinename} ({medicine.dosage}
                                              {medicine.dosageunit}){" "}
                                              <Box
                                                display="inline-block"
                                                verticalAlign="bottom"
                                                fontSize="10px"
                                                fontWeight="600"
                                                bg="#E6E7E966"
                                                border="1px solid #E6E7E9"
                                                p="5px 10px"
                                                borderRadius="full"
                                                w="fit-content"
                                                whiteSpace="nowrap"
                                                overflow="hidden"
                                                textOverflow="ellipsis"
                                              >
                                                {medicine.medicinetype
                                                  ? medicine.medicinetype
                                                  : "-"}
                                              </Box>
                                            </Box>
                                            <Box fontSize={"xs"}>
                                              Composition: {medicine.composition}
                                            </Box>
                                          </Box>
                                          <Box
                                            display="flex"
                                            w="100%"
                                            flexDir="column"
                                            gap="10px"
                                          >
                                            <Box width="100%">
                                              {medicine.morning}-{medicine.afternoon}-
                                              {medicine.night}
                                            </Box>
                                            <Box width="100%">
                                              {medicine.beforefood === 1 &&
                                                medicine.afterfood === 1 && (
                                                  <>Before & After Food</>
                                                )}
                                              {medicine.beforefood === 1 &&
                                                (medicine.afterfood === 0 ||
                                                  medicine.afterfood === null) && (
                                                  <>Before Food</>
                                                )}
                                              {(medicine.beforefood === 0 ||
                                                medicine.beforefood === null) &&
                                                medicine.afterfood === 1 && (
                                                  <>After Food</>
                                                )}{" "}
                                              {(medicine.beforefood === 1 ||
                                                medicine.afterfood === 1) &&
                                                medicine.frequency &&
                                                "-"}
                                              {medicine.frequency &&
                                                `${medicine.frequency} x per day`}
                                            </Box>
                                            <Box
                                              display="flex"
                                              alignItems="center"
                                              width="100%"
                                            >
                                                                      <Box
                                          as="button"
                                          border="1px solid #E6E7E9"
                                          borderRadius="full"
                                          w="36px"
                                          h="auto"
                                          p="10px"
                                          display="flex"
                                          justifyContent="center"
                                          alignItems="center"
                                          onClick={isChatbotAllowed() ? () => fetchAiDoctorPrompts(medicine.medicinename) : null}
                                          cursor={isChatbotAllowed() ? "pointer" : "not-allowed"}
                                          opacity={isChatbotAllowed() ? 1 : 0.5}
                                          bg={isChatbotAllowed() ? "transparent" : "gray.100"}
                                          _hover={
                                            isChatbotAllowed() 
                                              ? { bg: "gray.50", borderColor: "gray.300" } 
                                              : {}
                                          }
                                          title={
                                            !isChatbotAllowed() 
                                              ? "Please upgrade your subscription to use AI features" 
                                              : "Get AI suggestions"
                                          }
                                        >
                                          <Image 
                                            w="26px" 
                                            src="/assets/svgs/ai-star-outline.svg" 
                                            opacity={isChatbotAllowed() ? 1 : 0.5}
                                            filter={!isChatbotAllowed() ? "grayscale(100%)" : "none"}
                                          />
                                        </Box>
                                              <Box
                                                as="button"
                                                border="1px solid #E6E7E9"
                                                borderRadius="full"
                                                w="36px"
                                                h="auto"
                                                p="10px"
                                                ml="10px"
                                                onClick={() => handleEditMedicine(medicine)}
                                              >
                                                <Image
                                                  w="13px"
                                                  src="/assets/svgs/edit-gray.svg"
                                                />
                                              </Box>
                                              <Box
                                                as="button"
                                                border="1px solid #E6E7E9"
                                                borderRadius="full"
                                                w="36px"
                                                h="auto"
                                                p="10px"
                                                ml="10px"
                                                onClick={() => handleDeleteMedicine(medicine)}
                                              >
                                                <Image w="13px" src="/assets/imgs/delete.png" />
                                              </Box>
                                            </Box>
                                          </Box>
                                        </>
                                      )} */}
                                    </Box>
                                  </Box>
                                          </StepDescription>
                                                          </Box>
                                                      <StepSeparator colorScheme="red" />
                                            
                                                        </Step>
                                ))
                                ) : (
                  <Box
                  w="100%"
                  display="flex"
                  flexDirection="column"
                  gap="5px"
                  justifyContent="center"
                  alignItems="center"
                  h="100%"
                >
                  <Image display='flex' alignItems='center' w="36px" src="/assets/svgs/medication-nodata.svg" />
                  <Box as="p">No data available</Box>
                  
                </Box>
                )
            ) : (
              <Box
                w="100%"
                mt="100px"
                display="flex"
                flexDirection="column"
                gap="5px"
                justifyContent="center"
                alignItems="center"
                h="100%"
              >
                <Image w="60px" src="/assets/svgs/medication-nodata.svg" />
                <Box as="p">No data available</Box>
                {/* <PrimaryButton
                  fontSize="14px"
                  variant="mdBtn"
                  buttonText="Add Medication"
                  btnIcon="/assets/imgs/add.png"
                  onClick={addData}
                /> */}
              </Box>
            )}

                      </Stepper>
          </Box>
        {/* </Flex> */}
      </Box>

      <ModalRight
        ref={detailsmodel}
        //header="Medicine details"
        bodyStyle={{ p: "24px 32px" }}
        modalWidth="360px"
        body={
          <>
            <Flex flexDir="column">
              <Box w="100%" mb="15px">
                <Box
                  fontSize="10px"
                  fontWeight="600"
                  bg="#E6E7E966"
                  border="1px solid #E6E7E9"
                  p="5px 10px"
                  borderRadius="full"
                  w="fit-content"
                >
                  {medicinedata && medicinedata.medicinetype
                    ? medicinedata.medicinetype
                    : ""}
                </Box>
                <Text fontSize="15px" fontWeight="600">
                  {medicinedata && medicinedata.medicinename
                    ? medicinedata.medicinename
                    : "-"}
                </Text>
                {/* <Text fontSize="12px" fontWeight="500" color="#384052"> */}
                  {/* {medicinedata && medicinedata.medicationenddate
                    ? medicinedata.medicationenddate
                    : "-"} */}
                  {/* {formatDate(medicinedata && medicinedata.medicationstartdate && medicinedata.medicationstartdate)}
                </Text> */}
                  
                <Text fontWeight="bold" fontSize="12px">
                Composition :
                <span style={{fontWeight:"500"}}>
                  {medicinedata && medicinedata.chemicalcomposition
                    ? medicinedata.chemicalcomposition
                    : "-"}
                    </span>
                </Text>
                <Text fontWeight="bold" fontSize="12px">
                Expiry :
                <span style={{fontWeight:"500"}}>
                  {medicinedata && medicinedata.medicineexpirydate
                    ? medicinedata.medicineexpirydate
                    : "-"}
                    </span>
                </Text>
              </Box>
              <Divider />
              <Box
                display="flex"
                flexDir="column"
                mt="15px"
                gap="12px"
                border="1px solid #E6E7E9"
                borderRadius="10px"
                p="20px"
              >
                <Box
                  display="flex"
                  alignItems="center"
                  justifyContent="start"
                  gap="10px"
                >
                  <Image src="/assets/svgs/pill-blue.svg" />
                  <Text fontSize="14px" fontWeight="500">
                    {/* {medicinedata && medicinedata.frequency
                      ? medicinedata.frequency
                      : "-"}
                    x per day */}

                    {medicinedata &&  medicinedata.frequency &&
                                 (() => {
                                     const parts = medicinedata.frequency.split(" ");
                                     const value = parts[0]; // Extract the number
                                     let unit = parts[1];  // Extract the unit
                                     // Remove trailing 's' from the unit if it exists
                                     if (unit?.endsWith("s")) {
                                         unit = unit.slice(0, -1);
                                     }
                                     return value && unit ? `${value} x per ${unit}` : medicinedata.frequency;
                                 })()}

                  </Text>
                  <Box display="flex" gap="5px">
                    <Box
                      as="span"
                      bg={
                        medicinedata && medicinedata.morning === 1
                          ? "#384052"
                          : "#E6E7E9"
                      }
                      borderRadius="full"
                      w="8px"
                      h="8px"
                      p="4px"
                    ></Box>
                    <Box
                      as="span"
                      bg={
                        medicinedata && medicinedata.afternoon === 1
                          ? "#384052"
                          : "#E6E7E9"
                      }
                      borderRadius="full"
                      w="8px"
                      h="8px"
                      p="4px"
                    ></Box>
                    <Box
                      as="span"
                      bg={
                        medicinedata && medicinedata.night === 1
                          ? "#384052"
                          : "#E6E7E9"
                      }
                      borderRadius="full"
                      w="8px"
                      h="8px"
                      p="4px"
                    ></Box>
                  </Box>
                </Box>
                {/* <Box display="flex" gap="10px" pr="4px">
                  <Image src="/assets/svgs/calendar_month.svg" />
                  <Text fontSize="14px" fontWeight="500">
                    {daysDiffrence} 
                  </Text>
                </Box> */}
                <Box display="flex" gap="10px" pr="4px">
                  <Image src="/assets/svgs/stethoscope.svg" />
                  <Text fontSize="14px" fontWeight="500" className="textOverflow">
                    {medicinedata && medicinedata.prescribedby
                      ? medicinedata.prescribedby
                      : "-"}
                  </Text>
                </Box>
                <Box display="flex" gap="10px" pr="4px">
                  <Image src="/assets/svgs/hospital.svg" />
                  <Text fontSize="14px" fontWeight="500" className="textOverflow">
                    {medicinedata && medicinedata.prescribedhospitalname
                      ? medicinedata.prescribedhospitalname
                      : "-"}
                  </Text>
                </Box>
              </Box>
              {/* <Button w="100%" h="48px" my="15px" borderRadius="10px" border="1px solid #E6E7E9" display="flex" justifyContent="space-between" bg="white" color="#1C4EC5" sx={{_hover: {bg:"none"}}}>
                    12/01/24_Report.pdf
                    <Box as="span">
                        <Image src="/assets/imgs/download.png" />
                    </Box>
                </Button>  */}
              {medicinedata && medicinedata.documents && medicinedata.documents.map((document, index) => (
                <Button
                  key={index}
                  w="100%"
                  h="48px"
                  my="15px"
                  borderRadius="10px"
                  border="1px solid #E6E7E9"
                  display="flex"
                  justifyContent="space-between"
                  bg="white"
                  color="#1C4EC5"
                  sx={{ _hover: { bg: "none" } }}
                  onClick={()=>downloadDocument(document.imagepath + document.documenturl)}
                  cursor="pointer"
                >
                  Document {index + 1}
                  {document.documenturl != null && (
                    <Box as="span">
                      <Image src="/assets/imgs/download.png" />
                    </Box>
                  )}
                </Button>
              ))}
            </Flex>
          </>
        }
        footerActions={
          <>
            <Box w="100%" display="flex" flexDirection="row" gap="15px">
              <PrimaryButton 
              onClick={() => handleeditmedication(medicinedata)} 
              btnStyle={{fontSize:"14px", my: "0"}} variant="grayBtnFull" buttonText="Update Medication" 
              isDisabled={actionAccessPatients?.update ? false : true} />
              <PrimaryButton
                variant="grayBtnFull"
                color="#AA2E26"
                btnStyle={{ color: "#AA2F27", fontSize:"14px", my: "0" }}
                buttonText="Delete Medication"
                
              isDisabled={actionAccessPatients?.delete ? false : true}
                onClick={() =>
                  DeleteMedicineModel(
                    medicinedata && medicinedata.medicinename,
                    medicinedata && medicinedata.id
                  )
                }
              />
            </Box>
          </>
        }
      />

{/* <ModalRight
        ref={addmedications}
        header="Add Medication"
        bodyStyle={{ p: "24px 32px" }}
        modalWidth="460px"
        body={
          <>
            <Box display="flex" flexDir="column" gap="20px">
              <Stack>
                <InputGroup>
                  <Input
                    pr="4.5rem" 
                    type="text"
                    placeholder="Medicine name*"
                    value={medicinename}
                    sx={{
                      height: "48px",
                      borderRadius: "10px",
                      _hover: {
                        border: "2px solid",
                        borderColor: COLORS.INPUT_FOCUS_DARK,
                        outline: "none",
                        bg: "none",
                        _focus: {
                          borderRadius: "10px",
                          borderColor: COLORS.INPUT_FOCUS_DARK,
                          outline: "none",
                        },
                        _focusVisible: { borderColor: "none" },
                      },
                    }}
                    onChange={handlemedicinename}
                    maxLength={80}
                  />
                  <InputRightElement width="4.5rem">
                    <Box
                      as="button"
                      h="1.75rem"
                      bg="none"
                      pt="8px"
                      onClick={() =>
                        document.getElementById("file-upload").click()
                      }
                      sx={{ _hover: { bg: "none" } }}
                    >
                      <Image src="/assets/svgs/image-search-blue.svg" />
                    </Box>
                    <input
                      type="file"
                      id="file-upload"
                      style={{ display: "none" }}
                      onChange={handleimageselection}
                    />
                  </InputRightElement>
                </InputGroup>
                <InputGroup>
                <PrimaryInput
                variant="bothSide"
                  inputValue={Composition}
                  onChange={(event)=> setComposition(event.target.value)}
                  inputPlace="Medicine Composition"
                />
                  <PrimaryButton
                          buttonText="Fetch"
                          verticalAlign="bottom"
                          variant="grayBtn"
                          btnStyle={{
                            w: "15%",
                            color: COLORS.PRIMARY_COLOR,
                            verticalAlign: "bottom",
                            ml: "4px",
                            mb: "0px",
                            h: "48px",
                            m: "0",
                            borderRadius: "0 10px 10px 0",
                          
                          }}
                          onClick={() =>
                            fetchComposition(medicinename)
                          }
                          isDisabled={false}

                        />
                        
                        </InputGroup>
                        {medicinename != '' &&
                        <Box as="button" onClick={makeAicall} textAlign="right" fontSize="12px" textDecoration="underline">Learn more</Box>
                        }
                        <RadioGroup
                        mt="1rem"
                  defaultValue={medicineTypeRadio}
                  onChange={handlemedicinetypechange}
                >
                   <Divider />
                  <Stack direction="row" gap="20px"  wrap="wrap">
                    <Radio value="Tablet">Tablet</Radio>
                    <Radio value="Capsule">Capsule</Radio>
                    <Radio value="Syrup">Syrup</Radio>
                    <Radio value="Injection">Injection</Radio>
                    <Radio value="Ointment">Ointments / Creams / Gels</Radio>
                    <Radio value="Drops">Drops</Radio>
                    <Radio value="Nebulization">Nebulization</Radio>
                    <Radio value="IVFluids">IV Fluids</Radio>
                    <Radio value="Inhaler">Inhaler</Radio>
                  </Stack>
                </RadioGroup>
                <Divider />
                <Box>

                  {medicinetype == "Tablet" || medicinetype == "Capsule" ?
                                  (
                                      <MiniDropdownInput
                                      variant="bothside"
                                      options={ [
                                      { label: "mg", value: "mg" },
                                      { label: "mcg", value: "mcg" },
                                      { label: "g", value: "g" },
                                        ] }
                                  
                                      placeholderProp={  medicinetype == "Syrup" || medicinetype == "Injection" ||  medicinetype == "Nebulization" ||  medicinetype == "IVFluids" || medicinetype == "Drops"  ? "Volume" :  "Dosage"}
                                      onSelect={handleChangeDosageUnit}
                                      handleInputChange={(e) =>
                                        setMedicineDosage(validationOfNumberWithOnly1Decimal(e.target.value))
                                      }
                                      inputVal={dosage}
                  
                                      defaultOptionProp={dosageunit}
                                      maxLength="6"
                                    />
                                  ): medicinetype === "Inhaler" ? (
                                    <MiniDropdownInput
                                      variant="bothside"
                                      options={ [
                                        { label: "puffs", value: "puffs" },
                                        { label: "ml", value: "ml" },
                                      { label: "grms", value: "grms" },
                                        ] }
                                  
                                      placeholderProp={medicinetype == "Inhaler" ? "Volume" :  "Dosage"}
                                      onSelect={handleChangeDosageUnit}
                                      handleInputChange={(e) =>
                                        setMedicineDosage(validationOfNumberWithOnly1Decimal(e.target.value))
                                      }
                                      inputVal={dosage}
                  
                                      defaultOptionProp={dosageunit}
                                      maxLength="6"
                                    />
                                  ) : (
                                    <MiniDropdownInput
                                      variant="bothside"
                                      options={ [
                                      { label: "mg", value: "mg" },
                                      { label: "ml", value: "ml" },
                                      { label: "grms", value: "grms" },
                                        ] }
                                  
                                      placeholderProp={  medicinetype == "Syrup" || medicinetype == "Injection" ||  medicinetype == "Nebulization" ||  medicinetype == "IVFluids" || medicinetype == "Drops"  ? "Volume" :  "Dosage"}
                                      onSelect={handleChangeDosageUnit}
                                      handleInputChange={(e) =>
                                        setMedicineDosage(validationOfNumberWithOnly1Decimal(e.target.value))
                                      }
                                      inputVal={dosage}
                  
                                      defaultOptionProp={dosageunit}
                                      maxLength="6"
                                    />
                                  )}
                  
                  {medicinetype == "IVFluids" &&

<MiniDropdownInput
  variant="bothside"
  options={[
    { label: "ml/hr", value: "ml/hr" },
    { label: "ml/min", value: "ml/min" },
  ]}
  handleInputChange={(e) =>
    setRateOfInfusionValue(validationOfNumberWithOnly1Decimal(e.target.value))
  }
  placeholderProp={"Rate of Infusion"}
  onSelect={handleRateOfInfusionUnit}
  maxLength="6"
/>

}


<Divider my="10px" />
  <Text  fontSize="0.875rem" fontWeight="500" mb="10px">{medicinetype == "Ointment" ? "Application Frequency" : "Frequency" }</Text>
  <DropdownInput
    variant="downSide"
    dropDownPlace={medicinetype == "Ointment" ? "Application Frequency" : medicinetype == "Nebulization" || medicinetype == "Inhaler" || medicinetype == "IVFluids" ? "Frequency" : "Consumption Quantity" }
    options={["0.5", "1", "2", "3", "4", "5", "6", "7",]}
    onClick={handleconsumptionfrequencychange}
  />
   <DropdownInput
    variant="bothSide"
    dropDownPlace="Frequency Interval"
    options={["Hours","Days", "Weeks", "Months", "Years"]} 
    onClick={handleFrequencyUnit}
  />
  
  <Divider my="10px" />


  {(medicinetype == "Injection" || medicinetype == "Tablet" ||medicinetype == "Capsule" ) &&
  <>
  <Text fontSize="0.875rem" fontWeight="500" mb="10px">Duration</Text>

  <Box display="flex" flexDir="row">

    <Box width="50%">
      <DropdownInput
        variant="bothSide"
        dropDownPlace="Duration"
        options={["Hours", "Days", "Weeks", "Months", "Years"]}
        onClick={handleDurationUnit}
        defaultOption={durationUnit}
      />
    </Box>
    <Box width="50%">
      <DropdownInput
        variant="downSide"
        dropDownPlace="Interval Value"
        options={["1", "2", "3", "4", "5", "6", "7",]}
        onClick={handleDurationValue}
        defaultOption={durationValue}
      />
    </Box>
  </Box>
  <Divider my="10px" />
  </>
  }


{(medicinetype == "Injection") &&
<>


  <DropdownInput
    variant="downSide"
    dropDownPlace="Route of Administration"
    options={["Intravenous (IV)", "Intramuscular (IM)", "Subcutaneous (SC)"]}
    onClick={handleRouteOfAdministration}
  />
  <Box>
    <PrimaryInput
      variant={"bothSide"}
      onChange={handleTiming}
      inputPlace="Timing"
    />
  </Box>

</>
}

{(medicinetype == "Ointment") &&
<>

  <Text fontSize="0.875rem" fontWeight="500" mb="10px">Application Duration</Text>
  <Box display="flex" flexDir="row">
    <Box width="50%">
      <DropdownInput
        variant="bothSide"
        dropDownPlace="Duration"
        options={["Until symptoms resolve", "Hours", "Days", "Weeks", "Months", "Years"]}
        onClick={handleDurationUnit}
        
        defaultOption={durationUnit}
      />
    </Box>
    <Box width="50%">
      <DropdownInput
        variant="downSide"
        dropDownPlace="Interval Value"
        options={["1", "2", "3", "4", "5", "6", "7",]}
        onClick={handleDurationValue}
        
        defaultOption={durationValue}
      />
    </Box>

  </Box>

  <Divider my="10px" />

  <DropdownInput
    variant="downSide"
    dropDownPlace="Quantity"
    options={["Pea-sized", "Thin layer", "Fingertip unit (FTU)", "Half a fingertip"]}
    onClick={handleQuantity}
  />
  <PrimaryInput
    variant={"bothSide"}
    onChange={handleAreaOfApplication}
    inputPlace="Area of Application"
  />
</>
}


{(medicinetype == "Nebulization") &&
<>

  <Text fontSize="0.875rem" fontWeight="500" mb="10px">Duration</Text>

  <Box display="flex" flexDir="row">

    <Box width="50%">
      <DropdownInput
        variant="bothSide"
        dropDownPlace="Duration"
        options={["Hours", "Days", "Weeks", "Months", "Years"]}
        onClick={handleDurationUnit}
        defaultOption={durationUnit}
      />
    </Box>
    <Box width="50%">
      <DropdownInput
        variant="downSide"
        dropDownPlace="Interval Value"
        options={["1", "2", "3", "4", "5", "6", "7",]}
        onClick={handleDurationValue}
        defaultOption={durationValue}
      />
    </Box>
  </Box>
  <Divider my="10px" />

  <DropdownInput
    variant="downSide"
    dropDownPlace="Diluent"
    options={["Normal saline", "Distilled water" , "3% saline"]}
    onClick={handleDiluent}
  />

</>
}


{(medicinetype == "IVFluids") &&
<>
  <Text fontSize="0.875rem" fontWeight="500" mb="10px">Infusion Duration</Text>

  <DropdownInput
    variant="downSide"
    dropDownPlace="Infusion frequency"
    options={["1", "2", "3", "4", "5", "6", "7",]}
    onClick={handleDurationValue}
    defaultOption={durationValue}
  />
  <DropdownInput
    variant="bothSide"
    dropDownPlace="Infusion Duration"
    options={[ "Hours", "Days", "Weeks", "Months", "Years"]}
    onClick={handleDurationUnit}
    defaultOption={durationUnit}
  />

  <Divider my="10px" />

  <PrimaryInput
    variant={"bothSide"}
    onChange={handleAdditives}
    inputPlace="Additives"
  />


</>
}

{(medicinetype == "Inhaler") &&
<>

  <Divider my="10px" />
  <Text fontSize="0.875rem" fontWeight="500" mb="10px">Duration</Text>

  <Box display="flex" flexDir="row">

    <Box width="50%">
      <DropdownInput
        variant="bothSide"
        dropDownPlace="Duration"
        options={["Hours", "Days", "Weeks", "Months", "Years"]}
        onClick={handleDurationUnit}
        defaultOption={durationUnit}
      />
    </Box>
    <Box width="50%">
      <DropdownInput
        variant="downSide"
        dropDownPlace="Interval Value"
        options={["1", "2", "3", "4", "5", "6", "7",]}
        onClick={handleDurationValue}
        defaultOption={durationValue}
      />
    </Box>
  </Box>
  <Divider my="10px" />

</>
}

                  <MonthYearPicker
                    placeholderProp="Medicine Expiry"
                    value={medicineexpirydate}
                    onDateChange={handleMonthYearChange}
                    datePickerInputStyle={{ borderRadius: "0 0 10px 10px" }}
                    minYear={moment().year()}

                  />
                  <CheckboxGroup
                    colorScheme="green"
                    onChange={handlemedicinetime}
                  >
                    <Stack spacing={2} pt="20px" direction="row">
                      <Checkbox value="morning">Morning</Checkbox>
                      <Checkbox value="afternoon">Afternoon</Checkbox>
                      <Checkbox value="night">Night</Checkbox>
                    </Stack>
                  </CheckboxGroup>
                  <CheckboxGroup
                    colorScheme="green"
                    onChange={handlemedicinetimebeforeafter}
                  >
                    <Stack spacing={2} pt="20px" direction="row">
                      <Checkbox value="beforefood">Before Food</Checkbox>
                      <Checkbox value="afterfood">After Food</Checkbox>
                    </Stack>
                  </CheckboxGroup>
                  
                </Box>
                <Box>
                <Box w="100%" pos='relative' cursor="pointer">
                  <PrimaryInput
                    inputPlace="Prescribed by"
                    variant="defaultSide"
                    inputValue={prescribedby}
                    onChange={(e) =>
                      handleSurgeonNameChange(handleAlphaDotAndSpace(e.target.value,50))
                    }
                    onClick={() =>
                      listOfSurgeonNames(false)
                    }
                inputIdProp={"DoctorNameInAdd"}
                boolProp={boolValForSuggestions}
                  />
                    <Image top="33%" right="6.5%" w="15px" 
                          onClick={() =>
                            listOfSurgeonNames( true)
                          }
                            pos='absolute' src="/assets/imgs/double-arrow.png" />
                          
                  </Box>
                    {showDocNamesDropdown &&  suggestions.length > 0 && (
                <Menu isOpen={true}>
                <MenuButton as={Box} w="100%" display="block" pos="relative" zIndex="999">
                  <Box pos="absolute" top="100%" left="0" w="100%" bg="white" borderTop="none" border="1px solid #E6E7E9" borderRadius="0 0 12px 12px" />
                </MenuButton>
                <MenuList w="100%" borderRadius="0 0 12px 12px" zIndex="999" bg="white" maxH="150px" overflow="hidden auto">
                  {suggestions.map((suggestion, index) => (
                    <MenuItem
                      key={index}
                      onClick={() => handleSelect(suggestion)}
                      cursor="pointer"
                      p="1rem"
                      py="0.5rem"
                      borderBottom="1px solid #E6E7E9"
                    >
                      <Text fontSize="0.875rem" fontWeight="500">{suggestion.doctorname}</Text>
                    </MenuItem>
                  ))}
                  </MenuList>
                </Menu>
              )}


                  <PrimaryInput
                    inputPlace="Hospital name"
                    variant="downSide"
                    onChange={(e) => setHospitalname(handleAlphaNumericDotAndSpace(e.target.value))}
                    inputValue={hospitalname}
                  />
                  <Box mt="15px">
                  <Checkbox
                colorScheme="green"
                sx={{
                  ".chakra-checkbox__control": {
                    width: "20px",
                    height: "20px",
                    borderRadius: "5px",
                  },
                }}
                onChange={handleIsCurrent}
              >
                  Current
              </Checkbox>
              </Box>
                </Box>
                {filenameArray.map((filename, indexToDelete) => (
                  <Button fontSize="14px" fontWeight="500" w="100%" h="48px" borderRadius="10px" border="1px solid #E6E7E9" display="flex" justifyContent="space-between" bg="white" color="#1C4EC5" sx={{ _hover: { bg: "none" } }}>
                    Document {indexToDelete + 1}
                    <Box as="span" onClick={() => handleDelete(indexToDelete)}>
                      <Image src="/assets/imgs/delete.png" />
                    </Box>
                  </Button>
                ))}
                <Box onClick={addMedicationUploadDocument} as="button" display="flex" alignItems="center" gap="10px" fontSize="14px" fontWeight="600" color="#1C4EC5" textAlign="left">
                  <Image w="11px" src="/assets/imgs/add-blue.png" />
                  Add Document
                </Box>
                <input
                  type='file'
                  id='file-upload'
                  onChange={(e) => handleMedicationUpload(e)}
                  ref={fileInputRef} 
                  style={{ display: 'none' }} 
                />
              </Stack>
            </Box>
          </>
        }
        footerActions={
          <>
            <Box w="100%" display="flex" flexDirection="row" gap="15px">
              <PrimaryButton
                buttonText="Add Medication"
                onClick={addmedicine}
              isDisabled={actionAccessPatients?.create ? false : true}
              />
            </Box>
          </>
        }
      /> */}


      <DynamicModal
                      ref={addMedication}
                      modalHeader="Add medication"
            modalWidth={{base:'100%', md: 'calc(100vw - 40%)'}}
                      hasFooter= {false}
                      modalBody={
                        <>
                      <Box
                        // p="20px"
                        // border="1px solid gray"
                        borderRadius="10px"
                        ml="0px"
                        // mb="10rem"
                      >
                        <Stack spacing={4}>
                          <Flex
                            width="100%"
                            justifyContent="space-between"
                            alignItems="center"
                            flexDir={{ base: "column", md: "row" }}
                          >
                            {!apmtIdUrl && (
                            <Box width={{ base: "100%", md: "45%" }}>
                              <Box w="100%" pos="relative" cursor="pointer">
                                <PrimaryInput
                                  variant="bothSide"
                                  inputPlace="Medicine name"
                                  inputValue={newMedicine.medicinename}
                                  onChange={(e) => {
                                    handleNewMedicineChange(
                                      "medicinename",
                                      e.target.value
                                    );
                                    filterMedicineNames(e.target.value);
                                    setShowMedicineNamesDropdown(1);
                                    setBoolValForSuggestions(!boolValForSuggestions);
                                  }}
                                  inputIdProp={"MedicineNameInAdd" + 1}
                                  boolProp={boolValForSuggestions}
                                  // onKeyDown={(e) => handleKeyDown(e, 1)}
                                  autoFocus={showMedicineNamesDropdown === 1}
                                  autocomplete="off"
                                />
                                <Image
                                  top="33%"
                                  right="6.5%"
                                  w="15px"
                                  pos="absolute"
                                  src="/assets/imgs/double-arrow.png"
                                />
                              </Box>
                              {showMedicineNamesDropdown === 1 &&
                                suggestions.length > 0 && (
                                  <Menu isOpen={true}>
                                    <MenuButton
                                      as={Box}
                                      w="100%"
                                      display="block"
                                      pos="relative"
                                      zIndex="999"
                                    >
                                      <Box
                                        pos="absolute"
                                        top="100%"
                                        left="0"
                                        w="100%"
                                        bg="white"
                                        borderTop="none"
                                        border="1px solid #E6E7E9"
                                        borderRadius="0 0 12px 12px"
                                      />
                                    </MenuButton>
                                    <MenuList
                                      w="100%"
                                      borderRadius="0 0 12px 12px"
                                      zIndex="999"
                                      bg="white"
                                      maxH="150px"
                                      overflow="hidden auto"
                                      ref={suggestionsMenuRef}
                                    >
                                      {suggestions.map((suggestion, sIndex) => (
                                        <MenuItem
                                          key={sIndex}
                                          onClick={() => handleSelect(suggestion, 1)}
                                          cursor="pointer"
                                          p="1rem"
                                          py="0.5rem"
                                          borderBottom="1px solid #E6E7E9"
                                          bg={
                                            focusedItemIndex === sIndex
                                              ? "#f0f0f0"
                                              : "white"
                                          }
                                        >
                                          <Text fontSize="0.875rem" fontWeight="500">
                                            {suggestion.productname +
                                              " (" +
                                              suggestion.remainingquantity +
                                              " Qty)"}
                                          </Text>
                                        </MenuItem>
                                      ))}
                                    </MenuList>
                                  </Menu>
                                )}
                            </Box>
                            )}
                            {apmtIdUrl && (
                            <Box width={{ base: "100%", md: "45%" }}>
  <Box w="100%" pos="relative" cursor="pointer">
    <PrimaryInput
      variant="bothSide"
      ref={medicineNameRef}
      inputPlace="Medicine name"
      inputValue={newMedicine.medicinename}
      onChange={(e) => handleNewMedicineChangeIPD("medicinename", e.target.value)}
      inputIdProp={"MedicineNameInAdd" + 1}
      boolProp={boolValForSuggestions}
      // autoFocus={showMedicineNamesDropdown === 0}
      autocomplete="off"
    />
    <Image
      top="33%"
      right="6.5%"
      w="15px"
      pos="absolute"
      src="/assets/imgs/double-arrow.png"
    />
  </Box>
  {showMedicineNamesDropdown === 1 && suggestions.length > 0 && (
    <Menu isOpen={true} onClose={() => setShowMedicineNamesDropdown(-1)}>
      <MenuButton as={Box} w="100%" display="block" pos="relative" zIndex="999">
        <Box
          pos="absolute"
          top="100%"
          left="0"
          w="100%"
          bg="white"
          borderTop="none"
          border="1px solid #E6E7E9"
          borderRadius="0 0 12px 12px"
        />
      </MenuButton>
      <MenuList
        w="100%"
        borderRadius="0 0 12px 12px"
        zIndex="999"
        bg="white"
        maxH="150px"
        overflow="hidden auto"
        ref={suggestionsMenuRef}
      >
        {isSearching ? (
          <MenuItem>
            <Text fontSize="0.875rem" fontWeight="500">
              Searching...
            </Text>
          </MenuItem>
        ) : suggestions.length > 0 ? (
          suggestions.map((suggestion, sIndex) => (
            <MenuItem
              key={sIndex}
              onClick={() => handleSelectIPD(suggestion)}
              cursor="pointer"
              p="1rem"
              py="0.5rem"
              borderBottom="1px solid #E6E7E9"
              // bg={focusedItemIndex === sIndex ? "#f0f0f0" : "white"}
            >
              <Text fontSize="0.875rem" fontWeight="500">
                {suggestion.medicinename}
                {/* {suggestion.medicinename}  */}
          {/* {suggestion.dosage && ` ${suggestion.dosage}`}
          {suggestion.dosageunit && ` ${suggestion.dosageunit}`}
          {suggestion.medicinetype && ` (${suggestion.medicinetype})`} */}
              </Text>
            </MenuItem>
          ))
        ) : (
          <MenuItem>
            <Text fontSize="0.875rem" fontWeight="500">
              No medicines found
            </Text>
          </MenuItem>
        )}
      </MenuList>
    </Menu>
  )}
</Box>
                            )}
                            <Box width={{ base: "100%", md: "45%" }}>
                              <PrimaryInput
                                variant={"bothSide"}
                                inputPlace="Manufacturer"
                                inputValue={newMedicine.manufacturer || ""}
                                onChange={(e) =>
                                  handleNewMedicineChange(
                                    "manufacturer",
                                    e.target.value
                                  )
                                }
                              />
                            </Box>
                            <Box width={{ base: "100%", md: "45%" }}>
                              <PrimaryInput
                                key={key}
                                type="text"
                                variant={"bothSide"}
                                inputPlace="Medicine Composition"
                                inputValue={newMedicine.composition}
                                onChange={(e) =>
                                  handleNewMedicineChange(
                                    "composition",
                                    e.target.value
                                  )
                                }
                              />{" "}
                            </Box>
                            <Box
                              as="button"
                              type="button"
                              border="1px solid #E6E7E9"
                              // borderRadius="full"
                              width={{ base: "100%", md: "10%" }}
                              // w="40px"
                              // h="40px"
                              p="8px"
                              display="flex"
                              justifyContent="center"
                              alignItems="center"
                              // cursor={medicineTextFieldValue ? "pointer" : "not-allowed"}
                              // opacity={medicineTextFieldValue ? 1 : 0.5}
                              // pointerEvents={medicineTextFieldValue ? "auto" : "none"}
                              onClick={() => {
                              if (isChatbotAllowed()) {
                                fetchComposition(newMedicine.medicinename);
                              } else {
                                showErrorToast("Please upgrade your subscription to use this feature");
                              }
                            }}
                            isDisabled={!isChatbotAllowed()}
                            title={!isChatbotAllowed() ? "Please upgrade your subscription to use AI features" : ""}
                              bg="white"
                              // _hover={medicineTextFieldValue ? { bg: "#f0f0f0" } : {}}
                            >
                              <Image w="28px" src="/assets/svgs/ai-star-outline.svg" />
                            </Box>
                            {/* <Box width={{ base: "100%", md: "10%" }}>
                              <PrimaryButton
                                buttonText="Fetch"
                                verticalAlign="bottom"
                                variant="grayBtn"
                                btnStyle={{
                                  w: "100%",
                                  color: COLORS.PRIMARY_COLOR,
                                  verticalAlign: "bottom",
                                  ml: { base: "0", md: "4px" },
                                  mb: "0px",
                                  h: "2.8rem",
                                  opacity: isChatbotAllowed() ? 1 : 0.6,
                                    cursor: isChatbotAllowed() ? "pointer" : "not-allowed"
                                }}
                                onClick={() => {
                                      if (isChatbotAllowed()) {
                                        fetchComposition(newMedicine.medicinename);
                                      } else {
                                        showErrorToast("Please upgrade your subscription to use this feature");
                                      }
                                    }}
                                    isDisabled={!isChatbotAllowed()}
                                    title={!isChatbotAllowed() ? "Please upgrade your subscription to use AI features" : ""}
                              />
                            </Box> */}
                          </Flex>
                          {/* </InputGroup> */}
                          <RadioGroup
                            // defaultValue={newMedicine.medicinetype}
  //                           onChange={(value) => {
  //   handleNewMedicineChange("medicinetype", value);

  //   // Set default dosage units based on medicine type
  //   if (value === "Syrup" || value === "Drops" || value === "Suspension" || 
  //       value === "Respules" || value === "Gargle" || value === "Shampoo" || 
  //       value === "Topical Cleanser") {
  //     handleNewMedicineChange("dosageunit", "ml");
  //   } else if (value === "Tablet" || value === "Capsule" || value === "Suppository" || 
  //              value === "Powder") {
  //     handleNewMedicineChange("dosageunit", "mg");
  //   } else if (value === "Injection" || value === "Nebulization" || value === "IVFluids") {
  //     handleNewMedicineChange("dosageunit", "ml");
  //   } else if (value === "Ointment" || value === "Cream" || value === "Gel" || 
  //              value === "Foam" || value === "Lotion" || value === "Tube" || 
  //              value === "Soap") {
  //     handleNewMedicineChange("dosageunit", "grms");
  //   } else if (value === "Inhaler" || value === "Spray" || value === "Aerosol") {
  //     handleNewMedicineChange("dosageunit", "puffs");
  //   } else if (value === "EA" || value === "Device" || value === "Box") {
  //     handleNewMedicineChange("dosageunit", "each");
  //   } else if (value === "Sachet") {
  //     handleNewMedicineChange("dosageunit", "mg"); // or 'g' as default
  //   } else if (value === "Custom") {
  //     handleNewMedicineChange("dosageunit", ""); // No default for custom
  //   }
  // }}
                            value={medicinetype}
                            onChange={(value) => handleTypeChange(value)}
                            // existing function
                            // onChange={(value) => {
                            //   handleNewMedicineChange("medicinetype", value);
      
                            //   if (value === "Syrup" || value === "Drops") {
                            //     handleNewMedicineChange("dosageunit", "ml");
                            //   } else if (value === "Tablet") {
                            //     handleNewMedicineChange("dosageunit", "mg");
                            //   } else if (value === "Capsule") {
                            //     handleNewMedicineChange("dosageunit", "mg");
                            //   } else if (value === "Injection") {
                            //     handleNewMedicineChange("dosageunit", "ml");
                            //   } else if (value === "Ointment") {
                            //     handleNewMedicineChange("dosageunit", "grms");
                            //   } else if (value === "Nebulization") {
                            //     handleNewMedicineChange("dosageunit", "ml");
                            //   } else if (value === "IVFluids") {
                            //     handleNewMedicineChange("dosageunit", "ml");
                            //   } else if (value === "Inhaler") {
                            //     handleNewMedicineChange("dosageunit", "puffs")
                            //   }
                            // }}
                          >
                            <Stack direction="row" alignItems='center' gap="20px" wrap="wrap">
                  <Radio colorScheme="green" value="Tablet">Tablet</Radio>
                  <Radio colorScheme="green" value="Capsule">Capsule</Radio>
                  <Radio colorScheme="green" value="Syrup">Syrup</Radio>
                  <Radio colorScheme="green" value="Drops">Drops</Radio>
                  <Radio colorScheme="green" value="Injection">Injection</Radio>
                  <Radio colorScheme="green" value="Nebulization">Nebulization</Radio>
                  <Radio colorScheme="green" value="IVFluids">IV Fluids</Radio>
                  <Radio colorScheme="green" value="Inhaler">Inhaler</Radio>
                  <Radio colorScheme="green" value="Sachet">Sachet</Radio>
                  <Radio colorScheme="green" value="Ointment">Ointment</Radio>
                  <Radio colorScheme="green" value="Cream">Cream</Radio>
                  <Radio colorScheme="green" value="Gel">Gel</Radio>                     

                              {/* existing */}
                              {/* <Radio value="Tablet">Tablet</Radio>
                              <Radio value="Syrup">Syrup</Radio>
                              <Radio value="Drops">Drops</Radio>
                              <Radio value="Capsule">Capsule</Radio>
                              <Radio value="Injection">Injection</Radio>
                              <Radio value="Ointment">
                                Ointments / Creams / Gels
                              </Radio>
                              <Radio value="Nebulization">Nebulization</Radio>
                              <Radio value="IVFluids">IV Fluids</Radio>
                              <Radio value="Inhaler">Inhaler</Radio> */}
                            <Text>-Or-</Text>
                            {/* Dropdown for additional options */}
                            <Box mx='1rem'>

  <DropdownInput
    variant="bothSide"
    dropDownPlace="More Medicine Types"
    options={additionalMedicineTypes}
    onClick={(value) => handleTypeChange(value)}
    value={dropdownMedType}
    defaultOption={dropdownMedType || "Select more types"}
  />
                            </Box>
                            </Stack>
                          </RadioGroup>
                          <Divider />
                          <Box>
                            {/* Date Time & Doctor Field */}
                            {apmtIdUrl && (
                            <Box display="flex" flexDir="row">
                              <DropdownInput
                                variant="bothSide"
                                dropDownPlace="Doctor Name*"
                                options={DoctorListForDropdown?DoctorListForDropdown:""}
                                id="Doctor Name"
                                onClick={HandleEditDoctor}
                                value={DefaultDoctor} 
                                defaultOption={DefaultDoctor}
                                menuList={{ pos: "absolute", right: "-41px", minW: "310px" }}
                                inputStyleCss={{ w: "100%" }}
                              />
                              <DatePicker
                                onDateChange={(selectedDateValue) =>
                                  handledatechange(selectedDateValue)
                                }
                                defaultDate={date}
                                disableFutureDates={true}
                                placeholderProp="Date"
                                calendarStlye={{left: "-18px",  right: "unset"}}
                              />
                              <PrimaryInput
                                variant="bothSide"
                                id="vitaltime"
                                inputType="time"
                                inputPlace="Time"
                                pr="10px"
                                defaultValue={time}
                                inputValue={time}
                                onChange={handleTimeChange }
                              />
                            </Box>
                            )}
                            <Box
                              display="flex"
                              flexDir={{ base: "column", md: "row" }}
                            >
                              <PrimaryInput
                                variant={"bothSide"}
                                inputPlace="Drug Class"
                                inputValue={newMedicine.drugclass || ""}
                                onChange={(e) =>
                                  handleNewMedicineChange(
                                    "drugclass",
                                    e.target.value
                                  )
                                }
                              />
                              <PrimaryInput
                                variant={"bothSide"}
                                // onChange={handleTherapeuticCategory}
                                inputPlace="Therapeutic category"
                                inputValue={newMedicine.therapeutic || ""}
                                onChange={(e) =>
                                  handleNewMedicineChange(
                                    "therapeutic",
                                    e.target.value
                                  )
                                }
                              />
                              {newMedicine.medicinetype === "Tablet" || 
 newMedicine.medicinetype === "Capsule" || 
 newMedicine.medicinetype === "Suppository" || 
 newMedicine.medicinetype === "Powder" ? (
  <MiniDropdownInput
    variant="bothSide"
    options={[
      { label: "mg", value: "mg" },
      { label: "mcg", value: "mcg" },
      { label: "g", value: "g" },
    ]}
    placeholderProp="Strength"
    defaultValue={newMedicine.dosage}
    defaultOptionProp={newMedicine.dosageunit}
    onSelect={(value) => handleNewMedicineChange("dosageunit", value.label)}
    handleInputChange={(event) =>
      handleNewMedicineChange(
        "dosage",
        validationOfNumberWithOnly1Decimal(event.target.value)
      )
    }
    maxLength="6"
    inputVal={newMedicine.dosage}
  />
) : newMedicine.medicinetype === "Inhaler" || 
    newMedicine.medicinetype === "Spray" || 
    newMedicine.medicinetype === "Aerosol" ? (
  <MiniDropdownInput
    variant="bothSide"
    options={[
      { label: "puffs", value: "puffs" },
      { label: "ml", value: "ml" },
    ]}
    placeholderProp="Volume"
    defaultValue={newMedicine.dosage}
    defaultOptionProp={newMedicine.dosageunit}
    onSelect={(value) => handleNewMedicineChange("dosageunit", value.label)}
    handleInputChange={(event) =>
      handleNewMedicineChange(
        "dosage",
        validationOfNumberWithOnly1Decimal(event.target.value)
      )
    }
    maxLength="6"
    inputVal={newMedicine.dosage}
  />
) : newMedicine.medicinetype === "Syrup" ||
    newMedicine.medicinetype === "Drops" ||
    newMedicine.medicinetype === "Injection" ||
    newMedicine.medicinetype === "Nebulization" ||
    newMedicine.medicinetype === "IVFluids" ||
    newMedicine.medicinetype === "Suspension" ||
    newMedicine.medicinetype === "Respules" ||
    newMedicine.medicinetype === "Gargle" ||
    newMedicine.medicinetype === "Shampoo" ||
    newMedicine.medicinetype === "Topical Cleanser" ? (
  <MiniDropdownInput
    variant="bothSide"
    options={[{ label: "ml", value: "ml" }]}
    placeholderProp="Volume"
    defaultValue={newMedicine.dosage}
    defaultOptionProp={newMedicine.dosageunit}
    onSelect={(value) => handleNewMedicineChange("dosageunit", value.label)}
    handleInputChange={(event) =>
      handleNewMedicineChange(
        "dosage",
        validationOfNumberWithOnly1Decimal(event.target.value)
      )
    }
    maxLength="6"
    inputVal={newMedicine.dosage}
  />
) : newMedicine.medicinetype === "Ointment" ||
    newMedicine.medicinetype === "Cream" ||
    newMedicine.medicinetype === "Gel" ||
    newMedicine.medicinetype === "Foam" ||
    newMedicine.medicinetype === "Lotion" ||
    newMedicine.medicinetype === "Tube" ||
    newMedicine.medicinetype === "Soap" ? (
  <MiniDropdownInput
    variant="bothSide"
    options={[{ label: "grms", value: "grms" }]}
    placeholderProp="Weight"
    defaultValue={newMedicine.dosage}
    defaultOptionProp={newMedicine.dosageunit}
    onSelect={(value) => handleNewMedicineChange("dosageunit", value.label)}
    handleInputChange={(event) =>
      handleNewMedicineChange(
        "dosage",
        validationOfNumberWithOnly1Decimal(event.target.value)
      )
    }
    maxLength="6"
    inputVal={newMedicine.dosage}
  />
) : newMedicine.medicinetype === "EA" || 
    newMedicine.medicinetype === "Device" || 
    newMedicine.medicinetype === "Box" ? (
  <MiniDropdownInput
    variant="bothSide"
    options={[{ label: "each", value: "each" }]}
    placeholderProp="Count"
    defaultValue={newMedicine.dosage}
    defaultOptionProp={newMedicine.dosageunit}
    onSelect={(value) => handleNewMedicineChange("dosageunit", value.label)}
    handleInputChange={(event) =>
      handleNewMedicineChange(
        "dosage",
        validationOfNumberWithOnly1Decimal(event.target.value)
      )
    }
    maxLength="6"
    inputVal={newMedicine.dosage}
  />
) : newMedicine.medicinetype === "Sachet" ? (
  <MiniDropdownInput
    variant="bothSide"
    options={[
      { label: "mg", value: "mg" },
      { label: "g", value: "g" },
    ]}
    placeholderProp="Strength"
    defaultValue={newMedicine.dosage}
    defaultOptionProp={newMedicine.dosageunit}
    onSelect={(value) => handleNewMedicineChange("dosageunit", value.label)}
    handleInputChange={(event) =>
      handleNewMedicineChange(
        "dosage",
        validationOfNumberWithOnly1Decimal(event.target.value)
      )
    }
    maxLength="6"
    inputVal={newMedicine.dosage}
  />
) : (
  // Default case for CUSTOM and any other types
  <MiniDropdownInput
    variant="bothSide"
    options={[
      { label: "mg", value: "mg" },
      { label: "ml", value: "ml" },
      { label: "grms", value: "grms" },
      { label: "puffs", value: "puffs" },
      { label: "each", value: "each" },
    ]}
    placeholderProp={newMedicine.medicinetype === "Custom" ? "Custom Unit" : "Strength"}
    defaultValue={newMedicine.dosage}
    defaultOptionProp={newMedicine.dosageunit}
    onSelect={(value) => handleNewMedicineChange("dosageunit", value.label)}
    handleInputChange={(event) =>
      handleNewMedicineChange(
        "dosage",
        validationOfNumberWithOnly1Decimal(event.target.value)
      )
    }
    maxLength="6"
    inputVal={newMedicine.dosage}
  />
)}

                              {/* existing */}
                              {/* {newMedicine.medicinetype == "Tablet" || newMedicine.medicinetype == "Capsule" ?
                              (<MiniDropdownInput
                                variant="bothSide"
                                options={[
                                  { label: "mg", value: "mg" },
                                  { label: "mcg", value: "mcg" },
                                  { label: "g", value: "g" },
                                  // { label: "mg", value: "mg" },
                                  // { label: "ml", value: "ml" },
                                  // { label: "grms", value: "grms" },
                                ]}
                                // placeholderProp="Dosage"
                                placeholderProp={
                                  newMedicine.medicinetype == "Syrup" ||
                                  newMedicine.medicinetype == "Drops" ||
                                  newMedicine.medicinetype == "Injection" ||
                                  newMedicine.medicinetype == "Nebulization" ||
                                  newMedicine.medicinetype == "Inhaler" ||
                                  newMedicine.medicinetype == "IVFluids"
                                    ? "Volume"
                                    : "Strength"
                                }
                                defaultValue={newMedicine.dosage}
                                defaultOptionProp={newMedicine.dosageunit}
                                onSelect={(value) =>
                                  handleNewMedicineChange("dosageunit", value.label)
                                }
                                handleInputChange={(event) =>
                                  handleNewMedicineChange(
                                    "dosage",
                                    validationOfNumberWithOnly1Decimal(
                                      event.target.value
                                    )
                                  )
                                }
                                maxLength="6"
                                inputVal={newMedicine.dosage}
                              />
                              ): newMedicine.medicinetype === "Inhaler" ? (
                                <MiniDropdownInput
                                variant="bothSide"
                                options={[
                                  { label: "puffs", value: "puffs" },
                                  { label: "ml", value: "ml" },
                                ]}
                                // placeholderProp="Dosage"
                                placeholderProp={
                                  newMedicine.medicinetype == "Syrup" ||
                                  newMedicine.medicinetype == "Drops" ||
                                  newMedicine.medicinetype == "Injection" ||
                                  newMedicine.medicinetype == "Nebulization" ||
                                  newMedicine.medicinetype == "Inhaler" ||
                                  newMedicine.medicinetype == "IVFluids"
                                    ? "Volume"
                                    : "Strength"
                                }
                                defaultValue={newMedicine.dosage}
                                defaultOptionProp={newMedicine.dosageunit}
                                onSelect={(value) =>
                                  handleNewMedicineChange("dosageunit", value.label)
                                }
                                handleInputChange={(event) =>
                                  handleNewMedicineChange(
                                    "dosage",
                                    validationOfNumberWithOnly1Decimal(
                                      event.target.value
                                    )
                                  )
                                }
                                maxLength="6"
                                inputVal={newMedicine.dosage}
                              />
                              ) : newMedicine.medicinetype === "Ointment" ? (
                                <MiniDropdownInput
                                variant="bothSide"
                                options={[
                                  { label: "mg", value: "mg" },
                                  { label: "ml", value: "ml" },
                                  { label: "grms", value: "grms" },
                                ]}
                                // placeholderProp="Dosage"
                                placeholderProp={
                                  newMedicine.medicinetype == "Syrup" ||
                                  newMedicine.medicinetype == "Drops" ||
                                  newMedicine.medicinetype == "Injection" ||
                                  newMedicine.medicinetype == "Nebulization" ||
                                  newMedicine.medicinetype == "Inhaler" ||
                                  newMedicine.medicinetype == "IVFluids"
                                    ? "Volume"
                                    : "Strength"
                                }
                                defaultValue={newMedicine.dosage}
                                defaultOptionProp={newMedicine.dosageunit}
                                onSelect={(value) =>
                                  handleNewMedicineChange("dosageunit", value.label)
                                }
                                handleInputChange={(event) =>
                                  handleNewMedicineChange(
                                    "dosage",
                                    validationOfNumberWithOnly1Decimal(
                                      event.target.value
                                    )
                                  )
                                }
                                maxLength="6"
                                inputVal={newMedicine.dosage}
                              />
                              ) : (
                                <MiniDropdownInput
                                variant="bothSide"
                                options={[
                                  { label: "ml", value: "ml" },
                                ]}
                                // placeholderProp="Dosage"
                                placeholderProp={
                                  newMedicine.medicinetype == "Syrup" ||
                                  newMedicine.medicinetype == "Drops" ||
                                  newMedicine.medicinetype == "Injection" ||
                                  newMedicine.medicinetype == "Nebulization" ||
                                  newMedicine.medicinetype == "Inhaler" ||
                                  newMedicine.medicinetype == "IVFluids"
                                    ? "Volume"
                                    : "Strength"
                                }
                                defaultValue={newMedicine.dosage}
                                defaultOptionProp={newMedicine.dosageunit}
                                onSelect={(value) =>
                                  handleNewMedicineChange("dosageunit", value.label)
                                }
                                handleInputChange={(event) =>
                                  handleNewMedicineChange(
                                    "dosage",
                                    validationOfNumberWithOnly1Decimal(
                                      event.target.value
                                    )
                                  )
                                }
                                maxLength="6"
                                inputVal={newMedicine.dosage}
                              />
                              )} */}
      
                              <DropdownInput
                                variant="bothSide"
                                dropDownPlace="Consumption Quantity"
                                options={["0.5", "1", "2", "3", "4"]}
                                onClick={(value) =>
                                  handleNewMedicineChange("frequency", value)
                                }
                                // defaultOption={newMedicine.frequency}
                                value={newMedicine.frequency}
                              />
                              
                            </Box>
                            <Box display="flex" flexDir="row">
                              <Box width="25%">
                                <DropdownInput
                                  variant="bothSide"
                                  dropDownPlace={
                                    newMedicine.medicinetype === "IVFluids"
                                      ? "Infusion Frequency"
                                      : newMedicine.medicinetype === "Ointment"
                                      ? "Application Duration"
                                      : "Duration"
                                      // : "Interval Duration"
                                  }
                                  options={["Days", "Weeks", "Months", "Years"]} // Interval units as options
                                  // onClick={handleIntervalNewChange} // Handle changes with setIntervalOption
                                  // defaultOption={intervalNewOption}
                                  onClick={handleIntervalNewChange}
                                  value={newMedicine.durationunit} // Use from newMedicine state
                                />
                              </Box>
                              <Box width="25%">
                                <PrimaryInput
                                  variant={"bothSide"}
                                  inputType="number"
                                  // defaultValue={intervalNewValue}
                                  // onChange={handleIntervalNewValueChange}
                                  inputValue={newMedicine.durationvalue} // Controlled input
                                  // defaultOption={newMedicine.durationvalue}
                                  onChange={handleIntervalNewValueChange}
                                  inputPlace={
                                    newMedicine.medicinetype === "IVFluids"
                                      ? "Infusion Duration"
                                      : "Interval Value"
                                  }
                                />
                              </Box>
                              <Box width={"50%"} display="flex" flexDir="row">
                                <DatePicker
                                  dateWidth="50%"
                                  defaultDate={newMedicine.medicationstartdate}
                                  // minDate={newMedicine.medicationstartdate}
                                  onDateChange={(selectedDateValue) =>
                                    handleNewMedicineChange(
                                      "medicationstartdate",
                                      selectedDateValue
                                    )
                                  }
                                  placeholderProp={"Start Date"}
                                  calendarStlye={{
                                    left: "-18px",
                                    right: "unset",
                                  }}
                                />
                                <DatePicker
                                  dateWidth="50%"
                                  key={newMedicine.medicationenddate}
                                  defaultDate={newMedicine.medicationenddate}
                                  disableDatePicker={true}
                                  minDate={newMedicine.medicationstartdate}
                                  onDateChange={(selectedDateValue) =>
                                    handleNewMedicineChange(
                                      "medicationenddate",
                                      selectedDateValue
                                    )
                                  }
                                  placeholderProp={"End Date"}
                                  calendarStlye={{
                                    transform: "scale(0.9)",
                                    right: "-22px",
                                    top: "30px",
                                    pointerEvents: "none", // Disable interaction
                                    opacity: 0.5, // Visually indicate disabled state
                                  }}
                                />
                              </Box>
                            </Box>
                            <Box display="flex" flexDir="row">
                              {newMedicine.medicinetype == "Injection" && (
                                <>
                                  <Box width={"50%"}>
                                    <DropdownInput
                                      variant="downSide"
                                      dropDownPlace="Route of Administration"
                                      options={[
                                        "Intravenous (IV)",
                                        "Intramuscular (IM)",
                                        "Subcutaneous (SC)",
                                      ]}
                                      onClick={(value) =>
                                        handleNewMedicineChange(
                                          "routeofadministration",
                                          value
                                        )
                                      }
                                    />
                                  </Box>
                                  <Box width={"50%"}>
                                    <PrimaryInput
                                      variant={"bothSide"}
                                      onChange={(e) =>
                                        handleNewMedicineChange(
                                          "timingofinjection",
                                          e.target.value
                                        )
                                      }
                                      inputPlace="Timing"
                                    />
                                  </Box>
                                </>
                              )}
                              {newMedicine.medicinetype == "Ointment" && (
                                <>
                                  <DropdownInput
                                    variant="downSide"
                                    dropDownPlace="Quantity"
                                    options={[
                                      "Pea-sized",
                                      "Thin layer",
                                      "Fingertip unit (FTU)",
                                      "Half a fingertip",
                                    ]}
                                    onClick={(value) =>
                                      handleNewMedicineChange(
                                        "quantitytobeapplied",
                                        value
                                      )
                                    }
                                  />
                                  <PrimaryInput
                                    variant={"bothSide"}
                                    onChange={(e) =>
                                      handleNewMedicineChange(
                                        "areaofapplication",
                                        e.target.value
                                      )
                                    }
                                    inputPlace="Area of Application"
                                  />
                                </>
                              )}
      
                              {newMedicine.medicinetype == "Nebulization" && (
                                <>
                                  <DropdownInput
                                    variant="downSide"
                                    dropDownPlace="Diluent"
                                    options={["Normal saline", "Distilled water","3% saline"]}
                                    onClick={(value) =>
                                      handleNewMedicineChange("diluent", value)
                                    }
                                  />
                                </>
                              )}
      
                              {newMedicine.medicinetype == "IVFluids" && (
                                <>
                                  <MiniDropdownInput
                                    variant="bothside"
                                    options={[
                                      { label: "ml/hr", value: "ml/hr" },
                                      { label: "ml/min", value: "ml/min" },
                                      // { label: "mg/hr", value: "mg/hr" },
                                      // { label: "grms/hr", value: "grms/hr" },
                                    ]}
                                    handleInputChange={(e) =>
                                      handleNewMedicineChange(
                                        "rateofinfusionvalue",
                                        validationOfNumberWithOnly1Decimal(
                                          e.target.value
                                        )
                                      )
                                    }
                                    placeholderProp={"Rate of Infusion"}
                                    onSelect={(selectedOption) =>
                                      handleEditMedicineChange(
                                        "rateofinfusionunit",
                                        selectedOption.label
                                      )
                                    }
                                    maxLength="6"
                                  />
                                  <PrimaryInput
                                    variant={"bothSide"}
                                    onChange={(e) =>
                                      handleNewMedicineChange(
                                        "additives",
                                        e.target.value
                                      )
                                    }
                                    inputPlace="Additives"
                                  />
                                </>
                              )}
                            </Box>
      
                            <CheckboxGroup colorScheme="green">
        <Stack
          spacing={2}
          pt="20px"
          direction="row"
          alignItems='center'
          flexWrap={{ base: "wrap", md: "nowrap" }}
        >
          <Checkbox
            isChecked={newMedicine.morning === 1}
            onChange={() => {
              // Uncheck frequency inputs when checking a time checkbox
              if (newMedicine.morning !== 1) {
                handleNewMedicineChange("frequencytime", "");
                handleNewMedicineChange("frequencyvalue", "");
              }
              handleNewMedicineChange(
                "morning",
                newMedicine.morning === 1 ? 0 : 1
              );
            }}
          >
            Morning
          </Checkbox>
          <Checkbox
            isChecked={newMedicine.afternoon === 1}
            onChange={() => {
              // Uncheck frequency inputs when checking a time checkbox
              if (newMedicine.afternoon !== 1) {
                handleNewMedicineChange("frequencytime", "");
                handleNewMedicineChange("frequencyvalue", "");
              }
              handleNewMedicineChange(
                "afternoon",
                newMedicine.afternoon === 1 ? 0 : 1
              );
            }}
          >
            Afternoon
          </Checkbox>
          <Checkbox
            isChecked={newMedicine.night === 1}
            onChange={() => {
              // Uncheck frequency inputs when checking a time checkbox
              if (newMedicine.night !== 1) {
                handleNewMedicineChange("frequencytime", "");
                handleNewMedicineChange("frequencyvalue", "");
              }
              handleNewMedicineChange(
                "night",
                newMedicine.night === 1 ? 0 : 1
              );
            }}
          >
            Night
          </Checkbox>
          <Text fontWeight='600' whiteSpace='nowrap'>- Or -</Text>
          <Box display='flex'>
          <Box width='120px'>
            <DropdownInput
              variant="bothSide"
              dropDownPlace="Frequency"
              arrowCSS={{pr:0}}
              options={["Hours", "Daily", "Weekly"]}
              onClick={(value) => {
                // Uncheck time checkboxes when selecting frequency
                if (value) {
                  handleNewMedicineChange("morning", 0);
                  handleNewMedicineChange("afternoon", 0);
                  handleNewMedicineChange("night", 0);
                }
                handleNewMedicineChange("frequencytime", value || "");
              }}
              // defaultOption={"Hours"}
              value={newMedicine.frequencytime || ""}
            />
          </Box>
      
          <Box width='80px'>
      
            <DropdownInputForVitals
              variant="bothSide"
              dropDownPlace="Value"
              arrowCSS={{pr:0}}
              options={["1", "2", "3", "4", "8"]}
              readOnly=""
              maxLength={2}
              onClick={(value) => {
                // Uncheck time checkboxes when selecting value
                if (value) {
                  handleNewMedicineChange("morning", 0);
                  handleNewMedicineChange("afternoon", 0);
                  handleNewMedicineChange("night", 0);
                  handleNewMedicineChange("frequencyvalue", value);
                }
              }}
              onChange={(e) => {
                // Handle manual text input for value
                const value = e.target.value;
                console.log('e, ', e)
                if (value) {
                  handleNewMedicineChange("morning", 0);
                  handleNewMedicineChange("afternoon", 0);
                  handleNewMedicineChange("night", 0);
                }
                handleNewMedicineChange("frequencyvalue", value);
              }}
              value={newMedicine.frequencyvalue}
              inputValueProp={newMedicine.frequencyvalue}
              
            />
          </Box>
          </Box>
          <Spacer />
          
          {/* OLD FOOD TIMING RADIOS - COMMENTED OUT FOR TOPICAL SUPPORT
          <RadioGroup
            value={newMedicine.beforefood === 1 ? "beforefood" : "afterfood"}
            display='flex'
            justifyItems='start'
            flexWrap='wrap'
            gap='0.5rem'
            onChange={(value) => {
              if (value === "beforefood") {
                handleNewMedicineChange("beforefood", 1);
                handleNewMedicineChange("afterfood", 0);
              } else if (value === "afterfood") {
                handleNewMedicineChange("beforefood", 0);
                handleNewMedicineChange("afterfood", 1);
              }
            }}
          >
            <Radio value="beforefood" colorScheme="green">Before Food</Radio>
            <Radio value="afterfood" colorScheme="green">After Food</Radio>
          </RadioGroup>
          END OLD FOOD RADIOS */}

          {/* CONDITIONAL TIMING: TOPICAL VS FOOD */}
          {(newMedicine.medicinetype === "Cream" || newMedicine.medicinetype === "Ointment") ? (
            <Box>
              <Text fontSize="sm" mb={1}>Application Timing</Text>
              <RadioGroup
                value={newMedicine.timing || ""}
                display='flex'
                flexWrap='wrap'
                gap='0.5rem'
                onChange={(value) => {
                  handleNewMedicineChange("timing", value);
                  handleNewMedicineChange("beforefood", 0);
                  handleNewMedicineChange("afterfood", 0);
                }}
              >
                <Radio value="After Bath" colorScheme="green">After Bath</Radio>
                <Radio value="Before Bath" colorScheme="green">Before Bath</Radio>
                <Radio value="After Sun" colorScheme="green">After Sun</Radio>
                <Radio value="Before Sun" colorScheme="green">Before Sun</Radio>
                <Radio value="Time-based" colorScheme="green">Time-based</Radio>
              </RadioGroup>

              <Box mt={2}>
                <Text fontSize="sm" mb={1}>Where to Apply</Text>
                <RadioGroup
                  value={newMedicine.areaofapplication || ""}
                  display='flex'
                  flexWrap='wrap'
                  gap='0.5rem'
                  onChange={(value) => handleNewMedicineChange("areaofapplication", value)}
                >
                  <Radio value="On Scalp" colorScheme="green">On Scalp</Radio>
                  <Radio value="On Skin" colorScheme="green">On Skin</Radio>
                  <Radio value="On Wound" colorScheme="green">On Wound</Radio>
                  <Radio value="On Hair" colorScheme="green">On Hair</Radio>
                </RadioGroup>
              </Box>
            </Box>
          ) : (
            <RadioGroup
              value={newMedicine.beforefood === 1 ? "beforefood" : "afterfood"}
              display='flex'
              justifyItems='start'
              flexWrap='wrap'
              gap='0.5rem'
              onChange={(value) => {
                if (value === "beforefood") {
                  handleNewMedicineChange("beforefood", 1);
                  handleNewMedicineChange("afterfood", 0);
                  handleNewMedicineChange("timing", "Before Food");
                } else if (value === "afterfood") {
                  handleNewMedicineChange("beforefood", 0);
                  handleNewMedicineChange("afterfood", 1);
                  handleNewMedicineChange("timing", "After Food");
                }
              }}
            >
              <Radio value="beforefood" colorScheme="green">Before Food</Radio>
              <Radio value="afterfood" colorScheme="green">After Food</Radio>
            </RadioGroup>
          )}
        </Stack>
      </CheckboxGroup>
           
                            <Divider my="10px" />
      
      <Box position='relative' display='flex' alignItems='flex-end' flexDirection='row'>
        <Box
          as="form"
          width='100%'
          bg="white"
          pt={"2px"}
        >
          <Box flex="1" width="100%" position="relative" bg={"#f9fafb"}>
            {/* <Textarea
              borderRadius='0'
              // placeholder="Instructions"
              {...register("textField")}
              // inputValue={newMedicine.custommessage}
              // onChange={(e) => handleNewMedicineChange("custommessage", e.target.value)}
              value={newMedicine.custommessage || ''}
        onChange={(e) => {
          handleNewMedicineChange("custommessage", e.target.value);
          // Also update the react-hook-form value if needed
          setValue("textField", e.target.value);
        }}
              height="100%"
              padding="2"
              resize="none"
              // disabled={typing} // Disable when AI typing is true
              style={{ overflowWrap: "break-word", whiteSpace: "pre-wrap" }}
            /> */}
            <Textarea
  borderRadius='0'
  // placeholder={placeholder}
  value={newMedicine.custommessage || ''}
  onChange={(e) => {
    handleNewMedicineChange("custommessage", e.target.value);
    setValue("textField", e.target.value);
  }}
  height="100%"
  padding="2"
  resize="none"
  disabled={typing}
  style={{ overflowWrap: "break-word", whiteSpace: "pre-wrap" }}
/>
            
            {!newMedicine.custommessage && (
              <Text
                position="absolute"
                bottom="2"
                left="50%"
                transform="translateX(-50%)"
                fontSize="sm"
                color="gray.500"
                w={{ base: "100%", md: "unset" }}
                textAlign={{ base: "center", md: "unset" }}
              >
                {placeholder}
              </Text>
            )}
          </Box>
          
        </Box>
      
        {/* <GPUChatAudioManager */}
        <GPUChatAudioManagerSpeechMode
            transcriber={activeTranscriber}
            setPlaceholder={setPlaceholder}
            setTyping={setTyping}
            mode={mode}
            // onTranscribedText={handleTranscribedText}  // This is the key addition
            onTranscribedText={(text) => {
    handleNewMedicineChange("custommessage", text);
    setValue("textField", text);
  }}
          />
          <Box
            as="button"
            type="button" // Prevent form submission
            border="1px solid #E6E7E9"
            borderRadius="full"
            w="36px"
            h="auto"
            p="10px"
            mr='10px'
            display="flex"
            justifyContent="center"
            alignItems="center"
            // cursor={newMedicine.custommessage ? "pointer" : "not-allowed"}
            // opacity={newMedicine.custommessage ? 1 : 0.5}
            // pointerEvents={newMedicine.custommessage ? "auto" : "none"}
            // onClick={() => newMedicine.custommessage && correctOrders()}
            cursor={textFieldValue ? "pointer" : "not-allowed"}
                    opacity={textFieldValue ? 1 : 0.5}
                    pointerEvents={textFieldValue ? "auto" : "none"}
                    onClick={() => textFieldValue && correctOrders("add")}
          >
            <Image w="26px" src="/assets/svgs/ai-star-outline.svg" />
          </Box>
      </Box>
      
      <Divider my="10px" />
                          </Box>
                          {/* <Divider /> */}
                          <Box
                            display="flex"
                            justifyContent="flex-end"
                            w={{ base: "100%" }}
                            gap="10px"
                          >
                            {/* <Button onClick={() => setShowAddCard(false)}>
                              Cancel
                            </Button> */}
                            <PrimaryButton
                              buttonText="Cancel"
                              variant="grayBtn"
                              btnStyle={{
                                // w: { base: "50%", md: "15%" },
                                w: "50%",
                                color: COLORS.PRIMARY_COLOR,
                                h: "2.5rem",
                              }}
                              // onClick={handleCancelAddMedicine}
                              isDisabled={false}
                            />
                            {/* <Button colorScheme="blue" onClick={handleAddMedicine}>
                              Add medicine
                            </Button> */}
                            <PrimaryButton
                              buttonText="Add Medication"
                              // onClick={handleAddMedicine}
                              onClick={addmedicine}
                              isDisabled={false}
                              btnStyle={{
                                // w: { base: "50%", md: "25%" },
                                w: "50%",
                                //   color: COLORS.PRIMARY_COLOR,
                                h: "2.5rem",
                              }}
                            />
                          </Box>
                        </Stack>
                      </Box>
                        </>
                      }
                    />

<ModalRight
        ref={editmedications}
        header="Update Medication"
        bodyStyle={{ p: "24px 32px" }}
        modalWidth="460px"
        body={
          <>
            <Box display="flex" flexDir="column" gap="20px">
              <Stack spacing={4}>
                <InputGroup>
                  <Input
                    pr="4.5rem" // Padding right to make room for the icon
                    type="text"
                    placeholder="Medicine name*"
                    value={medicinename}
                    sx={{
                      height: "48px",
                      borderRadius: "10px",
                      _hover: {
                        border: "2px solid",
                        borderColor: COLORS.INPUT_FOCUS_DARK,
                        outline: "none",
                        bg: "none",
                        _focus: {
                          borderRadius: "10px",
                          borderColor: COLORS.INPUT_FOCUS_DARK,
                          outline: "none",
                        },
                        _focusVisible: { borderColor: "none" },
                      },
                    }}
                    maxLength={80}
                    onChange={handlemedicinename}
                  />
                  <InputRightElement width="4.5rem">
                    <Box
                      as="button"
                      h="1.75rem"
                      bg="none"
                      pt="8px"
                      onClick={() =>
                        document.getElementById("file-upload").click()
                      }
                      sx={{ _hover: { bg: "none" } }}
                    >
                      <Image src="/assets/svgs/image-search-blue.svg" />
                    </Box>
                    <input
                      type="file"
                      id="file-upload"
                      style={{ display: "none" }}
                      //onChange={(e) => setFile(e.target.files[0])}
                      onChange={handleimageselection}
                    />
                  </InputRightElement>
                </InputGroup>
                <InputGroup>
                <PrimaryInput
                variant="bothSide"
                  inputValue={Composition}
                  onChange={(event)=> setComposition(event.target.value)}
                  inputPlace="Chemical Composition"
                />
                <Box
                  as="button"
                  type="button"
                  border="1px solid #E6E7E9"
                  // borderRadius="full"
                  width={{ base: "100%", md: "10%" }}
                  // w="40px"
                  // h="40px"
                  p="8px"
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  // cursor={medicineTextFieldValue ? "pointer" : "not-allowed"}
                  // opacity={medicineTextFieldValue ? 1 : 0.5}
                  // pointerEvents={medicineTextFieldValue ? "auto" : "none"}
                  onClick={() => {
                  if (isChatbotAllowed()) {
                    fetchComposition(medicinename);
                  } else {
                    showErrorToast("Please upgrade your subscription to use this feature");
                  }
                }}
                isDisabled={!isChatbotAllowed()}
                title={!isChatbotAllowed() ? "Please upgrade your subscription to use AI features" : ""}
                  bg="white"
                  // _hover={medicineTextFieldValue ? { bg: "#f0f0f0" } : {}}
                >
                  <Image w="28px" src="/assets/svgs/ai-star-outline.svg" />
                </Box>
                  {/* <PrimaryButton
                          buttonText="Fetch"
                          verticalAlign="bottom"
                          variant="grayBtn"
                          btnStyle={{
                            w: "15%",
                            color: COLORS.PRIMARY_COLOR,
                            verticalAlign: "bottom",
                            ml: "4px",
                            mb: "0px",
                            h: "48px",
                            m: "0",
                            borderRadius: "0 10px 10px 0",
                            opacity: isChatbotAllowed() ? 1 : 0.6,
                              cursor: isChatbotAllowed() ? "pointer" : "not-allowed"
                          }}
                          onClick={() => {
                                if (isChatbotAllowed()) {
                                  fetchComposition(medicinename);
                                } else {
                                  showErrorToast("Please upgrade your subscription to use this feature");
                                }
                              }}
                              isDisabled={!isChatbotAllowed()}
                              title={!isChatbotAllowed() ? "Please upgrade your subscription to use AI features" : ""}
                          // onClick={() =>
                          //   fetchComposition(medicinename)
                          // }
                          // isDisabled={false}
                        /> */}
                </InputGroup>
                {medicinename != ''  &&
                        <Box as="button" onClick={makeAicall} textAlign="right" fontSize="12px" textDecoration="underline">Learn more</Box>
                        }
                <RadioGroup
                mt="1rem"
                  defaultValue={medicinetype}
                  onChange={handlemedicinetypechange}
                >
                   <Divider />
                  <Stack direction="row" gap="20px"  wrap="wrap">
                     <Radio value="Tablet">Tablet</Radio>
                    <Radio value="Capsule">Capsule</Radio>
                    <Radio value="Syrup">Syrup</Radio>
                    <Radio value="Injection">Injection</Radio>
                    <Radio value="Ointment">Ointments / Creams / Gels</Radio>
                    <Radio value="Drops">Drops</Radio>
                    <Radio value="Nebulization">Nebulization</Radio>
                    <Radio value="IVFluids">IV Fluids</Radio>
                    <Radio value="Inhaler">Inhaler</Radio>

                  </Stack>
                </RadioGroup>
                <Divider />
                <Box>
                  {/* <MiniDropdownInput
                    variant="bothside"
                    options={[
                      { label: "mg", value: "mg" },
                      { label: "ml", value: "ml" },
                    ]}
                    placeholderProp="Dosage"
                    defaultValue={dosage}
                    inputVal={dosage}
                    defaultOptionProp={dosageunit}
                    onSelect={handleChangeDosageUnit}
                    handleInputChange={(e) =>
                      setMedicineDosage(validationOfNumberWithOnly1Decimal(e.target.value))
                    }
                    maxLength="6"
                  /> */}

                  {medicinetype == "Tablet" || medicinetype == "Capsule" ?
                                  (
                                      <MiniDropdownInput
                                      variant="bothside"
                                      options={ [
                                      { label: "mg", value: "mg" },
                                      { label: "mcg", value: "mcg" },
                                      { label: "g", value: "g" },
                                      // { label: "ml", value: "ml" },
                                      // { label: "grms", value: "grms" },
                                        ] }
                                  
                                      placeholderProp={  medicinetype == "Syrup" || medicinetype == "Injection" ||  medicinetype == "Nebulization" ||  medicinetype == "IVFluids" || medicinetype == "Drops"  ? "Volume" :  "Strength"}
                                      onSelect={handleChangeDosageUnit}
                                      handleInputChange={(e) =>
                                        setMedicineDosage(validationOfNumberWithOnly1Decimal(e.target.value))
                                      }
                                      inputVal={dosage}
                  
                                      defaultOptionProp={dosageunit}
                                      maxLength="6"
                                    />
                                  ): medicinetype === "Inhaler" ? (
                                    <MiniDropdownInput
                                      variant="bothside"
                                      // options={[{ label: "puffs", value: "puffs" }]}
                                      options={ [
                                        { label: "puffs", value: "puffs" },
                                        { label: "ml", value: "ml" },
                                      { label: "grms", value: "grms" },
                                        ] }
                                  
                                      placeholderProp={medicinetype == "Inhaler" ? "Volume" :  "Strength"}
                                      onSelect={handleChangeDosageUnit}
                                      handleInputChange={(e) =>
                                        setMedicineDosage(validationOfNumberWithOnly1Decimal(e.target.value))
                                      }
                                      inputVal={dosage}
                  
                                      defaultOptionProp={dosageunit}
                                      maxLength="6"
                                    />
                                  ) : (
                                    <MiniDropdownInput
                                      variant="bothside"
                                      options={ [
                                      { label: "mg", value: "mg" },
                                      { label: "ml", value: "ml" },
                                      { label: "grms", value: "grms" },
                                        ] }
                                  
                                      placeholderProp={  medicinetype == "Syrup" || medicinetype == "Injection" ||  medicinetype == "Nebulization" ||  medicinetype == "IVFluids" || medicinetype == "Drops"  ? "Volume" :  "Strength"}
                                      onSelect={handleChangeDosageUnit}
                                      handleInputChange={(e) =>
                                        setMedicineDosage(validationOfNumberWithOnly1Decimal(e.target.value))
                                      }
                                      inputVal={dosage}
                  
                                      defaultOptionProp={dosageunit}
                                      maxLength="6"
                                    />
                                  )}

                  <Box display="flex" flexDir="row">
                  {/* <PrimaryInput

                      variant="bothSide"
                      id="vitaldate"
                      inputType="date"
                      inputPlace="From"
                      inputStyleCss={{ w: "50%" }}
                      defaultValue={fromdate}
                      onChange={(e) => setFromDate(e.target.value)}
                    />
                    <PrimaryInput
                      variant="bothSide"
                      id="vitaldate"
                      inputType="date"
                      inputPlace="To"
                      inputStyleCss={{ w: "50%" }}
                      defaultValue={todate}
                      onChange={(e) => setToDate(e.target.value)}
                    /> */}
                      {/* <DatePicker 
                      disableFutureDates={true}
                      defaultDate={fromdate} 
                      onDateChange={(selectedDateValue) =>
                        handleFromDateChange(selectedDateValue)
                      }
                      placeholderProp={"Start Date"} 
                      calendarStlye={{left: "-18px",  right: "unset"}}
                      maxDate={maxDateStateEdit}
                    />
                    <DatePicker 
                      defaultDate={todate} 
                      onDateChange={(selectedDateValue) =>
                        handleToDateChange(selectedDateValue)
                      }
                      placeholderProp={"End Date"} 
                      calendarStlye={{transform: "scale(0.9)", right: "-22px", top: "30px"}}
                      
                      disablePastDates={true}
                      
                      minDate={minDateStateEdit}
                      
                    /> */}


                  </Box>
                 
                 {/* New inputs in edit form Start ||----    */}
                 {medicinetype == "IVFluids" &&

<MiniDropdownInput
  variant="bothside"
  options={[
    { label: "ml/hr", value: "ml/hr" },
    { label: "ml/min", value: "ml/min" },
    // { label: "grms/hr", value: "grms/hr" },
  ]}
  handleInputChange={(e) =>
    setRateOfInfusionValue(validationOfNumberWithOnly1Decimal(e.target.value))
  }
  placeholderProp={"Rate of Infusion"}
  onSelect={handleRateOfInfusionUnit}
  maxLength="6"
  defaultOptionProp={rateOfInfusionUnit}
   defaultValue={rateOfInfusionValue}
/>

}

<Box display="flex" flexDir="row">


</Box>

<Divider my="10px" />
<Text fontSize="0.875rem" fontWeight="500" mb="10px">{medicinetype == "Ointment" ? "Application Frequency" : "Frequency"}</Text>
<DropdownInput
variant="downSide"
dropDownPlace={medicinetype == "Ointment" ? "Application Frequency" : medicinetype == "Nebulization" || medicinetype == "Inhaler" || medicinetype == "IVFluids" ? "Frequency" : "Consumption Quantity"}
options={["0.5", "1", "2", "3", "4", "5", "6", "7",]}
onClick={handleconsumptionfrequencychange}
defaultOption={frequency}
/>
<DropdownInput
variant="bothSide"
dropDownPlace="Frequency Interval"
options={["Hours", "Days", "Weeks", "Months", "Years"]} // Interval units as options
onClick={handleFrequencyUnit}
defaultOption={medicineFreqUnit}
/>

<Divider my="10px" />


{(medicinetype == "Injection" || medicinetype == "Tablet" ||medicinetype == "Capsule" ) &&
<>
{/* <Divider my="10px" /> */}
  <Text fontSize="0.875rem" fontWeight="500" mb="10px">Duration</Text>

  <Box display="flex" flexDir="row">

    <Box width="50%">
      <DropdownInput
        variant="bothSide"
        dropDownPlace="Duration"
        options={["Hours", "Days", "Weeks", "Months", "Years"]}
        onClick={handleDurationUnit}
        defaultOption={durationUnit}
      />
    </Box>
    <Box width="50%">
      <DropdownInput
        variant="downSide"
        dropDownPlace="Interval Value"
        options={["1", "2", "3", "4", "5", "6", "7",]}
        onClick={handleDurationValue}
        defaultOption={durationValue}
      />
    </Box>
  </Box>
  <Divider my="10px" />
  </>
  }

{(medicinetype == "Injection") &&
<>
 

  <DropdownInput
    variant="downSide"
    dropDownPlace="Route of Administration"
    options={["Intravenous (IV)", "Intramuscular (IM)", "Subcutaneous (SC)"]}
    onClick={handleRouteOfAdministration}
    defaultOption={routeOfAdministration}
  />
  <Box>
    <PrimaryInput
      variant={"bothSide"}
      onChange={handleTiming}
      inputPlace="Timing"
      defaultValue={timing}
    />
  </Box>

</>
}

{(medicinetype == "Ointment") &&
<>

  {/* <Divider my="10px" /> */}
  <Text fontSize="0.875rem" fontWeight="500" mb="10px">Application Duration</Text>
  <Box display="flex" flexDir="row">
    <Box width="50%">
      <DropdownInput
        variant="bothSide"
        dropDownPlace="Duration"
        options={["Until symptoms resolve", "Hours", "Days", "Weeks", "Months", "Years"]} // Interval units as options
        onClick={handleDurationUnit}
        defaultOption={durationUnit}
      />
    </Box>
    <Box width="50%">
      <DropdownInput
        variant="downSide"
        dropDownPlace="Interval Value"
        options={["1", "2", "3", "4", "5", "6", "7",]}
        onClick={handleDurationValue}
        defaultOption={durationValue}
      />
    </Box>

  </Box>

  <Divider my="10px" />

  <DropdownInput
    variant="downSide"
    dropDownPlace="Quantity"
    options={["Pea-sized", "Thin layer", "Fingertip unit (FTU)", "Half a fingertip"]}
    onClick={handleQuantity}
    defaultOption={quantity}
  />
  <PrimaryInput
    variant={"bothSide"}
    onChange={handleAreaOfApplication}
    inputPlace="Area of Application"
    defaultValue={areaOfApplication}
  />
</>
}


{(medicinetype == "Nebulization") &&
<>

  {/* <Divider my="10px" /> */}
  <Text fontSize="0.875rem" fontWeight="500" mb="10px">Duration</Text>

  <Box display="flex" flexDir="row">

    <Box width="50%">
      <DropdownInput
        variant="bothSide"
        dropDownPlace="Duration"
        options={["Hours", "Days", "Weeks", "Months", "Years"]}
        onClick={handleDurationUnit}
        defaultOption={durationUnit}
      />
    </Box>
    <Box width="50%">
      <DropdownInput
        variant="downSide"
        dropDownPlace="Interval Value"
        options={["1", "2", "3", "4", "5", "6", "7",]}
        onClick={handleDurationValue}
        defaultOption={durationValue}
      />
    </Box>
  </Box>
  <Divider my="10px" />

  <DropdownInput
    variant="downSide"
    dropDownPlace="Diluent"
    options={["Normal saline", "Distilled water" , "3% saline"]}
    onClick={handleDiluent}
    defaultOption={diluent}
  />

</>
}


{(medicinetype == "IVFluids") &&
<>
  {/* <Divider my="10px" /> */}
  <Text fontSize="0.875rem" fontWeight="500" mb="10px">Infusion Duration</Text>

  <DropdownInput
    variant="downSide"
    dropDownPlace="Infusion frequency"
    options={["1", "2", "3", "4", "5", "6", "7",]}
    onClick={handleDurationValue}
    defaultOption={durationValue}
  />
  <DropdownInput
    variant="bothSide"
    dropDownPlace="Infusion Duration"
    options={["Hours", "Days", "Weeks", "Months", "Years"]}
    onClick={handleDurationUnit}
    defaultOption={durationUnit}
  />

  <Divider my="10px" />

  <PrimaryInput
    variant={"bothSide"}
    onChange={handleAdditives}
    inputPlace="Additives"
    defaultValue={additives}
  />


</>
}

{(medicinetype == "Inhaler") &&
<>

  {/* <Divider my="10px" /> */}
  <Text fontSize="0.875rem" fontWeight="500" mb="10px">Duration</Text>

  <Box display="flex" flexDir="row">

    <Box width="50%">
      <DropdownInput
        variant="bothSide"
        dropDownPlace="Duration"
        options={["Hours", "Days", "Weeks", "Months", "Years"]}
        onClick={handleDurationUnit}
        defaultOption={durationUnit}
      />
    </Box>
    <Box width="50%">
      <DropdownInput
        variant="downSide"
        dropDownPlace="Interval Value"
        options={["1", "2", "3", "4", "5", "6", "7",]}
        onClick={handleDurationValue}
        defaultOption={durationValue}
      />
    </Box>
  </Box>
  <Divider my="10px" />

  <DropdownInput
    variant="downSide"
    dropDownPlace="Diluent"
    options={["Normal saline", "Distilled water" , "3% saline"]}
    onClick={handleDiluent}
  />

</>
}
{/* New inputs in edit form End ----|| */}

                  {/* <PrimaryInput
                    inputPlace="Medicine Expiry"
                    variant="defaultSide"
                    defaultValue={medicineexpirydate}
                    inputValue={medicineexpirydate}
                    onChange={(event) => handleExpiryDateChange(event.target.value)}
                  /> */}
                  {/* <DatePickerMonthYear */}
                  <MonthYearPicker
        placeholderProp="Medicine Expiry"
        value={medicineexpirydate}
        onDateChange={handleMonthYearChange}
        datePickerInputStyle={{ borderRadius: "0!important" }}
        
        defaultDate={medicineexpirydate}
        minYear={moment().year()}
        // minDate={moment().startOf('month')}

      />
                  <CheckboxGroup
                    colorScheme="green"
                  //onChange={handlemedicinetime}               
                  >
                    <Stack spacing={2} pt="20px" direction="row">
                      <Checkbox isChecked={morning === 1} onChange={() => setMorning(morning === 1 ? 0 : 1)}>Morning</Checkbox> 
                      <Checkbox w='33.33%' ml='6px' isChecked={afternoon === 1} onChange={() => setAfternoon(afternoon === 1 ? 0 : 1)}>Afternoon</Checkbox>
                      {/* <Checkbox isChecked={setevening === 1} onChange={() => setEvening(setevening === 1 ? 0 : 1)}>Evening</Checkbox> */}
                      <Checkbox isChecked={setnight === 1} onChange={() => setNight(setnight === 1 ? 0 : 1)}>Night</Checkbox>
                    </Stack>
                  </CheckboxGroup>
                  {/* <Divider /> */}
                  <CheckboxGroup
                    colorScheme="green"
                  >
                    <Stack spacing={2} pt="20px" direction="row">
                      <Checkbox isChecked={beforefood === 1} onChange={() => setBeforefood(beforefood === 1 ? 0 : 1)}>Before Food</Checkbox>
                      <Checkbox isChecked={afterfood === 1} onChange={() => setAfterfood(afterfood === 1 ? 0 : 1)}>After Food</Checkbox>
                    </Stack>
                  </CheckboxGroup>
                  
                </Box>
                <Divider />
                <Box>
                  
                <Box w="100%" pos='relative' cursor="pointer">
                  <PrimaryInput
                    inputPlace="Prescribed by"
                    variant="defaultSide"
                    onChange={(e) =>
                      handleSurgeonNameChange(handleAlphaDotAndSpace(e.target.value,50))
                    }
                    onClick={() =>
                      listOfSurgeonNames(false)
                    }
                    defaultValue={prescribedby}
                    inputValue={prescribedby}

                    
                inputIdProp={"DoctorNameInEdit"}
                boolProp={boolValForSuggestions}
                  />
                    <Image top="33%" right="6.5%" w="15px" 
                          onClick={() =>
                            listOfSurgeonNames( true)
                          }
                            pos='absolute' src="/assets/imgs/double-arrow.png" />

                  {showDocNamesDropdown &&  suggestions.length > 0 && (
                <Menu isOpen={true}>
                <MenuButton as={Box} w="100%" display="block" pos="relative" zIndex="999">
                  <Box pos="absolute" top="100%" left="0" w="100%" bg="white" borderTop="none" border="1px solid #E6E7E9" borderRadius="0 0 12px 12px" />
                </MenuButton>
                <MenuList w="100%" borderRadius="0 0 12px 12px" zIndex="999" bg="white" maxH="150px" overflow="hidden auto">
                  {suggestions.map((suggestion, index) => (
                    <MenuItem
                      key={index}
                      onClick={() => handleSelect(suggestion)}
                      cursor="pointer"
                      p="1rem"
                      py="0.5rem"
                      borderBottom="1px solid #E6E7E9"
                    >
                      <Text fontSize="0.875rem" fontWeight="500">{suggestion.doctorname}</Text>
                    </MenuItem>
                  ))}
                  </MenuList>
                </Menu>
              )}
              </Box>
                  <PrimaryInput
                    inputPlace="Hospital name"
                    variant="downSide"
                    onChange={(e) => setHospitalname(handleAlphaNumericDotAndSpace(e.target.value))}
                    defaultValue={hospitalname}
                  />
                </Box>
                <Box mt="15px">
                  <Checkbox
                colorScheme="green"
                sx={{
                  ".chakra-checkbox__control": {
                    width: "20px",
                    height: "20px",
                    borderRadius: "5px",
                  },
                }}
                isChecked={isChecked == 1}
                onChange={handleIsCurrent}
              >
                  Current
              </Checkbox>
              </Box>

                {/* {filenameforUpload && filenameforUpload.map((filename, index) => ( */}
                {documentURLForEdit?.map((document, index) => (
              
                  <Button
                    key={index}
                    w="100%"
                    h="48px"
                    my="15px"
                    borderRadius="10px"
                    border="1px solid #E6E7E9"
                    display="flex"
                    justifyContent="space-between"
                    bg="white"
                    color="#1C4EC5"
                    sx={{ _hover: { bg: "none" } }}
                    // onClick={()=>downloadDocument(`https://midocfileserver.blob.core.windows.net/midocdev/${filename}`)}
                    onClick={() => handleDeleteDocInEdit(index)}
                    cursor="pointer"
                  >
                    Document {index + 1}
                    <Box as="span">
                      <Image src="/assets/imgs/delete.png" />
                    </Box>
                  </Button>
                ))}
                {/* <Button fontSize="14px" fontWeight="500" w="100%" h="48px" borderRadius="10px" border="1px solid #E6E7E9" display="flex" justifyContent="space-between" bg="white" color="#1C4EC5" sx={{_hover: {bg:"none"}}}>
                  12/01/24_Report.pdf
                  <Box as="span">
                      <Image src="/assets/imgs/delete.png" />
                  </Box>
                </Button>*/}
                <Box onClick={updateMedicationDocuments} as="button" display="flex" alignItems="center" gap="10px" fontSize="14px" fontWeight="600" color="#1C4EC5" textAlign="left">
                  <Image w="11px" src="/assets/imgs/add-blue.png" />
                  Add Document
                </Box>
                <input
                  type='file'
                  id='file-upload'
                  onChange={(e) => handleMedicationUploadUpdate(e)}
                  ref={fileInputRefUpdate} // Set the ref for the file input
                  style={{ display: 'none' }} // Hide the file input
                />
              </Stack>
            </Box>
          </>
        }
        footerActions={
          <>
            <Box w="100%" display="flex" flexDirection="row" gap="15px">
              <PrimaryButton
                buttonText="Update Medication"
                onClick={editmedicine}
                btnStyle={{my: "0"}}
                
              isDisabled={actionAccessPatients?.update ? false : true}
              />
            </Box>
          </>
        }
      />
      <DynamicModal
        ref={dynamicModal}
        modalHeader="Delete Medicine?"
        modalBody={
          <>
            <Text fontSize="14px" fontWeight="600">
              Are you sure you want to delete <br />
              <strong>"{title ? title : "-"}"</strong>
            </Text>
          </>
        }
        modalFooterBtn={
          <>
            <PrimaryButton
              variant="deleteBtn"
              buttonText="Delete"
              onClick={deletemedicine}
            />
          </>
        }
      />

<DynamicModal
        ref={learnMoreModal}
        modalHeader={medicinename}

        modalStyle={{maxWidth: "calc(100vw - 45%)",maxHeight: "calc(100vh - 30%)", overflow:"hidden auto", w: "100%"}}
        modalBody={
          <>
          
          <Box mb="10px" >
            <Text fontSize="14px" fontWeight="600">
              Benifit  
            </Text>
            <Box as="span" >{benifit ? benifit : ''}</Box>
            </Box>
            
            <Box mb="10px" >
            <Text fontSize="14px" fontWeight="600">
              Side Effect 
            </Text>
            <Box as="span"  > {sideEffects ? sideEffects : ''}</Box>
            </Box>
            
          <Box mb="10px" >
            <Text fontSize="14px" fontWeight="600">
                {Composition == "Not Available" ? "" : "Composition" }
            </Text>
            <Box as="span" mb="10px">{Composition == "Not Available" ? "" : Composition }</Box>
            </Box>
          </>
        }
        
      />

<AiModal
        ref={AIChatModel}
      modalSize="420px"
      //icon="/assets/imgs/ai-doctor.png"
      header={<>
        <Box display="flex" flexDir='column'>
          <Text fontSize="1rem" fontWeight="700" backgroundImage="linear-gradient(to right top, #0d7e54, #007774, #006d94, #005ea7, #1146a0)" color="transparent" backgroundClip="text">Aira - AI</Text>
          <Text fontSize="0.75rem" fontWeight="400">Chat with your AI health guide</Text>
        </Box>
      </>}
      headerStyle={{ p: "24px 32px", lineHeight: "normal" }}
      closeBtnStyle={{ top: "18px" }}
      footerStyle={{ maxH: "35%", overflow: "hidden auto", boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px" }}
      withoutBg={true}
      backDropBlur="10px"
      body={
        <>
          <Flex flexDirection="column" height="100%">
            <Box
              p="24px 32px"
              ref={chatContainerRef}
              className="chat-container"
              style={{ overflowY: "auto", maxHeight: 'calc(100vh - 160px)' }}
            >
              {initialRender && remainingquestions.length > 0 && (
                <Box>
                  {remainingquestions.map((step, index) => (
                    <Box
                      key={index}
                      as="button"
                      w="100%"
                      p="16px"
                      mb="16px"
                      fontSize="14px"
                      fontWeight="600"
                      display="flex"
                      flexDirection="row"
                      alignItems="center"
                      textAlign='left'
                      gap='10px'
                      justifyContent="space-between"
                      borderRadius="10px"
                      border="1px solid #7795DC"
                      bg="#EAEDF5"
                      color="#163E9E"
                      onClick={() => GetAIAnswer(step.value)}
                      className={`question-box ${animate ? 'slide-in' : ''}`}
                    >
                      {step.value ? step.value : "-"}
                      <Image src="/assets/imgs/right-icon.png" />
                    </Box>
                  ))}
                </Box>
              )}
              {aianswers.map((step, index) => (
                <React.Fragment key={index}>
                  <Box
                    as="div"
                    bg="#061027"
                    p="12px 16px"
                    w="fit-content"
                    float="right"
                    borderRadius="10px 10px 1px 10px"
                    className={`answer-box ${animate ? 'slide-in' : ''}`}
                  >
                    <Text fontSize="14px" fontWeight="500" color="white">
                      {step.question ? step.question : "-"}
                    </Text>
                  </Box>

                  <Box
                    as="div"
                    my="20px"
                    w="fit-content"
                    display="flex"
                    alignItems="end"
                    float="left"
                    className={`answer-box ${animate ? 'slide-in' : ''}`}
                  >
                    <Image
                      bg="#061027"
                      p="4px"
                      mr="8px"
                      borderRadius="6px"
                      src="/assets/imgs/ai-chat-logo.png"
                    />
                    <Text
                      bg="#E6E7E980"
                      p="12px 16px"
                      fontSize="14px"
                      fontWeight="500"
                      color="#061027"
                      borderRadius="10px 10px 10px 1px"
                    >
                      {step.answer ? step.answer : <TypingLoader />}
                    </Text>
                  </Box>
                </React.Fragment>
              ))}
            </Box>
          </Flex>
        </>
      }
      footerActions={
        !initialRender && (
          <Box
            p="24px 32px"
            display="flex"
            w="100%"
            h="100%"
            flexDirection="column"
            justifyContent="space-between"
          >
            <Box w="100%">
              {remainingquestions.map((step, index) => (
                <Box
                  key={index}
                  as="button"
                  w="100%"
                  p="16px"
                  mb="16px"
                  fontSize="14px"
                  fontWeight="600"
                  display="flex"
                  flexDirection="row"
                  alignItems="center"
                  justifyContent="space-between"
                  borderRadius="10px"
                  border="1px solid #7795DC"
                  bg="#EAEDF5"
                  color="#163E9E"
                  onClick={() => GetAIAnswer(step.value)}
                  className={`question-box ${animate ? 'slide-in' : ''}`}
                >
                  {step.value ? step.value : "-"}
                  <Image src="/assets/imgs/right-icon.png" />
                </Box>
              ))}
            </Box>
          </Box>
        )
      }
    />


<DynamicModal
                ref={editMedication}
                modalHeader="Edit medication"
                // modalWidth="900px"
      modalWidth={{base:'100%', md: 'calc(100vw - 40%)'}}
                hasFooter= {false}
                modalBody={
                  <>
                  {editMedicine && (
                  <Box key={editMedicine.id}>
                    {/* {editMedicine && editMedicine.id === medicine.id && ( */}
                      <Box
                        // p="20px"
                        // border="1px solid gray"
                        borderRadius="10px"
                        mt="10px" // Add some margin-top to separate from the above row
                      >
                        <Stack spacing={4}>
                          <Flex
                            width="100%"
                            justifyContent="space-between"
                            alignItems="center"
                          >
                            {/* newly added code */}
                            {apmtIdUrl && (
                            <Box width="45%">
  <Box w="100%" pos="relative" cursor="pointer">
    <PrimaryInput
      variant="bothSide"
      inputPlace="Medicine name"
      inputValue={editMedicine.medicinename}
      onChange={(e) => {
        handleEditMedicineChange("medicinename", e.target.value);
        setMedicineSearchTerm(e.target.value);
        if (e.target.value.length >= 3) {
          searchMedicines(e.target.value);
          setShowMedicineNamesDropdown(0);
        } else {
          setSuggestions([]);
          setShowMedicineNamesDropdown(-1);
        }
      }}
      inputIdProp={"MedicineNameInAdd" + 0}
      boolProp={boolValForSuggestions}
      onKeyDown={(e) => handleEditKeyDown(e, 0)}
      autoFocus={showMedicineNamesDropdown === 0}
      autocomplete="off"
    />
    <Image
      top="33%"
      right="6.5%"
      w="15px"
      pos="absolute"
      src="/assets/imgs/double-arrow.png"
    />
  </Box>
  
  {showMedicineNamesDropdown === 0 && suggestions.length > 0 && (
    <Menu isOpen={true}>
      <MenuButton
        as={Box}
        w="100%"
        display="block"
        pos="relative"
        zIndex="999"
      >
        <Box
          pos="absolute"
          top="100%"
          left="0"
          w="100%"
          bg="white"
          borderTop="none"
          border="1px solid #E6E7E9"
          borderRadius="0 0 12px 12px"
        />
      </MenuButton>
      <MenuList
        w="100%"
        borderRadius="0 0 12px 12px"
        zIndex="999"
        bg="white"
        maxH="150px"
        overflow="hidden auto"
        ref={suggestionsMenuRef}
      >
        {isSearching ? (
          <MenuItem>
            <Text fontSize="0.875rem" fontWeight="500">
              Searching...
            </Text>
          </MenuItem>
        ) : suggestions.length > 0 ? (
          suggestions.map((suggestion, sIndex) => (
            <MenuItem
              key={sIndex}
              onClick={() => handleEditSelectIPD(suggestion)}
              cursor="pointer"
              p="1rem"
              py="0.5rem"
              borderBottom="1px solid #E6E7E9"
              bg={focusedItemIndex === sIndex ? "#f0f0f0" : "white"}
            >
              <Text fontSize="0.875rem" fontWeight="500">
                {suggestion.medicinename}
                {suggestion.dosage && ` ${suggestion.dosage}`}
                {suggestion.dosageunit && ` ${suggestion.dosageunit}`}
                {suggestion.medicinetype && ` (${suggestion.medicinetype})`}
              </Text>
            </MenuItem>
          ))
        ) : (
          <MenuItem>
            <Text fontSize="0.875rem" fontWeight="500">
              No medicines found
            </Text>
          </MenuItem>
        )}
      </MenuList>
    </Menu>
  )}
</Box>
                            )}

                            {/* edit existing code */}
                            {!apmtIdUrl && (
                            <Box width="45%">
                              <Box w="100%" pos="relative" cursor="pointer">
                                <PrimaryInput
                                  variant="bothSide"
                                  inputPlace="Medicine name"
                                  inputValue={editMedicine.medicinename}
                                  onChange={(e) => {
                                    handleEditMedicineChange(
                                      "medicinename",
                                      e.target.value
                                    );
                                    filterMedicineNames(e.target.value);
                                    setShowMedicineNamesDropdown(0);
                                    setBoolValForSuggestions(
                                      !boolValForSuggestions
                                    );
                                  }}
                                  inputIdProp={"MedicineNameInAdd" + 0}
                                  boolProp={boolValForSuggestions}
                                  onKeyDown={(e) => handleEditKeyDown(e, 0)}
                                  autoFocus={showMedicineNamesDropdown === 0}
                                  autocomplete="off"
                                />
                                <Image
                                  top="33%"
                                  right="6.5%"
                                  w="15px"
                                  pos="absolute"
                                  src="/assets/imgs/double-arrow.png"
                                />
                              </Box>
                              {showMedicineNamesDropdown === 0 &&
                                suggestions.length > 0 && (
                                  <Menu isOpen={true}>
                                    <MenuButton
                                      as={Box}
                                      w="100%"
                                      display="block"
                                      pos="relative"
                                      zIndex="999"
                                    >
                                      <Box
                                        pos="absolute"
                                        top="100%"
                                        left="0"
                                        w="100%"
                                        bg="white"
                                        borderTop="none"
                                        border="1px solid #E6E7E9"
                                        borderRadius="0 0 12px 12px"
                                      />
                                    </MenuButton>
                                    <MenuList
                                      w="100%"
                                      borderRadius="0 0 12px 12px"
                                      zIndex="999"
                                      bg="white"
                                      maxH="150px"
                                      overflow="hidden auto"
                                      ref={suggestionsMenuRef}
                                    >
                                      {suggestions.map((suggestion, sIndex) => (
                                        <MenuItem
                                          key={sIndex}
                                          onClick={() =>
                                            handleEditSelect(suggestion, 0)
                                          }
                                          cursor="pointer"
                                          p="1rem"
                                          py="0.5rem"
                                          borderBottom="1px solid #E6E7E9"
                                          bg={
                                            focusedItemIndex === sIndex
                                              ? "#f0f0f0"
                                              : "white"
                                          }
                                        >
                                          <Text
                                            fontSize="0.875rem"
                                            fontWeight="500"
                                          >
                                            {suggestion.productname +
                                              " (" +
                                              suggestion.remainingquantity +
                                              " Qty)"}
                                          </Text>
                                        </MenuItem>
                                      ))}
                                    </MenuList>
                                  </Menu>
                                )}
                            </Box>                          
                            )}
                            <Box width={{ base: "100%", md: "45%" }}>
                        <PrimaryInput
                          key={key}
                          type="text"
                          variant={"bothSide"}
                          inputPlace="Manufacturer"
                          defaultValue={editMedicine.manufacturer || ""}
                          inputValue={editMedicine.manufacturer || ""}
                          onChange={(e) =>
                            handleEditMedicineChange(
                              "manufacturer",
                              e.target.value
                            )
                          }
                        />{" "}
                      </Box>
                            <Box width="45%">
                              <PrimaryInput
                                key={compositionEditKey}
                                type="text"
                                variant="bothSide"
                                inputPlace="Medicine Composition"
                                defaultValue={editMedicine.chemicalcomposition}
                                onChange={(e) =>
                                  handleEditMedicineChange(
                                    "chemicalcomposition",
                                    e.target.value
                                  )
                                }
                              />{" "}
                            </Box>
                            <Box
                              as="button"
                              type="button"
                              border="1px solid #E6E7E9"
                              // borderRadius="full"
                              width={{ base: "100%", md: "10%" }}
                              // w="40px"
                              // h="40px"
                              p="8px"
                              display="flex"
                              justifyContent="center"
                              alignItems="center"
                              // cursor={medicineTextFieldValue ? "pointer" : "not-allowed"}
                              // opacity={medicineTextFieldValue ? 1 : 0.5}
                              // pointerEvents={medicineTextFieldValue ? "auto" : "none"}
                              onClick={() => {
                              if (isChatbotAllowed()) {
                                fetchCompositionForEdit(editMedicine.medicinename);
                              } else {
                                showErrorToast("Please upgrade your subscription to use this feature");
                              }
                            }}
                            isDisabled={!isChatbotAllowed()}
                            title={!isChatbotAllowed() ? "Please upgrade your subscription to use AI features" : ""}
                              bg="white"
                              // _hover={medicineTextFieldValue ? { bg: "#f0f0f0" } : {}}
                            >
                              <Image w="28px" src="/assets/svgs/ai-star-outline.svg" />
                            </Box>
                            {/* <Box width="10%">
                              <PrimaryButton
                                buttonText="Fetch"
                                verticalAlign="bottom"
                                variant="grayBtn"
                                btnStyle={{
                                  w: "100%",
                                  color: COLORS.PRIMARY_COLOR,
                                  verticalAlign: "bottom",
                                  ml: "4px",
                                  mb: "0px",
                                  h: "2.8rem",
                                  opacity: isChatbotAllowed() ? 1 : 0.6,
                              cursor: isChatbotAllowed() ? "pointer" : "not-allowed"
                                }}
                                onClick={() => {
                                if (isChatbotAllowed()) {
                                  fetchCompositionForEdit(editMedicine.medicinename);
                                } else {
                                  showErrorToast("Please upgrade your subscription to use this feature");
                                }
                              }}
                              isDisabled={!isChatbotAllowed()}
                              title={!isChatbotAllowed() ? "Please upgrade your subscription to use AI features" : ""}
                                // onClick={() =>
                                //   fetchCompositionForEdit(
                                //     editMedicine.medicinename
                                //   )
                                // }
                                // isDisabled={false}
                              />
                            </Box> */}
                          </Flex>
                          <RadioGroup
  //                           defaultValue={editMedicine.medicinetype}
  //                           onChange={(value) => {
  //   handleEditMedicineChange("medicinetype", value);

  //   // Set default dosage units based on medicine type
  //   if (value === "Syrup" || value === "Drops" || value === "Suspension" || 
  //       value === "Respules" || value === "Gargle" || value === "Shampoo" || 
  //       value === "Topical Cleanser") {
  //     handleEditMedicineChange("dosageunit", "ml");
  //   } else if (value === "Tablet" || value === "Capsule" || value === "Suppository" || 
  //              value === "Powder") {
  //     handleEditMedicineChange("dosageunit", "mg");
  //   } else if (value === "Injection" || value === "Nebulization" || value === "IVFluids") {
  //     handleEditMedicineChange("dosageunit", "ml");
  //   } else if (value === "Ointment" || value === "Cream" || value === "Gel" || 
  //              value === "Foam" || value === "Lotion" || value === "Tube" || 
  //              value === "Soap") {
  //     handleEditMedicineChange("dosageunit", "grms");
  //   } else if (value === "Inhaler" || value === "Spray" || value === "Aerosol") {
  //     handleEditMedicineChange("dosageunit", "puffs");
  //   } else if (value === "EA" || value === "Device" || value === "Box") {
  //     handleEditMedicineChange("dosageunit", "each");
  //   } else if (value === "Sachet") {
  //     handleEditMedicineChange("dosageunit", "mg"); // or 'g' as default
  //   } else if (value === "Custom") {
  //     handleEditMedicineChange("dosageunit", ""); // No default for custom
  //   }
  // }}

  value={additionalMedicineTypes.includes(editMedicine.medicinetype) ? "" : editMedicine.medicinetype}
  onChange={(value) => handleEditTypeChange(value)}

                            // existing
                            // onChange={(value) => {
                            //   handleEditMedicineChange("medicinetype", value);

                            //   if (value === "Syrup" || value === "Drops") {
                            //     handleEditMedicineChange("dosageunit", "ml");
                            //   } else if (value === "Tablet") {
                            //     handleEditMedicineChange("dosageunit", "mg");
                            //   } else if (value === "Capsule") {
                            //     handleEditMedicineChange("dosageunit", "mg");
                            //   } else if (value === "Injection") {
                            //     handleEditMedicineChange("dosageunit", "ml");
                            //   } else if (value === "Ointment") {
                            //     handleEditMedicineChange("dosageunit", "grms");
                            //   } else if (value === "Nebulization") {
                            //     handleEditMedicineChange("dosageunit", "ml");
                            //   } else if (value === "IVFluids") {
                            //     handleEditMedicineChange("dosageunit", "ml");
                            //   } else if (value === "Inhaler") {
                            //     handleEditMedicineChange("dosageunit", "puffs")
                            //   }
                            // }}
                          >
                            <Stack direction="row" alignItems='center' gap="20px" wrap="wrap">
                  <Radio colorScheme="green" value="Tablet">Tablet</Radio>
                  <Radio colorScheme="green" value="Capsule">Capsule</Radio>
                  <Radio colorScheme="green" value="Syrup">Syrup</Radio>
                  <Radio colorScheme="green" value="Drops">Drops</Radio>
                  <Radio colorScheme="green" value="Injection">Injection</Radio>
                  <Radio colorScheme="green" value="Nebulization">Nebulization</Radio>
                  <Radio colorScheme="green" value="IVFluids">IV Fluids</Radio>
                  <Radio colorScheme="green" value="Inhaler">Inhaler</Radio>
                  <Radio colorScheme="green" value="Sachet">Sachet</Radio>
                  <Radio colorScheme="green" value="Ointment">Ointment</Radio>
                  <Radio colorScheme="green" value="Cream">Cream</Radio>
                  <Radio colorScheme="green" value="Gel">Gel</Radio>  

                              {/* existing */}
                              {/* <Radio value="Tablet">Tablet</Radio>
                              <Radio value="Syrup">Syrup</Radio>
                              <Radio value="Drops">Drops</Radio>
                              <Radio value="Capsule">Capsule</Radio>
                              <Radio value="Injection">Injection</Radio>
                              <Radio value="Ointment">
                                Ointments / Creams / Gels
                              </Radio>
                              <Radio value="Nebulization">Nebulization</Radio>
                              <Radio value="IVFluids">IV Fluids</Radio>
                              <Radio value="Inhaler">Inhaler</Radio> */}
                            <Text>-Or-</Text>
                            <Box mx='1rem'>

                            <DropdownInput
    variant="bothSide"
    dropDownPlace="More Medicine Types"
    options={additionalMedicineTypes}
    onClick={(value) => handleEditTypeChange(value)}
    value={dropdownMedType}
    defaultOption={dropdownMedType || "Select more types"}
  />
                            </Box>
                            </Stack>
                          </RadioGroup>
                          <Divider />
                          <Box>
                            {/* Date Time & Doctor Field */}
                            {apmtIdUrl && (
                            <Box display="flex" flexDir="row">
                              <DropdownInput
                                variant="bothSide"
                                dropDownPlace="Doctor Name*"
                                options={DoctorListForDropdown || []}
                                id="Doctor Name"
                                onClick={(value) => {
      HandleEditDoctor(value);
      handleEditMedicineChange("doctor", value);
    }}
    value={editMedicine.doctor || DefaultDoctor || ""}
    defaultOption={DefaultDoctor || "Select Doctor"}

    //                             value={editMedicine.doctor || ""}
    // onChange={(value) => handleEditMedicineChange("doctor", value)}
                                menuList={{ pos: "absolute", right: "-41px", minW: "310px" }}
                                inputStyleCss={{ w: "100%" }}
                              />
                              <DatePicker
                                onDateChange={(selectedDateValue) => {
      const formattedDate = moment(selectedDateValue).format("DD-MM-YYYY");
      handleEditMedicineChange("updateddate", formattedDate);
    }}
    //                             onDateChange={(selectedDateValue) =>
    //   handleEditMedicineChange("updateddate", selectedDateValue)
    // }
                                // defaultDate={date}
                                defaultDate={editMedicine.updateddate || moment().format("DD-MM-YYYY")}
                                disableFutureDates={true}
                                placeholderProp="Date"
                                calendarStlye={{left: "-18px",  right: "unset"}}
                              />
                              <PrimaryInput
                                variant="bothSide"
                                id="vitaltime"
                                inputType="time"
                                inputPlace="Time"
                                pr="10px"
                                inputValue={editMedicine.updatedtime}
    // onChange={(e) => handleEditMedicineChange("updatedtime", e.target.value)}
                                defaultValue={editMedicine.updatedtime || moment().format("HH:mm")}
    onChange={(e) => {
      const inputTime = e.target.value;
      const currentDate = moment().format("DD-MM-yyyy");
      const currentTime = moment().format("HH:mm");
      // Only validate if the selected date in edit modal is today
      if (editMedicine.updateddate === currentDate) {
        const [inputHours, inputMinutes] = inputTime.split(":").map(Number);
        const [currentHours, currentMinutes] = currentTime.split(":").map(Number);
    
        // Create moment objects for comparison
        const inputMoment = moment().set({
          hour: inputHours,
          minute: inputMinutes,
          second: 0,
          millisecond: 0
        });
        
        const currentMoment = moment();
    
        if (inputMoment.isAfter(currentMoment)) {
          const currentFormattedTime = moment().format("HH:mm");
          handleEditMedicineChange("updatedtime", currentFormattedTime);
          showErrorToast("Future time cannot be selected.");
          return;
        }
      }else {
        // If date is not today or time is not in future, update the time
        handleEditMedicineChange("updatedtime", inputTime);
      }

      // existing code
      // const inputTime = e.target.value;
      // const currentTime = new Date();
      // const [inputHours, inputMinutes] = inputTime.split(":").map(Number);

      // const inputDate = new Date();
      // inputDate.setHours(inputHours);
      // inputDate.setMinutes(inputMinutes);

      // if (inputDate > currentTime) {
      //   const currentFormattedTime = moment().format("HH:mm");
      //   handleEditMedicineChange("updatedtime", currentFormattedTime);
      //   showErrorToast("Future time cannot be selected.");
      // } else {
      //   handleEditMedicineChange("updatedtime", inputTime);
      // }
    }}
                              />
                            </Box>
                            )}
                            <Box display="flex" flexDir="row">
                              <PrimaryInput
                          variant={"bothSide"}
                          inputPlace="Drug Class"
                          defaultValue={editMedicine.drugclass || ""}
                          inputValue={editMedicine.drugclass || ""}
                          onChange={(e) =>
                            handleEditMedicineChange(
                              "drugclass",
                              e.target.value
                            )
                          }
                        />
                        <PrimaryInput
                          variant={"bothSide"}
                          inputPlace="Therapeutic category"
                          defaultValue={editMedicine.therapeutic || ""}
                          inputValue={editMedicine.therapeutic || ""}
                          onChange={(e) =>
                            handleEditMedicineChange(
                              "therapeutic",
                              e.target.value
                            )
                          }
                        />

                            </Box>

                          <Box width='100%' display="flex" flexDir="row">
                            <Box>

                              {editMedicine.medicinetype === "Tablet" || 
 editMedicine.medicinetype === "Capsule" || 
 editMedicine.medicinetype === "Suppository" || 
 editMedicine.medicinetype === "Powder" ? (
  <MiniDropdownInput
    variant="bothSide"
    options={[
      { label: "mg", value: "mg" },
      { label: "mcg", value: "mcg" },
      { label: "g", value: "g" },
    ]}
    placeholderProp="Strength"
    defaultValue={editMedicine.dosage}
    defaultOptionProp={editMedicine.dosageunit}
    onSelect={(value) => handleEditMedicineChange("dosageunit", value.label)}
    handleInputChange={(event) =>
      handleEditMedicineChange(
        "dosage",
        validationOfNumberWithOnly1Decimal(event.target.value)
      )
    }
    inputVal={editMedicine.dosage}
    maxLength="6"
  />
) : editMedicine.medicinetype === "Inhaler" || 
    editMedicine.medicinetype === "Spray" || 
    editMedicine.medicinetype === "Aerosol" ? (
  <MiniDropdownInput
    variant="bothSide"
    options={[
      { label: "puffs", value: "puffs" },
      { label: "ml", value: "ml" },
    ]}
    placeholderProp="Volume"
    defaultValue={editMedicine.dosage}
    defaultOptionProp={editMedicine.dosageunit}
    onSelect={(value) => handleEditMedicineChange("dosageunit", value.label)}
    handleInputChange={(event) =>
      handleEditMedicineChange(
        "dosage",
        validationOfNumberWithOnly1Decimal(event.target.value)
      )
    }
    inputVal={editMedicine.dosage}
    maxLength="6"
  />
) : editMedicine.medicinetype === "Syrup" ||
    editMedicine.medicinetype === "Drops" ||
    editMedicine.medicinetype === "Injection" ||
    editMedicine.medicinetype === "Nebulization" ||
    editMedicine.medicinetype === "IVFluids" ||
    editMedicine.medicinetype === "Suspension" ||
    editMedicine.medicinetype === "Respules" ||
    editMedicine.medicinetype === "Gargle" ||
    editMedicine.medicinetype === "Shampoo" ||
    editMedicine.medicinetype === "Topical Cleanser" ? (
  <MiniDropdownInput
    variant="bothSide"
    options={[{ label: "ml", value: "ml" }]}
    placeholderProp="Volume"
    defaultValue={editMedicine.dosage}
    defaultOptionProp={editMedicine.dosageunit}
    onSelect={(value) => handleEditMedicineChange("dosageunit", value.label)}
    handleInputChange={(event) =>
      handleEditMedicineChange(
        "dosage",
        validationOfNumberWithOnly1Decimal(event.target.value)
      )
    }
    inputVal={editMedicine.dosage}
    maxLength="6"
  />
) : editMedicine.medicinetype === "Ointment" ||
    editMedicine.medicinetype === "Cream" ||
    editMedicine.medicinetype === "Gel" ||
    editMedicine.medicinetype === "Foam" ||
    editMedicine.medicinetype === "Lotion" ||
    editMedicine.medicinetype === "Tube" ||
    editMedicine.medicinetype === "Soap" ? (
  <MiniDropdownInput
    variant="bothSide"
    options={[
      { label: "grms", value: "grms" },
      { label: "ml", value: "ml" },
    ]}
    placeholderProp="Weight"
    defaultValue={editMedicine.dosage}
    defaultOptionProp={editMedicine.dosageunit}
    onSelect={(value) => handleEditMedicineChange("dosageunit", value.label)}
    handleInputChange={(event) =>
      handleEditMedicineChange(
        "dosage",
        validationOfNumberWithOnly1Decimal(event.target.value)
      )
    }
    inputVal={editMedicine.dosage}
    maxLength="6"
  />
) : editMedicine.medicinetype === "EA" || 
    editMedicine.medicinetype === "Device" || 
    editMedicine.medicinetype === "Box" ? (
  <MiniDropdownInput
    variant="bothSide"
    options={[{ label: "each", value: "each" }]}
    placeholderProp="Count"
    defaultValue={editMedicine.dosage}
    defaultOptionProp={editMedicine.dosageunit}
    onSelect={(value) => handleEditMedicineChange("dosageunit", value.label)}
    handleInputChange={(event) =>
      handleEditMedicineChange(
        "dosage",
        validationOfNumberWithOnly1Decimal(event.target.value)
      )
    }
    inputVal={editMedicine.dosage}
    maxLength="6"
  />
) : editMedicine.medicinetype === "Sachet" ? (
  <MiniDropdownInput
    variant="bothSide"
    options={[
      { label: "mg", value: "mg" },
      { label: "g", value: "g" },
    ]}
    placeholderProp="Strength"
    defaultValue={editMedicine.dosage}
    defaultOptionProp={editMedicine.dosageunit}
    onSelect={(value) => handleEditMedicineChange("dosageunit", value.label)}
    handleInputChange={(event) =>
      handleEditMedicineChange(
        "dosage",
        validationOfNumberWithOnly1Decimal(event.target.value)
      )
    }
    inputVal={editMedicine.dosage}
    maxLength="6"
  />
) : (
  // Default case for CUSTOM and any other types
  <MiniDropdownInput
    variant="bothSide"
    options={[
      { label: "mg", value: "mg" },
      { label: "ml", value: "ml" },
      { label: "grms", value: "grms" },
      { label: "puffs", value: "puffs" },
      { label: "each", value: "each" },
    ]}
    placeholderProp={editMedicine.medicinetype === "Custom" ? "Custom Unit" : "Strength"}
    defaultValue={editMedicine.dosage}
    defaultOptionProp={editMedicine.dosageunit}
    onSelect={(value) => handleEditMedicineChange("dosageunit", value.label)}
    handleInputChange={(event) =>
      handleEditMedicineChange(
        "dosage",
        validationOfNumberWithOnly1Decimal(event.target.value)
      )
    }
    inputVal={editMedicine.dosage}
    maxLength="6"
  />
)}

                              {/* existing */}
                              {/* {editMedicine.medicinetype == "Tablet" || editMedicine.medicinetype == "Capsule" ?
                                (
                                <MiniDropdownInput
                                      variant="bothSide"
                                      options={[
                                        { label: "mg", value: "mg" },
                                        { label: "mcg", value: "mcg" },
                                        { label: "g", value: "g" },
                                      ]}
                                      // placeholderProp="Dosage"
                                      placeholderProp={
                                        editMedicine.medicinetype == "Syrup" ||
                                        editMedicine.medicinetype == "Drops" ||
                                        editMedicine.medicinetype == "Injection" ||
                                        editMedicine.medicinetype == "Nebulization" ||
                                        editMedicine.medicinetype == "Inhaler" ||
                                        editMedicine.medicinetype == "IVFluids"
                                          ? "Volume"
                                          : "Strength"
                                      }
                                      defaultValue={editMedicine.dosage}
                                      defaultOptionProp={editMedicine.dosageunit}
                                      onSelect={(value) =>
                                        handleEditMedicineChange(
                                          "dosageunit",
                                          value.label
                                        )
                                      }
                                      // changes here
                                      handleInputChange={(event) =>
                                        handleEditMedicineChange(
                                          "dosage",
                                          // event.target.value
                                          validationOfNumberWithOnly1Decimal(
                                            event.target.value
                                          )
                                        )
                                      }
                                      inputVal={editMedicine.dosage}
                                      maxLength="6"
                                    />
                              ): editMedicine.medicinetype === "Inhaler" ? (
                                <MiniDropdownInput
                                      variant="bothSide"
                                      options={[
                                        { label: "puffs", value: "puffs" },
                                        { label: "ml", value: "ml" },
                                      ]}
                                      // placeholderProp="Dosage"
                                      placeholderProp={
                                        editMedicine.medicinetype == "Syrup" ||
                                        editMedicine.medicinetype == "Drops" ||
                                        editMedicine.medicinetype == "Injection" ||
                                        editMedicine.medicinetype == "Nebulization" ||
                                        editMedicine.medicinetype == "Inhaler" ||
                                        editMedicine.medicinetype == "IVFluids"
                                          ? "Volume"
                                          : "Strength"
                                      }
                                      defaultValue={editMedicine.dosage}
                                      defaultOptionProp={editMedicine.dosageunit}
                                      onSelect={(value) =>
                                        handleEditMedicineChange(
                                          "dosageunit",
                                          value.label
                                        )
                                      }
                                      // changes here
                                      handleInputChange={(event) =>
                                        handleEditMedicineChange(
                                          "dosage",
                                          // event.target.value
                                          validationOfNumberWithOnly1Decimal(
                                            event.target.value
                                          )
                                        )
                                      }
                                      inputVal={editMedicine.dosage}
                                      maxLength="6"
                                    />
                              ) : editMedicine.medicinetype === "Ointment" ? (
                                <MiniDropdownInput
                                      variant="bothSide"
                                      options={[
                                        { label: "mg", value: "mg" },
                                        { label: "ml", value: "ml" },
                                        { label: "grms", value: "grms" },
                                      ]}
                                      // placeholderProp="Dosage"
                                      placeholderProp={
                                        editMedicine.medicinetype == "Syrup" ||
                                        editMedicine.medicinetype == "Drops" ||
                                        editMedicine.medicinetype == "Injection" ||
                                        editMedicine.medicinetype == "Nebulization" ||
                                        editMedicine.medicinetype == "Inhaler" ||
                                        editMedicine.medicinetype == "IVFluids"
                                          ? "Volume"
                                          : "Strength"
                                      }
                                      defaultValue={editMedicine.dosage}
                                      defaultOptionProp={editMedicine.dosageunit}
                                      onSelect={(value) =>
                                        handleEditMedicineChange(
                                          "dosageunit",
                                          value.label
                                        )
                                      }
                                      // changes here
                                      handleInputChange={(event) =>
                                        handleEditMedicineChange(
                                          "dosage",
                                          // event.target.value
                                          validationOfNumberWithOnly1Decimal(
                                            event.target.value
                                          )
                                        )
                                      }
                                      inputVal={editMedicine.dosage}
                                      maxLength="6"
                                    />
                              ) : (
                                <MiniDropdownInput
                                      variant="bothSide"
                                      options={[
                                        { label: "ml", value: "ml" },
                                      ]}
                                      // placeholderProp="Dosage"
                                      placeholderProp={
                                        editMedicine.medicinetype == "Syrup" ||
                                        editMedicine.medicinetype == "Drops" ||
                                        editMedicine.medicinetype == "Injection" ||
                                        editMedicine.medicinetype == "Nebulization" ||
                                        editMedicine.medicinetype == "Inhaler" ||
                                        editMedicine.medicinetype == "IVFluids"
                                          ? "Volume"
                                          : "Strength"
                                      }
                                      defaultValue={editMedicine.dosage}
                                      defaultOptionProp={editMedicine.dosageunit}
                                      onSelect={(value) =>
                                        handleEditMedicineChange(
                                          "dosageunit",
                                          value.label
                                        )
                                      }
                                      // changes here
                                      handleInputChange={(event) =>
                                        handleEditMedicineChange(
                                          "dosage",
                                          // event.target.value
                                          validationOfNumberWithOnly1Decimal(
                                            event.target.value
                                          )
                                        )
                                      }
                                      inputVal={editMedicine.dosage}
                                      maxLength="6"
                                    />
                              )} */}
                            </Box>
                            <Box>
                              <DropdownInput
                                variant="bothSide"
                                dropDownPlace="Qty"
                                options={["0.5", "1", "2", "3", "4"]}
                                onClick={(value) =>
                                  handleEditMedicineChange("frequency", value)
                                }
                                // defaultOption={editMedicine.frequency}
                                value={editMedicine.frequency}
                              />
                            </Box>
                              <Box >
                                <DropdownInput
                                  variant="bothSide"
                                  dropDownPlace={
                                    editMedicine.medicinetype === "IVFluids"
                                      ? "Infusion Frequency"
                                      : editMedicine.medicinetype === "Ointment"
                                      ? "Application Duration"
                                      : "Duration"
                                  }
                                  options={["Days", "Weeks", "Months", "Years"]} // Interval units as options
                                  // onClick={handleIntervalChange} 
                                  // defaultOption={intervalOption}
                                  onClick={handleIntervalChange}
                                  value={editMedicine.durationunit}
                                />
                              </Box>
                              <Box >
                                <PrimaryInput
                                  variant={"bothSide"}
                                  inputType="number"
                                  // defaultValue={intervalValue}
                                  // onChange={handleIntervalValueChange}
                                  inputValue={editMedicine.durationvalue} // Controlled input
                                  onChange={handleIntervalValueChange}
                                  inputPlace={
                                    editMedicine.medicinetype === "IVFluids"
                                      ? "Infusion Duration"
                                      : "Interval Value"
                                  }
                                />
                              </Box>
                                <Box  display="flex" flexDir="row">
                                  <DatePicker
                                    dateWidth="50%"
                                    defaultDate={editMedicine.medicationstartdate}
                                    // minDate={newMedicine.medicationstartdate}
                                    // minDate={moment().format("DD-MM-YYYY")}
                                    onDateChange={(selectedDateValue) =>
                                      handleEditMedicineChange(
                                        "medicationstartdate",
                                        selectedDateValue
                                      )
                                    }
                                    placeholderProp={"Start Date"}
                                    calendarStlye={{
                                      left: "-18px",
                                      right: "unset",
                                    }}
                                  />
                                  <DatePicker
                                    dateWidth="50%"
                                    key={editMedicine.medicationenddate}
                                    defaultDate={editMedicine.medicationenddate}
                                    disableDatePicker={true}
                                    // minDate={newMedicine.medicationstartdate}
                                    onDateChange={(selectedDateValue) =>
                                      handleEditMedicineChange(
                                        "medicationenddate",
                                        selectedDateValue
                                      )
                                    }
                                    placeholderProp={"End Date"}
                                    calendarStlye={{
                                      transform: "scale(0.9)",
                                      right: "-22px",
                                      top: "30px",
                                      pointerEvents: "none", // Disable interaction
                                      opacity: 0.5, // Visually indicate disabled state
                                    }}
                                  />
                                </Box>
                            </Box>
                            <Box display="flex" flexDir="row">
                              {editMedicine.medicinetype == "Injection" && (
                                <>
                                  <Box width={"50%"}>
                                    <DropdownInput
                                      variant="downSide"
                                      dropDownPlace="Route of Administration"
                                      options={[
                                        "Intravenous (IV)",
                                        "Intramuscular (IM)",
                                        "Subcutaneous (SC)",
                                      ]}
                                      onClick={(value) =>
                                        handleEditMedicineChange(
                                          "routeofadministration",
                                          value
                                        )
                                      }
                                      defaultOption={
                                        editMedicine.routeofadministration
                                      }
                                    />
                                  </Box>
                                  <Box width={"50%"}>
                                    <PrimaryInput
                                      variant={"bothSide"}
                                      onChange={(e) =>
                                        handleEditMedicineChange(
                                          "timingofinjection",
                                          e.target.value
                                        )
                                      }
                                      inputPlace="Timing"
                                      defaultValue={
                                        editMedicine.timingofinjection
                                      }
                                    />
                                  </Box>
                                </>
                              )}
                              {editMedicine.medicinetype == "Ointment" && (
                                <>
                                  <DropdownInput
                                    variant="downSide"
                                    dropDownPlace="Quantity"
                                    options={[
                                      "Pea-sized",
                                      "Thin layer",
                                      "Fingertip unit (FTU)",
                                      "Half a fingertip",
                                    ]}
                                    onClick={(value) =>
                                      handleEditMedicineChange(
                                        "quantitytobeapplied",
                                        value
                                      )
                                    }
                                    defaultOption={
                                      editMedicine.quantitytobeapplied
                                    }
                                  />
                                  <PrimaryInput
                                    variant={"bothSide"}
                                    onChange={(e) =>
                                      handleEditMedicineChange(
                                        "areaofapplication",
                                        e.target.value
                                      )
                                    }
                                    inputPlace="Area of Application"
                                    defaultValue={
                                      editMedicine.areaofapplication
                                    }
                                  />
                                </>
                              )}

                              {editMedicine.medicinetype == "Nebulization" && (
                                <>
                                  <DropdownInput
                                    variant="downSide"
                                    dropDownPlace="Diluent"
                                    options={[
                                      "Normal saline",
                                      "Distilled water",
                                      "3% saline",
                                    ]}
                                    onClick={(value) =>
                                      handleEditMedicineChange("diluent", value)
                                    }
                                    defaultOption={editMedicine.diluent}
                                  />
                                </>
                              )}

                              {editMedicine.medicinetype == "IVFluids" && (
                                <>
                                  <MiniDropdownInput
                                    variant="bothside"
                                    options={[
                                      { label: "ml/hr", value: "ml/hr" },
                                      { label: "ml/min", value: "ml/min" },
                                      // { label: "mg/hr", value: "mg/hr" },
                                      // { label: "grms/hr", value: "grms/hr" },
                                    ]}
                                    handleInputChange={(e) =>
                                      handleEditMedicineChange(
                                        "rateofinfusionvalue",
                                        validationOfNumberWithOnly1Decimal(
                                          e.target.value
                                        )
                                      )
                                    }
                                    placeholderProp={"Rate of Infusion"}
                                    onSelect={(selectedOption) =>
                                      handleEditMedicineChange(
                                        "rateofinfusionunit",
                                        selectedOption.label
                                      )
                                    }
                                    maxLength="6"
                                    defaultOptionProp={
                                      editMedicine.rateofinfusionunit
                                    }
                                    defaultValue={
                                      editMedicine.rateofinfusionvalue
                                    }
                                  />
                                  <PrimaryInput
                                    variant={"bothSide"}
                                    onChange={(e) =>
                                      handleEditMedicineChange(
                                        "additives",
                                        e.target.value
                                      )
                                    }
                                    inputPlace="Additives"
                                    defaultValue={editMedicine.additives}
                                  />
                                </>
                              )}
                            </Box>

                            <CheckboxGroup colorScheme="green">
                              <Stack spacing={2} alignItems='center' pt="20px" direction="row" flexWrap="wrap">
                                {/* Time checkboxes */}
                                <Checkbox
                                  isChecked={editMedicine.morning === 1}
                                  onChange={() => {
                                    // Uncheck frequency inputs when checking a time checkbox
                                    if (editMedicine.morning !== 1) {
                                      handleEditMedicineChange("frequencytime", "");
                                      handleEditMedicineChange("frequencyvalue", "");
                                    }
                                    handleEditMedicineChange(
                                      "morning",
                                      editMedicine.morning === 1 ? 0 : 1
                                    );
                                  }}
                                >
                                  Morning
                                </Checkbox>
                                
                                <Checkbox
                                  isChecked={editMedicine.afternoon === 1}
                                  onChange={() => {
                                    // Uncheck frequency inputs when checking a time checkbox
                                    if (editMedicine.afternoon !== 1) {
                                      handleEditMedicineChange("frequencytime", "");
                                      handleEditMedicineChange("frequencyvalue", "");
                                    }
                                    handleEditMedicineChange(
                                      "afternoon",
                                      editMedicine.afternoon === 1 ? 0 : 1
                                    );
                                  }}
                                >
                                  Afternoon
                                </Checkbox>
                                
                                <Checkbox
                                  isChecked={editMedicine.night === 1}
                                  onChange={() => {
                                    // Uncheck frequency inputs when checking a time checkbox
                                    if (editMedicine.night !== 1) {
                                      handleEditMedicineChange("frequencytime", "");
                                      handleEditMedicineChange("frequencyvalue", "");
                                    }
                                    handleEditMedicineChange(
                                      "night",
                                      editMedicine.night === 1 ? 0 : 1
                                    );
                                  }}
                                >
                                  Night
                                </Checkbox>

                                <Text fontWeight='600' whiteSpace='nowrap'>- Or -</Text>

                                {/* Frequency inputs */}
                                <Box display='flex'>
                                <Box width='120px'>
                                  <DropdownInput
                                    variant="bothSide"
                                    dropDownPlace="Frequency"
                                    arrowCSS={{pr:0}}
                                    options={["Hours", "Daily", "Weekly"]}
                                    onClick={(value) => {
                                      // Uncheck time checkboxes when selecting frequency
                                      if (value) {
                                        handleEditMedicineChange("morning", 0);
                                        handleEditMedicineChange("afternoon", 0);
                                        handleEditMedicineChange("night", 0);
                                      }
                                      handleEditMedicineChange("frequencytime", value || 0);
                                    }}
                                    // defaultOption={"Hours"}
                                    value={editMedicine.frequencytime}
                                  />
                                </Box>

                                <Box width='70px'>
                                  <DropdownInputForVitals
                                    variant="bothSide"
                                    dropDownPlace="Value"
                                    arrowCSS={{pr:0}}
                                    readOnly=""
                                    options={["1", "2", "3", "4", "8"]}
                                    onClick={(value) => {
                                      // Uncheck time checkboxes when selecting value
                                      if (value) {
                                        handleEditMedicineChange("morning", 0);
                                        handleEditMedicineChange("afternoon", 0);
                                        handleEditMedicineChange("night", 0);
                                        handleEditMedicineChange("frequencyvalue", value);
                                      }
                                    }}
                                    onChange={(e) => {
                                      // Handle manual text input for value
                                      const value = e.target.value;
                                      if (value) {
                                        handleEditMedicineChange("morning", 0);
                                        handleEditMedicineChange("afternoon", 0);
                                        handleEditMedicineChange("night", 0);
                                      }
                                      handleEditMedicineChange("frequencyvalue", value);
                                    }}
                                    value={editMedicine.frequencyvalue}
                                    inputValueProp={editMedicine.frequencyvalue || ""}
                                    maxLength={2}
                                  />
                                  {/* <DropdownInput
                                    variant="bothSide"
                                    dropDownPlace="Value"
                                    options={["1", "2", "3", "4", "8"]}
                                    onClick={(value) => {
                                      // Uncheck time checkboxes when selecting value
                                      if (value) {
                                        handleEditMedicineChange("morning", 0);
                                        handleEditMedicineChange("afternoon", 0);
                                        handleEditMedicineChange("night", 0);
                                      }
                                      handleEditMedicineChange("frequencyvalue", value || "");
                                    }}
                                    onChange={(e) => {
                                      // Handle manual text input for value
                                      const value = e.target.value;
                                      if (value) {
                                        handleEditMedicineChange("morning", 0);
                                        handleEditMedicineChange("afternoon", 0);
                                        handleEditMedicineChange("night", 0);
                                      }
                                      handleEditMedicineChange("frequencyvalue", value || "");
                                    }}
                                    value={editMedicine.frequencyvalue}
                                  /> */}
                                </Box>
                                </Box>
                                {/* OLD FOOD TIMING RADIO BUTTONS - COMMENTED OUT FOR TOPICAL SUPPORT */}
                                {/* <Spacer/>
                                <RadioGroup
                                  value={editMedicine && editMedicine.beforefood === 1 ? "beforefood" : "afterfood"}
                                  display='flex'
                                  justifyItems='start'
                                  flexWrap='wrap'
                                  gap='0.5rem'
                                  onChange={(value) => {
                                    if (value === "beforefood") {
                                      handleEditMedicineChange("beforefood", 1);
                                      handleEditMedicineChange("afterfood", 0);
                                    } else if (value === "afterfood") {
                                      handleEditMedicineChange("beforefood", 0);
                                      handleEditMedicineChange("afterfood", 1);
                                    }
                                  }}
                                >
                                  <Radio value="beforefood" colorScheme="green">Before Food</Radio>
                                  <Radio value="afterfood" colorScheme="green">After Food</Radio>
                                </RadioGroup>
                                END OLD FOOD RADIOS */}

                                {/* CONDITIONAL TIMING: TOPICAL VS FOOD */}
                                <Spacer/>
                                {(editMedicine?.medicinetype === "Cream" || editMedicine?.medicinetype === "Ointment") ? (
                                  <Box>
                                    <Text fontSize="sm" mb={1}>Application Timing</Text>
                                    <RadioGroup
                                      value={editMedicine.timing || ""}
                                      display='flex'
                                      flexWrap='wrap'
                                      gap='0.5rem'
                                      onChange={(value) => {
                                        handleEditMedicineChange("timing", value);
                                        handleEditMedicineChange("beforefood", 0);
                                        handleEditMedicineChange("afterfood", 0);
                                      }}
                                    >
                                      <Radio value="After Bath" colorScheme="green">After Bath</Radio>
                                      <Radio value="Before Bath" colorScheme="green">Before Bath</Radio>
                                      <Radio value="After Sun" colorScheme="green">After Sun</Radio>
                                      <Radio value="Before Sun" colorScheme="green">Before Sun</Radio>
                                      <Radio value="Time-based" colorScheme="green">Time-based</Radio>
                                    </RadioGroup>

                                    <Box mt={2}>
                                      <Text fontSize="sm" mb={1}>Where to Apply</Text>
                                      <RadioGroup
                                        value={editMedicine.areaofapplication || ""}
                                        display='flex'
                                        flexWrap='wrap'
                                        gap='0.5rem'
                                        onChange={(value) => handleEditMedicineChange("areaofapplication", value)}
                                      >
                                        <Radio value="On Scalp" colorScheme="green">On Scalp</Radio>
                                        <Radio value="On Skin" colorScheme="green">On Skin</Radio>
                                        <Radio value="On Wound" colorScheme="green">On Wound</Radio>
                                        <Radio value="On Hair" colorScheme="green">On Hair</Radio>
                                      </RadioGroup>
                                    </Box>
                                  </Box>
                                ) : (
                                  <RadioGroup
                                    value={editMedicine && editMedicine.beforefood === 1 ? "beforefood" : "afterfood"}
                                    display='flex'
                                    justifyItems='start'
                                    flexWrap='wrap'
                                    gap='0.5rem'
                                    onChange={(value) => {
                                      if (value === "beforefood") {
                                        handleEditMedicineChange("beforefood", 1);
                                        handleEditMedicineChange("afterfood", 0);
                                        handleEditMedicineChange("timing", "Before Food");
                                      } else if (value === "afterfood") {
                                        handleEditMedicineChange("beforefood", 0);
                                        handleEditMedicineChange("afterfood", 1);
                                        handleEditMedicineChange("timing", "After Food");
                                      }
                                    }}
                                  >
                                    <Radio value="beforefood" colorScheme="green">Before Food</Radio>
                                    <Radio value="afterfood" colorScheme="green">After Food</Radio>
                                  </RadioGroup>
                                )}
                              </Stack>
                            </CheckboxGroup>

                            <Divider my="10px" />

                            {/* <PrimaryInput
                              variant={"bothSide"}
                              onChange={(e) => handleEditMedicineChange("sos", e.target.value )}
                              // defaultValue={editMedicine.sos}
                              inputPlace="SOS"
                              inputValue={editMedicine.sos}
                              
                            /> */}
                            {/* <Textarea
                              borderRadius='0'
                              placeholder="Instructions"
                              defaultValue={editMedicine.custommessage}
                              // onChange={handleCustomMessage}
                              onChange={(e) => handleEditMedicineChange("custommessage", e.target.value )}
                              inputValue={editMedicine.custommessage}
                            /> */}


                            <Box position='relative' display='flex' alignItems='flex-end' flexDirection='row'>
  <Box
    as="form"
    width='100%'
    bg="white"
    pt={"2px"}
  >
    <Box flex="1" width="100%" position="relative" bg={"#f9fafb"}>
      {/* <Textarea
        borderRadius='0'
        {...register("textField")}
        defaultValue={editMedicine.custommessage}
        inputValue={editMedicine.custommessage}
        onChange={(e) => {
          handleEditMedicineChange("custommessage", e.target.value);
          // Also update the form field
          setValue("textField", e.target.value, {
            shouldDirty: true,
            shouldTouch: true,
            shouldValidate: true,
          });
        }}
        height="100%"
        padding="2"
        resize="none"
        style={{ overflowWrap: "break-word", whiteSpace: "pre-wrap" }}
      /> */}
      <Textarea
        borderRadius='0'
        value={editMedicine.custommessage || ''}
        onChange={(e) => {
          // Update both state and form value
          setEditMedicine(prev => ({
            ...prev,
            custommessage: e.target.value
          }));
          setValue("textField", e.target.value);
        }}
        height="100%"
        padding="2"
        resize="none"
        style={{ overflowWrap: "break-word", whiteSpace: "pre-wrap" }}
      />
      
      {!editMedicine.custommessage && (
        <Text
          position="absolute"
          bottom="2"
          left="50%"
          transform="translateX(-50%)"
          fontSize="sm"
          color="gray.500"
          w={{ base: "100%", md: "unset" }}
          textAlign={{ base: "center", md: "unset" }}
        >
          {placeholder}
        </Text>
      )}
    </Box>
    
  </Box>

  <GPUChatAudioManagerSpeechMode
      transcriber={activeTranscriber}
      setPlaceholder={setPlaceholder}
      setTyping={setTyping}
      mode={mode}
      onTranscribedText={(text) => {

        setEditMedicine(prev => ({
      ...(prev || {}),
      custommessage: text
    }));
    setValue("textField", text);
  }}
      // Update both state and form value when recording
    //   setEditMedicine(prev => ({
    //     ...prev,
    //     // custommessage: text
    //     custommessage: (prev.custommessage || "") + text
    //   }));
    //   // setValue("textField", text);
    //   setValue("textField", (editMedicine.custommessage || "") + text);
    // }}
    />
    <Box
      as="button"
      type="button"
      border="1px solid #E6E7E9"
      borderRadius="full"
      w="36px"
      h="auto"
      p="10px"
      mr='10px'
      display="flex"
      justifyContent="center"
      alignItems="center"
      cursor={textFieldValue ? "pointer" : "not-allowed"}
      opacity={textFieldValue ? 1 : 0.5}
      pointerEvents={textFieldValue ? "auto" : "none"}
      onClick={() => textFieldValue && correctOrders("edit")}
    >
      <Image w="26px" src="/assets/svgs/ai-star-outline.svg" />
    </Box>
</Box>


                            <Divider my="10px" />
                          </Box>
                          {/* <Divider /> */}
                          <Box
                            display="flex"
                            justifyContent="flex-end"
                            gap="10px"
                          >
                            {/* <Button onClick={() => setEditMedicine(null)}>
                            Cancel
                          </Button> */}
                            <PrimaryButton
                              buttonText="Cancel"
                              variant="grayBtn"
                              btnStyle={{
                                // w: "15%",
                          w: "50%",
                                color: COLORS.PRIMARY_COLOR,
                                h: "2.5rem",
                              }}
                              // onClick={() => setEditMedicine(null)}
                              onClick={() => {
                                setEditMedicine(null)
                                editMedication.current.closeModal();
                              }}
                              isDisabled={false}
                            />
                            {/* <Button
                            colorScheme="blue"
                            onClick={handleSaveEditMedicine}
                          >
                            Save
                          </Button> */}
                            <PrimaryButton
                              buttonText="Save"
                              // onClick={handleSaveEditMedicine}
                              onClick={editmedicine}
                              isDisabled={false}
                              btnStyle={{
                                // w: "25%",
                          w: "50%",
                                //   color: COLORS.PRIMARY_COLOR,
                                h: "2.5rem",
                              }}
                            />
                          </Box>
                        </Stack>
                      </Box>
                    {/* )} */}
                  </Box>
                )}   
                  </>
                }
              />

    </>
  )
}

export default MedicationIndex;